
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("3WVxj", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $Asv1P = parcelRequire("Asv1P");


var $3654r = parcelRequire("3654r");


var $ee7An = parcelRequire("ee7An");


var $5nBzc = parcelRequire("5nBzc");


var $g9Srd = parcelRequire("g9Srd");

var $8DMug = parcelRequire("8DMug");


var $dh538 = parcelRequire("dh538");

parcelRequire("bpQ0v");
var $i93lZ = parcelRequire("i93lZ");
var $bpQ0v = parcelRequire("bpQ0v");


var $58wk0 = parcelRequire("58wk0");


var $8dG3J = parcelRequire("8dG3J");


var $kHF6o = parcelRequire("kHF6o");


var $4009b = parcelRequire("4009b");


var $lJT0z = parcelRequire("lJT0z");


var $jCd35 = parcelRequire("jCd35");

const $c7d700dd6b7beca2$var$textLinkCssVar = '--ds-ctl';
const $c7d700dd6b7beca2$var$textDefaultCssVar = '--ds-ct';
const $c7d700dd6b7beca2$var$textActiveCssVar = '--ds-ctp';
const $c7d700dd6b7beca2$var$backgroundHoverCssVar = '--ds-cbh';
const $c7d700dd6b7beca2$var$backgroundActiveCssVar = '--ds-cba';
var $c7d700dd6b7beca2$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($c7d700dd6b7beca2$var$TagStatus || {});
const $c7d700dd6b7beca2$var$packageName = "platform-pkg";
const $c7d700dd6b7beca2$var$packageVersion = "0.0.0-use.local";
const $c7d700dd6b7beca2$var$defaultBeforeRemoveAction = ()=>true; /**
                                               * These hide the focus ring for the tag when its remove button is focused,
                                               * preventing a double focus ring.
                                               */ 
const $c7d700dd6b7beca2$var$removingStyles = null;
const $c7d700dd6b7beca2$var$RemovableTagComponent = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(80);
    let appearance;
    let href;
    let linkComponent;
    let maxWidth;
    let migration_fallback;
    let removeButtonLabel;
    let rest;
    let swatchBefore;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let testId;
    if ($[0] !== t0) {
        ({ appearance: appearance, elemBefore: t1, isRemovable: t2, text: t3, color: t4, href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: t5, onAfterRemoveAction: t6, linkComponent: linkComponent, migration_fallback: migration_fallback, maxWidth: maxWidth, hasMargin: t7, swatchBefore: swatchBefore, ...rest } = t0);
        $[0] = t0;
        $[1] = appearance;
        $[2] = href;
        $[3] = linkComponent;
        $[4] = maxWidth;
        $[5] = migration_fallback;
        $[6] = removeButtonLabel;
        $[7] = rest;
        $[8] = swatchBefore;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
        $[15] = t7;
        $[16] = testId;
    } else {
        appearance = $[1];
        href = $[2];
        linkComponent = $[3];
        maxWidth = $[4];
        migration_fallback = $[5];
        removeButtonLabel = $[6];
        rest = $[7];
        swatchBefore = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        t4 = $[12];
        t5 = $[13];
        t6 = $[14];
        t7 = $[15];
        testId = $[16];
    }
    const elemBefore = t1 === undefined ? null : t1;
    const isRemovable = t2 === undefined ? true : t2;
    const text = t3 === undefined ? "" : t3;
    const color = t4 === undefined ? "standard" : t4;
    const onBeforeRemoveAction = t5 === undefined ? $c7d700dd6b7beca2$var$defaultBeforeRemoveAction : t5;
    const onAfterRemoveAction = t6 === undefined ? (0, $ee7An.default) : t6;
    const hasMargin = t7 === undefined ? true : t7;
    const [status, setStatus] = (0, $42omo.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $42omo.useState)(false);
    let t8;
    if ($[17] !== text) {
        t8 = (0, $58wk0.getTagText)(text);
        $[17] = text;
        $[18] = t8;
    } else t8 = $[18];
    const normalizedText = t8;
    let t9;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {
            action: "removed",
            actionSubject: "tag",
            attributes: {
                componentName: "tag",
                packageName: $c7d700dd6b7beca2$var$packageName,
                packageVersion: $c7d700dd6b7beca2$var$packageVersion
            }
        };
        $[19] = t9;
    } else t9 = $[19];
    const onAfterRemoveActionWithAnalytics = (0, $Asv1P.useCallbackWithAnalytics)(onAfterRemoveAction, t9, "atlaskit");
    let t10;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = ()=>{
            setStatus("removed");
        };
        $[20] = t10;
    } else t10 = $[20];
    const handleRemoveComplete = t10;
    let t11;
    if ($[21] !== normalizedText || $[22] !== onAfterRemoveActionWithAnalytics || $[23] !== onBeforeRemoveAction) {
        t11 = ()=>{
            if (onBeforeRemoveAction && onBeforeRemoveAction()) {
                onAfterRemoveActionWithAnalytics(normalizedText);
                handleRemoveComplete();
            }
        };
        $[21] = normalizedText;
        $[22] = onAfterRemoveActionWithAnalytics;
        $[23] = onBeforeRemoveAction;
        $[24] = t11;
    } else t11 = $[24];
    const handleRemoveRequest = t11;
    let t12;
    if ($[25] !== handleRemoveRequest) {
        t12 = (e)=>{
            const spacebarOrEnter = e.key === " " || e.key === "Enter";
            if (spacebarOrEnter) {
                e.stopPropagation();
                handleRemoveRequest();
            }
        };
        $[25] = handleRemoveRequest;
        $[26] = t12;
    } else t12 = $[26];
    const onKeyPress = t12;
    let t13;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = ()=>setStatus("removing");
        $[27] = t13;
    } else t13 = $[27];
    const removingTag = t13;
    let t14;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = ()=>setStatus("showing");
        $[28] = t14;
    } else t14 = $[28];
    const showingTag = t14;
    let t15;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = ()=>setIsHoverCloseButton(true);
        $[29] = t15;
    } else t15 = $[29];
    const handleMouseOver = t15;
    let t16;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = ()=>setIsHoverCloseButton(false);
        $[30] = t16;
    } else t16 = $[30];
    const handleMouseOut = t16;
    let t17;
    if ($[31] !== handleRemoveRequest || $[32] !== isRemovable || $[33] !== normalizedText || $[34] !== onKeyPress || $[35] !== removeButtonLabel || $[36] !== testId) {
        t17 = isRemovable ? /*#__PURE__*/ $42omo.createElement((0, $jCd35.default), {
            "aria-label": `${removeButtonLabel || "Remove"} ${normalizedText}`,
            onClick: handleRemoveRequest,
            onFocus: removingTag,
            onBlur: showingTag,
            onKeyPress: onKeyPress,
            onMouseOver: handleMouseOver,
            onMouseOut: handleMouseOut,
            testId: `close-button-${testId}`
        }) : undefined;
        $[31] = handleRemoveRequest;
        $[32] = isRemovable;
        $[33] = normalizedText;
        $[34] = onKeyPress;
        $[35] = removeButtonLabel;
        $[36] = testId;
        $[37] = t17;
    } else t17 = $[37];
    const removeButton = t17;
    if (migration_fallback === "lozenge" && !(0, $dh538.fg)("platform-dst-lozenge-tag-badge-visual-uplifts")) {
        let t18;
        if ($[38] !== color) {
            t18 = (0, $4009b.getLozengeAppearance)(color);
            $[38] = color;
            $[39] = t18;
        } else t18 = $[39];
        const lozengeAppearance = t18;
        let t19;
        if ($[40] !== lozengeAppearance || $[41] !== normalizedText || $[42] !== rest || $[43] !== testId) {
            t19 = /*#__PURE__*/ $42omo.createElement((0, $5nBzc.default), {
                appearance: lozengeAppearance,
                isBold: false,
                testId: testId,
                ...rest
            }, normalizedText);
            $[40] = lozengeAppearance;
            $[41] = normalizedText;
            $[42] = rest;
            $[43] = testId;
            $[44] = t19;
        } else t19 = $[44];
        return t19;
    }
    if ((0, $dh538.fg)("platform-dst-lozenge-tag-badge-visual-uplifts")) {
        const newColor = (0, $i93lZ.colorMapping)[color || "standard"];
        let t18;
        if ($[45] !== elemBefore || $[46] !== hasMargin || $[47] !== href || $[48] !== isRemovable || $[49] !== maxWidth || $[50] !== newColor || $[51] !== normalizedText || $[52] !== onAfterRemoveActionWithAnalytics || $[53] !== onBeforeRemoveAction || $[54] !== ref || $[55] !== removeButtonLabel || $[56] !== swatchBefore || $[57] !== testId) {
            t18 = /*#__PURE__*/ $42omo.createElement((0, $bpQ0v.default), {
                ref: ref,
                color: newColor,
                text: normalizedText,
                elemBefore: elemBefore,
                href: href,
                testId: testId,
                isRemovable: isRemovable,
                removeButtonLabel: removeButtonLabel,
                onBeforeRemoveAction: onBeforeRemoveAction,
                onAfterRemoveAction: onAfterRemoveActionWithAnalytics,
                maxWidth: maxWidth,
                hasMargin: hasMargin,
                swatchBefore: swatchBefore
            });
            $[45] = elemBefore;
            $[46] = hasMargin;
            $[47] = href;
            $[48] = isRemovable;
            $[49] = maxWidth;
            $[50] = newColor;
            $[51] = normalizedText;
            $[52] = onAfterRemoveActionWithAnalytics;
            $[53] = onBeforeRemoveAction;
            $[54] = ref;
            $[55] = removeButtonLabel;
            $[56] = swatchBefore;
            $[57] = testId;
            $[58] = t18;
        } else t18 = $[58];
        return t18;
    }
    let t18;
    if ($[59] !== color || $[60] !== elemBefore || $[61] !== href || $[62] !== isRemovable || $[63] !== linkComponent || $[64] !== normalizedText) {
        t18 = /*#__PURE__*/ $42omo.createElement((0, $lJT0z.default), {
            elemBefore: elemBefore,
            isRemovable: isRemovable,
            text: normalizedText,
            color: color,
            href: href,
            linkComponent: linkComponent
        });
        $[59] = color;
        $[60] = elemBefore;
        $[61] = href;
        $[62] = isRemovable;
        $[63] = linkComponent;
        $[64] = normalizedText;
        $[65] = t18;
    } else t18 = $[65];
    const content = t18;
    let t19;
    if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = {
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            [$c7d700dd6b7beca2$var$backgroundHoverCssVar]: undefined,
            [$c7d700dd6b7beca2$var$backgroundActiveCssVar]: undefined,
            [$c7d700dd6b7beca2$var$textDefaultCssVar]: undefined,
            [$c7d700dd6b7beca2$var$textActiveCssVar]: undefined,
            [$c7d700dd6b7beca2$var$textLinkCssVar]: undefined
        };
        $[66] = t19;
    } else t19 = $[66];
    const hoverCloseButtonColors = t19;
    let t20;
    if ($[67] !== appearance || $[68] !== color || $[69] !== content || $[70] !== elemBefore || $[71] !== href || $[72] !== isHoverCloseButton || $[73] !== ref || $[74] !== removeButton || $[75] !== status || $[76] !== testId) {
        t20 = !(status === "removed") && /*#__PURE__*/ $42omo.createElement((0, $8DMug.default), {
            key: "atlaskit-removable-tag-legacy-shrink-out",
            onFinish: handleRemoveComplete
        }, (motion)=>/*#__PURE__*/ $42omo.createElement((0, $8dG3J.default), {
                ref: (0, $3654r.default)([
                    motion.ref,
                    ref
                ]),
                appearance: appearance,
                color: color,
                testId: testId,
                style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
                "data-removable": true,
                "data-removing": status === "removing",
                "data-ishoverclosebutton": isHoverCloseButton,
                href: href,
                before: /*#__PURE__*/ $42omo.createElement((0, $kHF6o.default), {
                    elemBefore: elemBefore
                }),
                contentElement: content,
                after: removeButton,
                className: (0, $gMc0m.default)([
                    status === "removing" && "_z30c1r31 _twwiglyw _1pka1o36 _bqhtfiwo"
                ])
            }));
        $[67] = appearance;
        $[68] = color;
        $[69] = content;
        $[70] = elemBefore;
        $[71] = href;
        $[72] = isHoverCloseButton;
        $[73] = ref;
        $[74] = removeButton;
        $[75] = status;
        $[76] = testId;
        $[77] = t20;
    } else t20 = $[77];
    let t21;
    if ($[78] !== t20) {
        t21 = /*#__PURE__*/ $42omo.createElement((0, $g9Srd.default), null, t20);
        $[78] = t20;
        $[79] = t21;
    } else t21 = $[79];
    return t21;
} : ({ appearance: appearance, elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $c7d700dd6b7beca2$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $ee7An.default), linkComponent: linkComponent, migration_fallback: migration_fallback, maxWidth: maxWidth, hasMargin: hasMargin = true, swatchBefore: swatchBefore, ...rest }, ref)=>{
    const [status, setStatus] = (0, $42omo.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $42omo.useState)(false);
    const normalizedText = (0, $58wk0.getTagText)(text);
    const onAfterRemoveActionWithAnalytics = (0, $Asv1P.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $c7d700dd6b7beca2$var$packageName,
            packageVersion: $c7d700dd6b7beca2$var$packageVersion
        }
    }, 'atlaskit');
    const handleRemoveComplete = (0, $42omo.useCallback)(()=>{
        setStatus("removed");
    }, []);
    const handleRemoveRequest = (0, $42omo.useCallback)(()=>{
        if (onBeforeRemoveAction && onBeforeRemoveAction()) {
            onAfterRemoveActionWithAnalytics(normalizedText);
            handleRemoveComplete();
        }
    }, [
        handleRemoveComplete,
        normalizedText,
        onBeforeRemoveAction,
        onAfterRemoveActionWithAnalytics
    ]);
    const onKeyPress = (0, $42omo.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $42omo.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $42omo.useCallback)(()=>setStatus("showing"), []);
    const handleMouseOver = (0, $42omo.useCallback)(()=>setIsHoverCloseButton(true), []);
    const handleMouseOut = (0, $42omo.useCallback)(()=>setIsHoverCloseButton(false), []);
    const removeButton = isRemovable ? /*#__PURE__*/ $42omo.createElement((0, $jCd35.default), {
        "aria-label": `${removeButtonLabel || 'Remove'} ${normalizedText}`,
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: `close-button-${testId}`
    }) : undefined; // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const lozengeAppearance = (0, $4009b.getLozengeAppearance)(color);
        return /*#__PURE__*/ $42omo.createElement((0, $5nBzc.default), {
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId,
            ...rest
        }, normalizedText);
    } // Use new TagNew component behind feature flag
    // TagNew handles its own animation internally via RemovableWrapper
    if ((0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const newColor = (0, $i93lZ.colorMapping)[color || 'standard'];
        return /*#__PURE__*/ $42omo.createElement((0, $bpQ0v.default), {
            ref: ref,
            color: newColor,
            text: normalizedText,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: isRemovable,
            removeButtonLabel: removeButtonLabel,
            onBeforeRemoveAction: onBeforeRemoveAction,
            onAfterRemoveAction: onAfterRemoveActionWithAnalytics,
            maxWidth: maxWidth,
            hasMargin: hasMargin,
            swatchBefore: swatchBefore
        });
    } // Original implementation
    const content = /*#__PURE__*/ $42omo.createElement((0, $lJT0z.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: normalizedText,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    const hoverCloseButtonColors = {
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
        // Tag background color on hover
        [$c7d700dd6b7beca2$var$backgroundHoverCssVar]: undefined,
        // Tag background color on press
        [$c7d700dd6b7beca2$var$backgroundActiveCssVar]: undefined,
        // The tag text on hover of remove button
        [$c7d700dd6b7beca2$var$textDefaultCssVar]: undefined,
        // 'elemBefore' text on press of remove button
        [$c7d700dd6b7beca2$var$textActiveCssVar]: undefined,
        // The tag link text on hover of remove button
        [$c7d700dd6b7beca2$var$textLinkCssVar]: undefined
    };
    return /*#__PURE__*/ $42omo.createElement((0, $g9Srd.default), null, !(status === "removed") && /*#__PURE__*/ $42omo.createElement((0, $8DMug.default), {
        key: "atlaskit-removable-tag-legacy-shrink-out",
        onFinish: handleRemoveComplete
    }, (motion)=>{
        return /*#__PURE__*/ $42omo.createElement((0, $8dG3J.default), {
            ref: (0, $3654r.default)([
                motion.ref,
                ref
            ]),
            appearance: appearance,
            color: color,
            testId: testId,
            style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
            "data-removable": true,
            "data-removing": status === "removing",
            "data-ishoverclosebutton": isHoverCloseButton,
            href: href,
            before: /*#__PURE__*/ $42omo.createElement((0, $kHF6o.default), {
                elemBefore: elemBefore
            }),
            contentElement: content,
            after: removeButton,
            className: (0, $gMc0m.default)([
                status === "removing" && "_z30c1r31 _twwiglyw _1pka1o36 _bqhtfiwo"
            ])
        });
    }));
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ const $c7d700dd6b7beca2$var$RemovableTag = /*#__PURE__*/ (0, $42omo.memo)($c7d700dd6b7beca2$var$RemovableTagComponent);
var $c7d700dd6b7beca2$export$2e2bcd8739ae039 = $c7d700dd6b7beca2$var$RemovableTag;
module.exports["default"] = $c7d700dd6b7beca2$export$2e2bcd8739ae039;

});

parcelRegister("5nBzc", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");


var $1AXSe = parcelRequire("1AXSe");

const $dca450adfa76ae0a$var$styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhksm61",
    'bg.subtle.inprogress': "_bfhksm61",
    'bg.subtle.moved': "_bfhksm61",
    'bg.subtle.new': "_bfhksm61",
    'bg.subtle.removed': "_bfhksm61",
    'bg.subtle.success': "_bfhksm61",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syazi7uo",
    'text.bold': "_syazwwip"
};
const $dca450adfa76ae0a$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
const $dca450adfa76ae0a$var$newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
const $dca450adfa76ae0a$var$appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
const $dca450adfa76ae0a$var$LegacyLozenge = /*#__PURE__*/ (0, $42omo.memo)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(22);
    const { children: children, testId: testId, isBold: t1, appearance: t2, maxWidth: t3, style: style } = t0;
    const isBold = t1 === undefined ? false : t1;
    const appearance = t2 === undefined ? "default" : t2;
    const maxWidth = t3 === undefined ? 200 : t3;
    const appearanceStyle = isBold ? "bold" : "subtle";
    const appearanceType = $dca450adfa76ae0a$var$appearanceTypes.includes(appearance) || $dca450adfa76ae0a$var$newSemanticColors.includes(appearance) ? $dca450adfa76ae0a$var$appearanceMapping[appearance] : "default";
    const maxWidthValue = typeof maxWidth === "string" ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === "string" && /%$/.test(maxWidth);
    const t4 = style?.backgroundColor;
    const t5 = maxWidthIsPc ? maxWidth : "100%";
    let t6;
    if ($[0] !== t4 || $[1] !== t5) {
        t6 = {
            backgroundColor: t4,
            maxWidth: t5
        };
        $[0] = t4;
        $[1] = t5;
        $[2] = t6;
    } else t6 = $[2];
    const t7 = $dca450adfa76ae0a$var$styles[`bg.${appearanceStyle}.${appearanceType}`];
    const t8 = appearanceStyle === "subtle" && $dca450adfa76ae0a$var$styles[`outline.subtle.${appearanceType}`];
    const t9 = appearanceStyle === "subtle" && $dca450adfa76ae0a$var$styles.containerSubtle;
    let t10;
    if ($[3] !== t7 || $[4] !== t8 || $[5] !== t9) {
        t10 = (0, $gMc0m.default)([
            $dca450adfa76ae0a$var$styles.container,
            t7,
            t8,
            t9
        ]);
        $[3] = t7;
        $[4] = t8;
        $[5] = t9;
        $[6] = t10;
    } else t10 = $[6];
    const t11 = style?.color;
    const t12 = maxWidthIsPc ? "100%" : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`;
    let t13;
    if ($[7] !== t11 || $[8] !== t12) {
        t13 = {
            color: t11,
            maxWidth: t12
        };
        $[7] = t11;
        $[8] = t12;
        $[9] = t13;
    } else t13 = $[9];
    const t14 = testId && `${testId}--text`;
    let t15;
    if ($[10] !== appearanceStyle) {
        t15 = (0, $gMc0m.default)([
            $dca450adfa76ae0a$var$styles.text,
            (0, $dh538.fg)("platform-lozenge-custom-letterspacing") && $dca450adfa76ae0a$var$styles.customLetterspacing,
            $dca450adfa76ae0a$var$styles[`text.${appearanceStyle}`]
        ]);
        $[10] = appearanceStyle;
        $[11] = t15;
    } else t15 = $[11];
    let t16;
    if ($[12] !== children || $[13] !== t13 || $[14] !== t14 || $[15] !== t15) {
        t16 = /*#__PURE__*/ $42omo.createElement("span", {
            style: t13,
            "data-testid": t14,
            className: t15
        }, children);
        $[12] = children;
        $[13] = t13;
        $[14] = t14;
        $[15] = t15;
        $[16] = t16;
    } else t16 = $[16];
    let t17;
    if ($[17] !== t10 || $[18] !== t16 || $[19] !== t6 || $[20] !== testId) {
        t17 = /*#__PURE__*/ $42omo.createElement("span", {
            style: t6,
            "data-testid": testId,
            className: t10
        }, t16);
        $[17] = t10;
        $[18] = t16;
        $[19] = t6;
        $[20] = testId;
        $[21] = t17;
    } else t17 = $[21];
    return t17;
} : ({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = (0, $42omo.useMemo)(()=>$dca450adfa76ae0a$var$appearanceTypes.includes(appearance) || $dca450adfa76ae0a$var$newSemanticColors.includes(appearance) ? $dca450adfa76ae0a$var$appearanceMapping[appearance] : 'default', [
        appearance
    ]);
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ $42omo.createElement("span", {
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $dca450adfa76ae0a$var$styles.container,
            $dca450adfa76ae0a$var$styles[`bg.${appearanceStyle}.${appearanceType}`],
            appearanceStyle === 'subtle' && $dca450adfa76ae0a$var$styles[`outline.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && $dca450adfa76ae0a$var$styles.containerSubtle
        ])
    }, /*#__PURE__*/ $42omo.createElement("span", {
        style: {
            color: style?.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
        },
        "data-testid": testId && `${testId}--text`,
        className: (0, $gMc0m.default)([
            $dca450adfa76ae0a$var$styles.text,
            (0, $dh538.fg)('platform-lozenge-custom-letterspacing') && $dca450adfa76ae0a$var$styles.customLetterspacing,
            $dca450adfa76ae0a$var$styles[`text.${appearanceStyle}`]
        ])
    }, children));
});
$dca450adfa76ae0a$var$LegacyLozenge.displayName = 'Lozenge'; /**
                                        * Wrapper component that switches between old and new Lozenge based on feature flag
                                        */ 
const $dca450adfa76ae0a$var$LozengeWrapper = /*#__PURE__*/ (0, $42omo.memo)((0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(4);
    if ((0, $dh538.fg)("platform-dst-lozenge-tag-badge-visual-uplifts")) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ $42omo.createElement((0, $1AXSe.default), props);
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    const t0 = props;
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ $42omo.createElement($dca450adfa76ae0a$var$LegacyLozenge, t0);
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props)=>{
    if ((0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) return /*#__PURE__*/ $42omo.createElement((0, $1AXSe.default), props);
    return /*#__PURE__*/ $42omo.createElement($dca450adfa76ae0a$var$LegacyLozenge, props);
});
$dca450adfa76ae0a$var$LozengeWrapper.displayName = 'Lozenge';
var $dca450adfa76ae0a$export$2e2bcd8739ae039 = $dca450adfa76ae0a$var$LozengeWrapper;
module.exports["default"] = $dca450adfa76ae0a$export$2e2bcd8739ae039;

});

parcelRegister("1AXSe", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dKLHc = parcelRequire("dKLHc");

const $e50b8329b0553dbf$var$Lozenge = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { appearance: t1, spacing: t2, maxWidth: t3, style: style, testId: testId, children: children, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance } = t0;
    const appearance = t1 === undefined ? "neutral" : t1;
    const spacing = t2 === undefined ? "default" : t2;
    const maxWidth = t3 === undefined ? 200 : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== children || $[2] !== iconBefore || $[3] !== maxWidth || $[4] !== spacing || $[5] !== style || $[6] !== testId || $[7] !== trailingMetric || $[8] !== trailingMetricAppearance) {
        t4 = {
            appearance: appearance,
            spacing: spacing,
            iconBefore: iconBefore,
            trailingMetric: trailingMetric,
            trailingMetricAppearance: trailingMetricAppearance,
            maxWidth: maxWidth,
            style: style,
            testId: testId,
            children: children
        };
        $[0] = appearance;
        $[1] = children;
        $[2] = iconBefore;
        $[3] = maxWidth;
        $[4] = spacing;
        $[5] = style;
        $[6] = testId;
        $[7] = trailingMetric;
        $[8] = trailingMetricAppearance;
        $[9] = t4;
    } else t4 = $[9];
    const baseProps = t4;
    let t5;
    if ($[10] !== baseProps || $[11] !== children) {
        t5 = /*#__PURE__*/ $42omo.createElement((0, $dKLHc.default), baseProps, children);
        $[10] = baseProps;
        $[11] = children;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ appearance: appearance = 'neutral', spacing: spacing = 'default', maxWidth: maxWidth = 200, style: style, testId: testId, children: children, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance })=>{
    const baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ $42omo.createElement((0, $dKLHc.default), baseProps, children);
};
$e50b8329b0553dbf$var$Lozenge.displayName = 'Lozenge';
var $e50b8329b0553dbf$export$2e2bcd8739ae039 = $e50b8329b0553dbf$var$Lozenge;
module.exports["default"] = $e50b8329b0553dbf$export$2e2bcd8739ae039;

});

parcelRegister("ho4zm", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5nBzc = parcelRequire("5nBzc");


var $dh538 = parcelRequire("dh538");

parcelRequire("bpQ0v");
var $i93lZ = parcelRequire("i93lZ");
var $bpQ0v = parcelRequire("bpQ0v");


var $8dG3J = parcelRequire("8dG3J");


var $kHF6o = parcelRequire("kHF6o");


var $4009b = parcelRequire("4009b");


var $lJT0z = parcelRequire("lJT0z");

const $3067586e5fba1d9c$var$SimpleTagComponent = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(45);
    let appearance;
    let href;
    let linkComponent;
    let maxWidth;
    let migration_fallback;
    let rest;
    let swatchBefore;
    let t1;
    let t2;
    let t3;
    let testId;
    if ($[0] !== t0) {
        ({ appearance: appearance, elemBefore: t1, color: t2, href: href, testId: testId, text: t3, linkComponent: linkComponent, migration_fallback: migration_fallback, maxWidth: maxWidth, swatchBefore: swatchBefore, ...rest } = t0);
        $[0] = t0;
        $[1] = appearance;
        $[2] = href;
        $[3] = linkComponent;
        $[4] = maxWidth;
        $[5] = migration_fallback;
        $[6] = rest;
        $[7] = swatchBefore;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = testId;
    } else {
        appearance = $[1];
        href = $[2];
        linkComponent = $[3];
        maxWidth = $[4];
        migration_fallback = $[5];
        rest = $[6];
        swatchBefore = $[7];
        t1 = $[8];
        t2 = $[9];
        t3 = $[10];
        testId = $[11];
    }
    const elemBefore = t1 === undefined ? null : t1;
    const color = t2 === undefined ? "standard" : t2;
    const text = t3 === undefined ? "" : t3;
    if (migration_fallback === "lozenge" && !(0, $dh538.fg)("platform-dst-lozenge-tag-badge-visual-uplifts")) {
        let t4;
        if ($[12] !== color) {
            t4 = (0, $4009b.getLozengeAppearance)(color);
            $[12] = color;
            $[13] = t4;
        } else t4 = $[13];
        const lozengeAppearance = t4;
        let t5;
        if ($[14] !== lozengeAppearance || $[15] !== rest || $[16] !== testId || $[17] !== text) {
            t5 = /*#__PURE__*/ $42omo.createElement((0, $5nBzc.default), {
                appearance: lozengeAppearance,
                isBold: false,
                testId: testId,
                ...rest
            }, text);
            $[14] = lozengeAppearance;
            $[15] = rest;
            $[16] = testId;
            $[17] = text;
            $[18] = t5;
        } else t5 = $[18];
        return t5;
    }
    if ((0, $dh538.fg)("platform-dst-lozenge-tag-badge-visual-uplifts")) {
        const newColor = (0, $i93lZ.colorMapping)[color || "standard"];
        let t4;
        if ($[19] !== elemBefore || $[20] !== href || $[21] !== maxWidth || $[22] !== newColor || $[23] !== ref || $[24] !== swatchBefore || $[25] !== testId || $[26] !== text) {
            t4 = /*#__PURE__*/ $42omo.createElement((0, $bpQ0v.default), {
                ref: ref,
                color: newColor,
                text: text,
                elemBefore: elemBefore,
                href: href,
                testId: testId,
                isRemovable: false,
                maxWidth: maxWidth,
                swatchBefore: swatchBefore
            });
            $[19] = elemBefore;
            $[20] = href;
            $[21] = maxWidth;
            $[22] = newColor;
            $[23] = ref;
            $[24] = swatchBefore;
            $[25] = testId;
            $[26] = text;
            $[27] = t4;
        } else t4 = $[27];
        return t4;
    }
    let t4;
    if ($[28] !== color || $[29] !== elemBefore || $[30] !== href || $[31] !== linkComponent || $[32] !== testId || $[33] !== text) {
        t4 = /*#__PURE__*/ $42omo.createElement((0, $lJT0z.default), {
            elemBefore: elemBefore,
            isRemovable: false,
            text: text,
            color: color,
            href: href,
            linkComponent: linkComponent,
            testId: testId
        });
        $[28] = color;
        $[29] = elemBefore;
        $[30] = href;
        $[31] = linkComponent;
        $[32] = testId;
        $[33] = text;
        $[34] = t4;
    } else t4 = $[34];
    const content = t4;
    let t5;
    if ($[35] !== elemBefore) {
        t5 = /*#__PURE__*/ $42omo.createElement((0, $kHF6o.default), {
            elemBefore: elemBefore
        });
        $[35] = elemBefore;
        $[36] = t5;
    } else t5 = $[36];
    let t6;
    if ($[37] !== appearance || $[38] !== color || $[39] !== content || $[40] !== href || $[41] !== ref || $[42] !== t5 || $[43] !== testId) {
        t6 = /*#__PURE__*/ $42omo.createElement((0, $8dG3J.default), {
            ref: ref,
            testId: testId,
            href: href,
            appearance: appearance,
            color: color,
            before: t5,
            contentElement: content
        });
        $[37] = appearance;
        $[38] = color;
        $[39] = content;
        $[40] = href;
        $[41] = ref;
        $[42] = t5;
        $[43] = testId;
        $[44] = t6;
    } else t6 = $[44];
    return t6;
} : ({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent, migration_fallback: migration_fallback, maxWidth: maxWidth, swatchBefore: swatchBefore, ...rest }, ref)=>{
    // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const lozengeAppearance = (0, $4009b.getLozengeAppearance)(color);
        return /*#__PURE__*/ $42omo.createElement((0, $5nBzc.default), {
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId,
            ...rest
        }, text);
    } // Use new TagNew component behind feature flag
    if ((0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const newColor = (0, $i93lZ.colorMapping)[color || 'standard'];
        return /*#__PURE__*/ $42omo.createElement((0, $bpQ0v.default), {
            ref: ref,
            color: newColor,
            text: text,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: false,
            maxWidth: maxWidth,
            swatchBefore: swatchBefore
        });
    } // Original implementation
    const content = /*#__PURE__*/ $42omo.createElement((0, $lJT0z.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent,
        testId: testId
    });
    return /*#__PURE__*/ $42omo.createElement((0, $8dG3J.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ $42omo.createElement((0, $kHF6o.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $3067586e5fba1d9c$var$SimpleTag = /*#__PURE__*/ (0, $42omo.memo)($3067586e5fba1d9c$var$SimpleTagComponent);
var $3067586e5fba1d9c$export$2e2bcd8739ae039 = $3067586e5fba1d9c$var$SimpleTag;
module.exports["default"] = $3067586e5fba1d9c$export$2e2bcd8739ae039;

});

parcelRegister("9E7O8", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $dKLHc = parcelRequire("dKLHc");

const $6084a1e0074f6ec5$var$LozengeDropdownTrigger = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(23);
    const { children: children, testId: testId, appearance: t1, spacing: t2, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance, isSelected: t3, isLoading: t4, maxWidth: t5, onClick: t6, style: style, analyticsContext: analyticsContext, interactionName: interactionName, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHaspopup, "aria-label": ariaLabel } = t0;
    const appearance = t1 === undefined ? "neutral" : t1;
    const spacing = t2 === undefined ? "default" : t2;
    const isSelected = t3 === undefined ? false : t3;
    const isLoading = t4 === undefined ? false : t4;
    const maxWidth = t5 === undefined ? 200 : t5;
    const onClick = t6 === undefined ? (0, $ee7An.default) : t6;
    let t7;
    if ($[0] !== analyticsContext || $[1] !== appearance || $[2] !== ariaControls || $[3] !== ariaExpanded || $[4] !== ariaHaspopup || $[5] !== ariaLabel || $[6] !== children || $[7] !== iconBefore || $[8] !== interactionName || $[9] !== isLoading || $[10] !== isSelected || $[11] !== maxWidth || $[12] !== onClick || $[13] !== spacing || $[14] !== style || $[15] !== testId || $[16] !== trailingMetric || $[17] !== trailingMetricAppearance) {
        t7 = {
            appearance: appearance,
            spacing: spacing,
            iconBefore: iconBefore,
            trailingMetric: trailingMetric,
            trailingMetricAppearance: trailingMetricAppearance,
            isSelected: isSelected,
            isLoading: isLoading,
            maxWidth: maxWidth,
            style: style,
            testId: testId,
            onClick: onClick,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            children: children,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            "aria-label": ariaLabel
        };
        $[0] = analyticsContext;
        $[1] = appearance;
        $[2] = ariaControls;
        $[3] = ariaExpanded;
        $[4] = ariaHaspopup;
        $[5] = ariaLabel;
        $[6] = children;
        $[7] = iconBefore;
        $[8] = interactionName;
        $[9] = isLoading;
        $[10] = isSelected;
        $[11] = maxWidth;
        $[12] = onClick;
        $[13] = spacing;
        $[14] = style;
        $[15] = testId;
        $[16] = trailingMetric;
        $[17] = trailingMetricAppearance;
        $[18] = t7;
    } else t7 = $[18];
    const baseProps = t7;
    let t8;
    if ($[19] !== baseProps || $[20] !== children || $[21] !== ref) {
        t8 = /*#__PURE__*/ $42omo.createElement((0, $dKLHc.default), {
            ref: ref,
            ...baseProps
        }, children);
        $[19] = baseProps;
        $[20] = children;
        $[21] = ref;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
} : ({ children: children, testId: testId, appearance: appearance = 'neutral', spacing: spacing = 'default', iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance, isSelected: isSelected = false, isLoading: isLoading = false, maxWidth: maxWidth = 200, onClick: onClick = (0, $ee7An.default), style: style, analyticsContext: analyticsContext, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-label': ariaLabel }, ref)=>{
    const baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        isSelected: isSelected,
        isLoading: isLoading,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        onClick: onClick,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        children: children,
        'aria-controls': ariaControls,
        'aria-expanded': ariaExpanded,
        'aria-haspopup': ariaHaspopup,
        'aria-label': ariaLabel
    };
    return /*#__PURE__*/ $42omo.createElement((0, $dKLHc.default), {
        ref: ref,
        ...baseProps
    }, children);
}));
$6084a1e0074f6ec5$var$LozengeDropdownTrigger.displayName = 'LozengeDropdownTrigger';
var $6084a1e0074f6ec5$export$2e2bcd8739ae039 = $6084a1e0074f6ec5$var$LozengeDropdownTrigger;
module.exports["default"] = $6084a1e0074f6ec5$export$2e2bcd8739ae039;

});

parcelRegister("c4sKh", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");


var $iXCQx = parcelRequire("iXCQx");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $60bfccf6e32ff94f$export$d21bba0569254935 = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger',
    warning: 'warning',
    discovery: 'discovery',
    danger: 'danger',
    success: 'success',
    information: 'information',
    inverse: 'inverse',
    neutral: 'neutral',
    informationBold: 'informationBold',
    successBold: 'successBold',
    dangerBold: 'dangerBold',
    warningBold: 'warningBold',
    discoveryBold: 'discoveryBold'
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $76f3dfaa612f757b$export$16f8cc7ac3541e83 = {
    added: 'added',
    removed: 'removed',
    default: 'default',
    primary: 'primary',
    primaryInverted: 'primaryInverted',
    important: 'important',
    danger: 'removed',
    success: 'added',
    information: 'primary',
    inverse: 'primaryInverted',
    neutral: 'default',
    warning: 'default',
    discovery: 'default',
    informationBold: 'primary',
    successBold: 'added',
    dangerBold: 'removed',
    warningBold: 'default',
    discoveryBold: 'default'
};



var $8Cy4Y = parcelRequire("8Cy4Y");

function $efadd75cd5e085a3$var$getSafeValueWithNegativeSupport(value = 0) {
    const numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $efadd75cd5e085a3$export$4b844743568d5983(value, max) {
    const safeValue = $efadd75cd5e085a3$var$getSafeValueWithNegativeSupport(value);
    const safeMax = $efadd75cd5e085a3$var$getSafeValueWithNegativeSupport(max);
    let hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}


const $3633338e39044437$var$neutral300 = '#DDDEE1';
const $3633338e39044437$var$red300 = '#FD9891';
const $3633338e39044437$var$blue300 = '#8FB8F6';
const $3633338e39044437$var$neutral1000 = '#292A2E';
const $3633338e39044437$var$styles = {
    root: "_2rkolb4i _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhk1y9u _syazi7uo",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1oa5",
    removed: "_bfhk1gly _syazi7uo"
};
const $3633338e39044437$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    return typeof children === 'number' && typeof max === 'number' ? (0, $efadd75cd5e085a3$export$4b844743568d5983)(children, max) : children;
}; /**
    * __Badge__
    *
    * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
    *
    * - [Examples](https://atlassian.design/components/badge/examples)
    * - [Code](https://atlassian.design/components/badge/code)
    * - [Usage](https://atlassian.design/components/badge/usage)
    */ 
const $3633338e39044437$var$Badge = /*#__PURE__*/ (0, $42omo.memo)((0, $4pOgL.isReactCompilerActivePlatform)() ? function Badge(t0) {
    const $ = (0, $frIzR.c)(21);
    const { appearance: t1, children: t2, max: t3, style: style, testId: testId } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const children = t2 === undefined ? 0 : t2;
    const max = t3 === undefined ? 99 : t3;
    if ((0, $dh538.fg)("platform-dst-lozenge-tag-badge-visual-uplifts")) {
        const newAppearance = (0, $60bfccf6e32ff94f$export$d21bba0569254935)[appearance];
        let t4;
        if ($[0] !== children || $[1] !== max || $[2] !== newAppearance || $[3] !== style || $[4] !== testId) {
            t4 = /*#__PURE__*/ $42omo.createElement((0, $8Cy4Y.default), {
                appearance: newAppearance,
                max: max,
                style: style,
                testId: testId
            }, children);
            $[0] = children;
            $[1] = max;
            $[2] = newAppearance;
            $[3] = style;
            $[4] = testId;
            $[5] = t4;
        } else t4 = $[5];
        return t4;
    }
    const oldAppearance = (0, $76f3dfaa612f757b$export$16f8cc7ac3541e83)[appearance];
    const t4 = style?.backgroundColor;
    const t5 = style?.color;
    let t6;
    if ($[6] !== t4 || $[7] !== t5) {
        t6 = {
            background: t4,
            color: t5
        };
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    const t7 = $3633338e39044437$var$styles[oldAppearance];
    let t8;
    if ($[9] !== t7) {
        t8 = (0, $gMc0m.default)([
            $3633338e39044437$var$styles.root,
            t7
        ]);
        $[9] = t7;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] !== children || $[12] !== max) {
        t9 = $3633338e39044437$var$badgeValueWithNegativeNumberSupported(children, max);
        $[11] = children;
        $[12] = max;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== t9) {
        t10 = /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
            size: "small",
            align: "center",
            color: "inherit"
        }, t9);
        $[14] = t9;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== t10 || $[17] !== t6 || $[18] !== t8 || $[19] !== testId) {
        t11 = /*#__PURE__*/ $42omo.createElement("span", {
            "data-testid": testId,
            style: t6,
            className: t8
        }, t10);
        $[16] = t10;
        $[17] = t6;
        $[18] = t8;
        $[19] = testId;
        $[20] = t11;
    } else t11 = $[20];
    return t11;
} : function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        // Map old appearance names to new ones
        const newAppearance = (0, $60bfccf6e32ff94f$export$d21bba0569254935)[appearance];
        return /*#__PURE__*/ $42omo.createElement((0, $8Cy4Y.default), {
            appearance: newAppearance,
            max: max,
            style: style,
            testId: testId
        }, children);
    }
    const oldAppearance = (0, $76f3dfaa612f757b$export$16f8cc7ac3541e83)[appearance];
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": testId,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $gMc0m.default)([
            $3633338e39044437$var$styles.root,
            $3633338e39044437$var$styles[oldAppearance]
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $3633338e39044437$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $3633338e39044437$export$2e2bcd8739ae039 = $3633338e39044437$var$Badge;
module.exports["default"] = $3633338e39044437$export$2e2bcd8739ae039;

});

parcelRegister("4noo5", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $dh538 = parcelRequire("dh538");

const $934b3c00d8e6ad37$var$containerMedia = {
    invalid: "_msj6gir2",
    disabled: "_6up518qt"
};
const $934b3c00d8e6ad37$var$inputMediaDisabled = null;
const $934b3c00d8e6ad37$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $934b3c00d8e6ad37$var$disabledStyle = {
    standard: "_1h6d187o _bfhk187o _syaz1gmx _80om13gf",
    subtle: "_1h6d1j28 _bfhk1j28 _syaz1gmx _80om13gf",
    none: "_1h6d1j28 _bfhk1j28 _syaz1gmx _80om13gf"
};
const $934b3c00d8e6ad37$var$invalidStyle = null;
const $934b3c00d8e6ad37$var$focusWithinStyle = {
    standard: "_1p9x1v1w _qao9r01l _q433vyy1",
    subtle: "_1p9x1v1w _qao9r01l _q433vyy1",
    none: "_1p9x1j28 _qao91j28 _q4333sij"
};
const $934b3c00d8e6ad37$var$hoverStyle = {
    standard: "_4cvxrsbi _irr3l4ek",
    subtle: "_4cvxrsbi _irr3l4ek",
    none: "_4cvx1j28 _irr31j28"
};
const $934b3c00d8e6ad37$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6drsbi _1dqonqa1 _syazi7uo _80om1kdv _bfhk1j9a _msj6gir2",
    subtle: "_1h6d1j28 _1dqonqa1 _syazi7uo _80om1kdv _16hg1j28 _msj6gir2",
    none: "_1h6d1j28 _1dqoglyw _syazi7uo _80om1kdv _16hg1j28 _msj6gir2"
};
const $934b3c00d8e6ad37$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $934b3c00d8e6ad37$var$getMaxWidth = (width)=>!width ? `100%` : width in $934b3c00d8e6ad37$var$widthMap ? `${$934b3c00d8e6ad37$var$widthMap[width]}px` : `${+width}px`;
const $934b3c00d8e6ad37$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
const $934b3c00d8e6ad37$var$containerStyles = null;
const $934b3c00d8e6ad37$var$containerStylesT26Shape = null;
const $934b3c00d8e6ad37$var$inputDisabledStyle = null;
const $934b3c00d8e6ad37$var$inputCompactStyle = null;
const $934b3c00d8e6ad37$var$inputMonospacedStyle = null; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textfield uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $934b3c00d8e6ad37$var$inputStyle = null; /**
                          * __Textfield__
                          *
                          * A text field is an input that allows a user to write or edit text.
                          *
                          * - [Examples](https://atlassian.design/components/textfield/examples)
                          * - [Code](https://atlassian.design/components/textfield/code)
                          * - [Usage](https://atlassian.design/components/textfield/usage)
                          */ 
const $934b3c00d8e6ad37$var$Textfield = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $frIzR.c)(69);
    let className;
    let elemAfterInput;
    let elemBeforeInput;
    let name;
    let onBlur;
    let onChange;
    let onFocus;
    let onMouseDown;
    let placeholder;
    let spreadProps;
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let testId;
    let width;
    if ($[0] !== props) {
        ({ appearance: t0, className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: t1, isDisabled: t2, isInvalid: t3, isMonospaced: t4, isReadOnly: t5, isRequired: t6, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props);
        $[0] = props;
        $[1] = className;
        $[2] = elemAfterInput;
        $[3] = elemBeforeInput;
        $[4] = name;
        $[5] = onBlur;
        $[6] = onChange;
        $[7] = onFocus;
        $[8] = onMouseDown;
        $[9] = placeholder;
        $[10] = spreadProps;
        $[11] = t0;
        $[12] = t1;
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
        $[18] = testId;
        $[19] = width;
    } else {
        className = $[1];
        elemAfterInput = $[2];
        elemBeforeInput = $[3];
        name = $[4];
        onBlur = $[5];
        onChange = $[6];
        onFocus = $[7];
        onMouseDown = $[8];
        placeholder = $[9];
        spreadProps = $[10];
        t0 = $[11];
        t1 = $[12];
        t2 = $[13];
        t3 = $[14];
        t4 = $[15];
        t5 = $[16];
        t6 = $[17];
        testId = $[18];
        width = $[19];
    }
    const appearance = t0 === undefined ? "standard" : t0;
    const isCompact = t1 === undefined ? false : t1;
    const isDisabled = t2 === undefined ? false : t2;
    const isInvalid = t3 === undefined ? false : t3;
    const isMonospaced = t4 === undefined ? false : t4;
    const isReadOnly = t5 === undefined ? false : t5;
    const isRequired = t6 === undefined ? false : t6;
    const inputRef = (0, $42omo.useRef)(null);
    let t7;
    if ($[20] !== onFocus) {
        t7 = {
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: "focused",
            ...$934b3c00d8e6ad37$var$analyticsParams
        };
        $[20] = onFocus;
        $[21] = t7;
    } else t7 = $[21];
    const handleOnFocus = (0, $gxtzC.usePlatformLeafEventHandler)(t7);
    let t8;
    if ($[22] !== onBlur) {
        t8 = {
            fn: (event_0)=>{
                onBlur && onBlur(event_0);
            },
            action: "blurred",
            ...$934b3c00d8e6ad37$var$analyticsParams
        };
        $[22] = onBlur;
        $[23] = t8;
    } else t8 = $[23];
    const handleOnBlur = (0, $gxtzC.usePlatformLeafEventHandler)(t8);
    let t9;
    if ($[24] !== isDisabled || $[25] !== onMouseDown) {
        t9 = (event_1)=>{
            const target = event_1.target;
            if (target.tagName !== "INPUT") event_1.preventDefault();
            if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
            onMouseDown && onMouseDown(event_1);
        };
        $[24] = isDisabled;
        $[25] = onMouseDown;
        $[26] = t9;
    } else t9 = $[26];
    const handleOnMouseDown = t9;
    let t10;
    if ($[27] !== ref) {
        t10 = (inputElement)=>{
            inputRef.current = inputElement;
            if (!ref) return;
            if (typeof ref === "object") ref.current = inputElement;
            if (typeof ref === "function") ref(inputElement);
        };
        $[27] = ref;
        $[28] = t10;
    } else t10 = $[28];
    const setInputRef = t10;
    const t11 = isDisabled ? isDisabled : undefined;
    const t12 = isInvalid ? isInvalid : undefined;
    const t13 = testId && `${testId}-container`;
    let t14;
    if ($[29] !== width) {
        t14 = $934b3c00d8e6ad37$var$getMaxWidth(width);
        $[29] = width;
        $[30] = t14;
    } else t14 = $[30];
    const t15 = `${t14}`;
    let t16;
    if ($[31] !== t15) {
        t16 = {
            maxWidth: t15
        };
        $[31] = t15;
        $[32] = t16;
    } else t16 = $[32];
    let t17;
    if ($[33] !== appearance || $[34] !== className || $[35] !== isDisabled || $[36] !== isInvalid) {
        t17 = (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c8fhey _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnqfajl",
            (0, $dh538.fg)("platform-dst-shape-theme-default") && "_1tnq1qi0",
            $934b3c00d8e6ad37$var$getContainerTextBgAndBorderColor[appearance],
            $934b3c00d8e6ad37$var$containerStyleAppearance[appearance],
            !isDisabled && $934b3c00d8e6ad37$var$focusWithinStyle[appearance],
            !isDisabled && $934b3c00d8e6ad37$var$hoverStyle[appearance],
            isDisabled && $934b3c00d8e6ad37$var$containerMedia.disabled,
            isDisabled && $934b3c00d8e6ad37$var$disabledStyle[appearance],
            isInvalid && $934b3c00d8e6ad37$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _uk1sr01l",
            className
        ]);
        $[33] = appearance;
        $[34] = className;
        $[35] = isDisabled;
        $[36] = isInvalid;
        $[37] = t17;
    } else t17 = $[37];
    const t18 = isInvalid ? isInvalid : undefined;
    const t19 = isCompact ? isCompact : undefined;
    const t20 = isMonospaced ? isMonospaced : undefined;
    const t21 = isMonospaced && "_ect4zzfg _14mdzzfg";
    const t22 = isCompact && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7";
    const t23 = isDisabled && "_syaz1gmx _1idr1gmx";
    const t24 = isDisabled && "_1fnx18qt";
    let t25;
    if ($[38] !== t21 || $[39] !== t22 || $[40] !== t23 || $[41] !== t24) {
        t25 = (0, $gMc0m.default)([
            "_19itidpf _11c81d4k _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk1j28 _syaz1kw7 _80om1kw7 _14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr1rpy _1tn2fhey _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
            t21,
            t22,
            t23,
            t24
        ]);
        $[38] = t21;
        $[39] = t22;
        $[40] = t23;
        $[41] = t24;
        $[42] = t25;
    } else t25 = $[42];
    let t26;
    if ($[43] !== handleOnBlur || $[44] !== handleOnFocus || $[45] !== isDisabled || $[46] !== isReadOnly || $[47] !== isRequired || $[48] !== name || $[49] !== onChange || $[50] !== placeholder || $[51] !== setInputRef || $[52] !== spreadProps || $[53] !== t18 || $[54] !== t19 || $[55] !== t20 || $[56] !== t25 || $[57] !== testId) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
            ...spreadProps,
            "aria-invalid": t18,
            "data-compact": t19,
            "data-ds--text-field--input": true,
            "data-monospaced": t20,
            "data-testid": testId,
            disabled: isDisabled,
            name: name,
            onBlur: handleOnBlur,
            onChange: onChange,
            onFocus: handleOnFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: setInputRef,
            required: isRequired,
            className: t25
        });
        $[43] = handleOnBlur;
        $[44] = handleOnFocus;
        $[45] = isDisabled;
        $[46] = isReadOnly;
        $[47] = isRequired;
        $[48] = name;
        $[49] = onChange;
        $[50] = placeholder;
        $[51] = setInputRef;
        $[52] = spreadProps;
        $[53] = t18;
        $[54] = t19;
        $[55] = t20;
        $[56] = t25;
        $[57] = testId;
        $[58] = t26;
    } else t26 = $[58];
    let t27;
    if ($[59] !== elemAfterInput || $[60] !== elemBeforeInput || $[61] !== handleOnMouseDown || $[62] !== t11 || $[63] !== t12 || $[64] !== t13 || $[65] !== t16 || $[66] !== t17 || $[67] !== t26) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            role: "presentation",
            "data-disabled": t11,
            "data-invalid": t12,
            "data-ds--text-field--container": true,
            "data-testid": t13,
            onMouseDown: handleOnMouseDown,
            style: t16,
            className: t17
        }, elemBeforeInput, t26, elemAfterInput);
        $[59] = elemAfterInput;
        $[60] = elemBeforeInput;
        $[61] = handleOnMouseDown;
        $[62] = t11;
        $[63] = t12;
        $[64] = t13;
        $[65] = t16;
        $[66] = t17;
        $[67] = t26;
        $[68] = t27;
    } else t27 = $[68];
    return t27;
} : (props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $42omo.useRef)(null);
    const handleOnFocus = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$934b3c00d8e6ad37$var$analyticsParams
    });
    const handleOnBlur = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event_0)=>{
            onBlur && onBlur(event_0);
        },
        action: 'blurred',
        ...$934b3c00d8e6ad37$var$analyticsParams
    });
    const handleOnMouseDown = (0, $42omo.useCallback)((event_1)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event_1.target;
        if (target.tagName !== 'INPUT') event_1.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event_1);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $42omo.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: `${$934b3c00d8e6ad37$var$getMaxWidth(width)}`
        },
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c8fhey _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnqfajl",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_1tnq1qi0",
            $934b3c00d8e6ad37$var$getContainerTextBgAndBorderColor[appearance],
            $934b3c00d8e6ad37$var$containerStyleAppearance[appearance],
            !isDisabled && $934b3c00d8e6ad37$var$focusWithinStyle[appearance],
            !isDisabled && $934b3c00d8e6ad37$var$hoverStyle[appearance],
            isDisabled && $934b3c00d8e6ad37$var$containerMedia.disabled,
            isDisabled && $934b3c00d8e6ad37$var$disabledStyle[appearance],
            isInvalid && $934b3c00d8e6ad37$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _uk1sr01l",
            className
        ])
    }, elemBeforeInput, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired,
        className: (0, $gMc0m.default)([
            "_19itidpf _11c81d4k _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk1j28 _syaz1kw7 _80om1kw7 _14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr1rpy _1tn2fhey _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
            isMonospaced && "_ect4zzfg _14mdzzfg",
            isCompact && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7",
            isDisabled && "_syaz1gmx _1idr1gmx",
            isDisabled && "_1fnx18qt"
        ])
    }), elemAfterInput);
});
var $934b3c00d8e6ad37$export$2e2bcd8739ae039 = $934b3c00d8e6ad37$var$Textfield;
module.exports["default"] = $934b3c00d8e6ad37$export$2e2bcd8739ae039;

});

parcelRegister("aoVih", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1qfLF = parcelRequire("1qfLF");


var $cO1el = parcelRequire("cO1el");


var $hmuev = parcelRequire("hmuev");


var $dh538 = parcelRequire("dh538");


var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");











var $3gddQ = parcelRequire("3gddQ");


var $a3fRD = parcelRequire("a3fRD");


var $eXmBZ = parcelRequire("eXmBZ");


var $3sFtD = parcelRequire("3sFtD");


var $ebrpi = parcelRequire("ebrpi");

const $3cc44aa8b598788e$var$appearanceIconSchema = {
    information: {
        backgroundColor: "var(--ds-background-information, #E9F2FE)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))),
        primaryIconColor: "var(--ds-icon-information, #357DE8)"
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, #FFF5DB)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))),
        primaryIconColor: "var(--ds-icon-warning, #E06C00)"
    },
    error: {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))),
        primaryIconColor: "var(--ds-icon-danger, #C9372C)"
    },
    success: {
        backgroundColor: "var(--ds-background-success, #EFFFD6)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))),
        primaryIconColor: "var(--ds-icon-success, #6A9A23)"
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, #F8EEFE)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3gddQ))),
        primaryIconColor: "var(--ds-icon-discovery, #AF59E1)"
    }
};
function $3cc44aa8b598788e$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $3cc44aa8b598788e$var$appearanceIconSchema[appearance] || $3cc44aa8b598788e$var$appearanceIconSchema.information;
    const AppearanceIcon = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
        const $ = (0, $frIzR.c)(2);
        const { primaryColor: primaryColor } = t0;
        let t1;
        if ($[0] !== primaryColor) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(appearanceIconStyles.Icon, {
                color: primaryColor,
                spacing: "spacious",
                label: appearance
            });
            $[0] = primaryColor;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    } : ({ primaryColor: primaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(appearanceIconStyles.Icon, {
            color: primaryColor,
            spacing: "spacious",
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}


const $e50f000c6973458a$var$sectionMessageStyles = {
    container: "_2rko12b0 _1rjcpxbi _18zrpxbi _1nmz1hna",
    containerT26Shape: "_2rko1mok",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c8fhey _syazi7uo",
    actionsContainer: "_11c8fhey",
    dismissButtonContainer: "_1pfh1i6y"
};
const $e50f000c6973458a$var$appearanceStyles = {
    information: "_bfhk19ip",
    warning: "_bfhk1917",
    error: "_bfhk1gly",
    success: "_bfhk1y9u",
    discovery: "_bfhk6vm6"
}; /**
    * __Section message__
    *
    * A section message is used to alert users to a particular section of the screen.
    *
    * - [Examples](https://atlassian.design/components/section-message/examples)
    * - [Code](https://atlassian.design/components/section-message/code)
    * - [Usage](https://atlassian.design/components/section-message/usage)
    */ 
const $e50f000c6973458a$var$SectionMessage = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? function SectionMessage(t0, ref) {
    const $ = (0, $frIzR.c)(19);
    const { children: children, appearance: t1, actions: actions, title: title, headingLevel: t2, icon: icon, isDismissible: isDismissible, onDismiss: onDismiss, testId: testId } = t0;
    const appearance = t1 === undefined ? "information" : t1;
    const headingLevel = t2 === undefined ? "h2" : t2;
    const [dismissed, setDismissed] = (0, $42omo.useState)(false);
    let t3;
    if ($[0] !== onDismiss) {
        t3 = ()=>{
            onDismiss?.();
            setDismissed(true);
        };
        $[0] = onDismiss;
        $[1] = t3;
    } else t3 = $[1];
    const handleDismiss = t3;
    let t4;
    if ($[2] !== appearance || $[3] !== icon) {
        t4 = (0, $3cc44aa8b598788e$export$e9b82d2e21ac0c1f)(appearance, icon);
        $[2] = appearance;
        $[3] = icon;
        $[4] = t4;
    } else t4 = $[4];
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = t4;
    const actionElements = actions && actions.type === (0, $42omo.Fragment) ? actions.props.children : actions;
    let t5;
    if ($[5] !== Icon || $[6] !== actionElements || $[7] !== appearance || $[8] !== children || $[9] !== dismissed || $[10] !== handleDismiss || $[11] !== headingLevel || $[12] !== isDismissible || $[13] !== primaryColor || $[14] !== ref || $[15] !== secondaryColor || $[16] !== testId || $[17] !== title) {
        const actionsArray = (0, $42omo.Children).toArray(actionElements);
        t5 = isDismissible && dismissed ? null : /*#__PURE__*/ $42omo.createElement("section", {
            "data-testid": testId,
            ref: ref,
            className: (0, $gMc0m.default)([
                $e50f000c6973458a$var$sectionMessageStyles.container,
                (0, $dh538.fg)("platform-dst-shape-theme-default") && $e50f000c6973458a$var$sectionMessageStyles.containerT26Shape,
                $e50f000c6973458a$var$appearanceStyles[appearance]
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
            space: "space.200",
            alignBlock: "stretch"
        }, /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                $e50f000c6973458a$var$sectionMessageStyles.iconContainer
            ])
        }, /*#__PURE__*/ $42omo.createElement(Icon, {
            size: "medium",
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            color: primaryColor,
            spacing: "spacious"
        })), /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
            space: "space.100",
            testId: testId && `${testId}--content`,
            xcss: $e50f000c6973458a$var$sectionMessageStyles.contentContainer
        }, !!title && /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
            as: headingLevel,
            size: "small"
        }, title), /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                $e50f000c6973458a$var$sectionMessageStyles.content
            ])
        }, children), actionsArray.length > 0 && /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
            shouldWrap: true,
            testId: testId && `${testId}--actions`,
            separator: "\xB7",
            space: "space.100",
            rowSpace: "space.0",
            role: actionsArray.length > 1 ? "list" : undefined,
            xcss: $e50f000c6973458a$var$sectionMessageStyles.actionsContainer
        }, actionsArray.map((action, id)=>/*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
                role: actionsArray.length > 1 ? "listitem" : undefined,
                key: id
            }, action)))), isDismissible && /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                $e50f000c6973458a$var$sectionMessageStyles.dismissButtonContainer
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
            testId: testId && `${testId}--dismiss-button`,
            label: "Dismiss",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
            appearance: "subtle",
            onClick: handleDismiss,
            spacing: "compact"
        }))));
        $[5] = Icon;
        $[6] = actionElements;
        $[7] = appearance;
        $[8] = children;
        $[9] = dismissed;
        $[10] = handleDismiss;
        $[11] = headingLevel;
        $[12] = isDismissible;
        $[13] = primaryColor;
        $[14] = ref;
        $[15] = secondaryColor;
        $[16] = testId;
        $[17] = title;
        $[18] = t5;
    } else t5 = $[18];
    return t5;
} : function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, headingLevel: headingLevel = 'h2', icon: icon, isDismissible: isDismissible, onDismiss: onDismiss, testId: testId }, ref) {
    const [dismissed, setDismissed] = (0, $42omo.useState)(false);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        onDismiss?.();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $3cc44aa8b598788e$export$e9b82d2e21ac0c1f)(appearance, icon);
    const actionElements = actions && actions.type === (0, $42omo.Fragment) ? actions.props.children : actions;
    const actionsArray = (0, $42omo.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ $42omo.createElement("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $gMc0m.default)([
            $e50f000c6973458a$var$sectionMessageStyles.container,
            (0, $dh538.fg)('platform-dst-shape-theme-default') && $e50f000c6973458a$var$sectionMessageStyles.containerT26Shape,
            $e50f000c6973458a$var$appearanceStyles[appearance]
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $e50f000c6973458a$var$sectionMessageStyles.iconContainer
        ])
    }, /*#__PURE__*/ $42omo.createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        color: primaryColor,
        spacing: "spacious"
    })), /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
        space: "space.100",
        testId: testId && `${testId}--content`,
        xcss: $e50f000c6973458a$var$sectionMessageStyles.contentContainer
    }, !!title && /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
        as: headingLevel,
        size: "small"
    }, title), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $e50f000c6973458a$var$sectionMessageStyles.content
        ])
    }, children), actionsArray.length > 0 && /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        shouldWrap: true,
        testId: testId && `${testId}--actions`,
        separator: "\xb7",
        space: "space.100",
        rowSpace: "space.0",
        role: actionsArray.length > 1 ? 'list' : undefined,
        xcss: $e50f000c6973458a$var$sectionMessageStyles.actionsContainer
    }, actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
        /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
            role: actionsArray.length > 1 ? 'listitem' : undefined,
            key: id
        }, action)))), isDismissible && /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $e50f000c6973458a$var$sectionMessageStyles.dismissButtonContainer
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
        testId: testId && `${testId}--dismiss-button`,
        label: "Dismiss",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        appearance: "subtle",
        onClick: handleDismiss,
        spacing: "compact"
    }))));
});
$e50f000c6973458a$var$SectionMessage.displayName = 'SectionMessage';
var $e50f000c6973458a$export$2e2bcd8739ae039 = $e50f000c6973458a$var$SectionMessage;
module.exports["default"] = $e50f000c6973458a$export$2e2bcd8739ae039;

});

parcelRegister("abC4X", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $hArLp = parcelRequire("hArLp");


var $cO1el = parcelRequire("cO1el");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $9hlns = parcelRequire("9hlns");











var $gMc0m = parcelRequire("gMc0m");

const $b6ec5e063c3a7af6$var$actionsStyles = null; /**
                             * __Actions container__
                             *
                             * A container for actions: primary action, secondary action, and tertiary action.
                             *
                             * @internal
                             */ 
const $b6ec5e063c3a7af6$var$ActionsContainer = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _6rthu2gc _bozg1jfw"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _6rthu2gc _bozg1jfw"
        ])
    }, children);
var $b6ec5e063c3a7af6$export$2e2bcd8739ae039 = $b6ec5e063c3a7af6$var$ActionsContainer;














const $dc4c7d139f367f70$var$containerStyles = null; /* Use max-width so the component can shrink on smaller viewports. */ 
const $dc4c7d139f367f70$var$wideContainerStyles = null;
const $dc4c7d139f367f70$var$narrowContainerStyles = null;
const $dc4c7d139f367f70$var$Container = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { children: children, width: width, testId: testId } = t0;
    const t1 = width === "narrow" ? "_p12fko4j" : "_p12f1pl1";
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $gMc0m.default)([
            "_6rthoahv _1pfhoahv _12l21wug _ahbq1wug _y3gn1h6o",
            t1
        ]);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== t2 || $[4] !== testId) {
        t3 = /*#__PURE__*/ $42omo.createElement("div", {
            "data-testid": testId,
            className: t2
        }, children);
        $[2] = children;
        $[3] = t2;
        $[4] = testId;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ children: children, width: width, testId: testId })=>/*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_6rthoahv _1pfhoahv _12l21wug _ahbq1wug _y3gn1h6o",
            width === 'narrow' ? "_p12fko4j" : "_p12f1pl1"
        ])
    }, children);
var $dc4c7d139f367f70$export$2e2bcd8739ae039 = $dc4c7d139f367f70$var$Container;














const $24e8f619b28ef148$var$CSS_VAR_MAX_WIDTH = '--max-width';
const $24e8f619b28ef148$var$CSS_VAR_MAX_HEIGHT = '--max-height';
const $24e8f619b28ef148$var$imageStyles = null; /**
                           * __Image__
                           *
                           * Image in Empty State.
                           *
                           * @internal
                           */ 
const $24e8f619b28ef148$var$Image = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { maxHeight: maxHeight, maxWidth: maxWidth, height: t1, width: t2, src: src } = t0;
    const height = t1 === undefined ? "auto" : t1;
    const width = t2 === undefined ? "auto" : t2;
    const t3 = `${maxWidth}px`;
    const t4 = `${maxHeight}px`;
    let t5;
    if ($[0] !== t3 || $[1] !== t4) {
        t5 = {
            [$24e8f619b28ef148$var$CSS_VAR_MAX_WIDTH]: t3,
            [$24e8f619b28ef148$var$CSS_VAR_MAX_HEIGHT]: t4
        };
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    const t6 = t5;
    let t7;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $gMc0m.default)([
            "_1e0c1ule _p12fnzqo _c71l8wry _6rth1ejb _1pfhidpf _12l21wug _ahbq1wug"
        ]);
        $[3] = t7;
    } else t7 = $[3];
    let t8;
    if ($[4] !== height || $[5] !== src || $[6] !== t6 || $[7] !== width) {
        t8 = /*#__PURE__*/ $42omo.createElement("img", {
            style: t6,
            width: width,
            height: height,
            alt: "",
            role: "presentation",
            src: src,
            className: t7
        });
        $[4] = height;
        $[5] = src;
        $[6] = t6;
        $[7] = width;
        $[8] = t8;
    } else t8 = $[8];
    return t8;
} : ({ maxHeight: maxHeight, maxWidth: maxWidth, height: height = 'auto', width: width = 'auto', src: src })=>/*#__PURE__*/ $42omo.createElement("img", {
        style: {
            [$24e8f619b28ef148$var$CSS_VAR_MAX_WIDTH]: `${maxWidth}px`,
            [$24e8f619b28ef148$var$CSS_VAR_MAX_HEIGHT]: `${maxHeight}px`
        },
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        src: src,
        className: (0, $gMc0m.default)([
            "_1e0c1ule _p12fnzqo _c71l8wry _6rth1ejb _1pfhidpf _12l21wug _ahbq1wug"
        ])
    });
var $24e8f619b28ef148$export$2e2bcd8739ae039 = $24e8f619b28ef148$var$Image;














const $6eb5aa691ef9993b$var$spinnerContainerStyles = null; /**
                                      * __Spinner container__
                                      *
                                      * A spinner container for loading state of Empty State.
                                      *
                                      * @internal
                                      */ 
const $6eb5aa691ef9993b$var$SpinnerContainer = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_1bsb1ejb _ahbqpxbi"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1bsb1ejb _ahbqpxbi"
        ])
    }, children);
var $6eb5aa691ef9993b$export$2e2bcd8739ae039 = $6eb5aa691ef9993b$var$SpinnerContainer;


/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ const $9ab514c0df16f704$var$EmptyState = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(27);
    const { buttonGroupLabel: buttonGroupLabel, description: description, header: header, headingLevel: t1, headingSize: t2, imageHeight: imageHeight, imageUrl: imageUrl, imageWidth: imageWidth, isLoading: isLoading, maxImageHeight: t3, maxImageWidth: t4, primaryAction: primaryAction, renderImage: renderImage, secondaryAction: secondaryAction, width: width, tertiaryAction: tertiaryAction, testId: testId } = t0;
    const headingLevel = t1 === undefined ? 4 : t1;
    const headingSize = t2 === undefined ? "medium" : t2;
    const maxImageHeight = t3 === undefined ? 160 : t3;
    const maxImageWidth = t4 === undefined ? 160 : t4;
    let t5;
    if ($[0] !== buttonGroupLabel || $[1] !== isLoading || $[2] !== primaryAction || $[3] !== secondaryAction || $[4] !== testId) {
        t5 = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b6ec5e063c3a7af6$export$2e2bcd8739ae039), null, primaryAction && secondaryAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), {
            label: buttonGroupLabel || "Button group",
            testId: testId && `${testId}-button-group`
        }, secondaryAction, primaryAction) : primaryAction || secondaryAction, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6eb5aa691ef9993b$export$2e2bcd8739ae039), null, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            testId: "empty-state-spinner"
        }))) : null;
        $[0] = buttonGroupLabel;
        $[1] = isLoading;
        $[2] = primaryAction;
        $[3] = secondaryAction;
        $[4] = testId;
        $[5] = t5;
    } else t5 = $[5];
    const actionsContainer = t5;
    const tag = `h${headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4}`;
    const t6 = width || "wide";
    let t7;
    if ($[6] !== imageHeight || $[7] !== imageUrl || $[8] !== imageWidth || $[9] !== maxImageHeight || $[10] !== maxImageWidth || $[11] !== renderImage) {
        t7 = imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $24e8f619b28ef148$export$2e2bcd8739ae039), {
            src: imageUrl,
            maxWidth: maxImageWidth,
            maxHeight: maxImageHeight,
            width: imageWidth,
            height: imageHeight
        }) : renderImage && renderImage({
            maxImageWidth: maxImageWidth,
            maxImageHeight: maxImageHeight,
            imageWidth: imageWidth,
            imageHeight: imageHeight
        });
        $[6] = imageHeight;
        $[7] = imageUrl;
        $[8] = imageWidth;
        $[9] = maxImageHeight;
        $[10] = maxImageWidth;
        $[11] = renderImage;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== header || $[14] !== headingSize || $[15] !== tag) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlockEnd: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: headingSize,
            as: tag
        }, header));
        $[13] = header;
        $[14] = headingSize;
        $[15] = tag;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== description) {
        t9 = description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlockEnd: "space.300"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            as: "p"
        }, description));
        $[17] = description;
        $[18] = t9;
    } else t9 = $[18];
    let t10;
    if ($[19] !== actionsContainer || $[20] !== t6 || $[21] !== t7 || $[22] !== t8 || $[23] !== t9 || $[24] !== tertiaryAction || $[25] !== testId) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dc4c7d139f367f70$export$2e2bcd8739ae039), {
            testId: testId,
            width: t6
        }, t7, t8, t9, actionsContainer, tertiaryAction);
        $[19] = actionsContainer;
        $[20] = t6;
        $[21] = t7;
        $[22] = t8;
        $[23] = t9;
        $[24] = tertiaryAction;
        $[25] = testId;
        $[26] = t10;
    } else t10 = $[26];
    return t10;
} : ({ buttonGroupLabel: buttonGroupLabel, description: description, header: header, headingLevel: headingLevel = 4, headingSize: headingSize = 'medium', imageHeight: imageHeight, imageUrl: imageUrl, imageWidth: imageWidth, isLoading: isLoading, maxImageHeight: maxImageHeight = 160, maxImageWidth: maxImageWidth = 160, primaryAction: primaryAction, renderImage: renderImage, secondaryAction: secondaryAction, width: width, tertiaryAction: tertiaryAction, testId: testId })=>{
    const actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b6ec5e063c3a7af6$export$2e2bcd8739ae039), null, primaryAction && secondaryAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), {
        label: buttonGroupLabel || 'Button group',
        testId: testId && `${testId}-button-group`
    }, secondaryAction, primaryAction) : primaryAction || secondaryAction, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6eb5aa691ef9993b$export$2e2bcd8739ae039), null, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        testId: "empty-state-spinner"
    }))) : null;
    const tag = `h${headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dc4c7d139f367f70$export$2e2bcd8739ae039), {
        testId: testId,
        width: width || 'wide'
    }, imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $24e8f619b28ef148$export$2e2bcd8739ae039), {
        src: imageUrl,
        maxWidth: maxImageWidth,
        maxHeight: maxImageHeight,
        width: imageWidth,
        height: imageHeight
    }) : renderImage && renderImage({
        maxImageWidth: maxImageWidth,
        maxImageHeight: maxImageHeight,
        imageWidth: imageWidth,
        imageHeight: imageHeight
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlockEnd: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: headingSize,
        as: tag
    }, header)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlockEnd: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "p"
    }, description)), actionsContainer, tertiaryAction);
};
var $9ab514c0df16f704$export$2e2bcd8739ae039 = $9ab514c0df16f704$var$EmptyState;
module.exports["default"] = $9ab514c0df16f704$export$2e2bcd8739ae039;

});

parcelRegister("lUjjs", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $fb3kw = parcelRequire("fb3kw");


var $fzqvY = parcelRequire("fzqvY");


var $dh538 = parcelRequire("dh538");


var $fVUfS = parcelRequire("fVUfS");


var $6F6hl = parcelRequire("6F6hl");














var $1qfLF = parcelRequire("1qfLF");


var $cvXh8 = parcelRequire("cvXh8");


var $hmuev = parcelRequire("hmuev");




const $a923a768f1bc2446$var$buttonsContainerStyles = null;
const $a923a768f1bc2446$var$buttonWrapperBaseStyles = null;
const $a923a768f1bc2446$var$buttonWrapperBaseStylesT26Shape = null;
const $a923a768f1bc2446$var$Buttons = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_1e0c1txw _kqswstnw _1o9zidpf _152t1osq _rjxpidpf _1pfh12x7"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gMc0m.default)([
            "_2rkofajl _11c8fhey _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs130s _1mpy1b66 _1nlx1bhr _l2uv6o2t _7mfvm8nx _szlbi7uo",
            (0, $dh538.fg)("platform-dst-shape-theme-default") && "_2rko1qi0"
        ]);
        $[1] = t2;
    } else t2 = $[1];
    const t3 = testId && `${testId}--confirm`;
    let t4;
    if ($[2] !== confirmButtonLabel || $[3] !== onMouseDown || $[4] !== t3) {
        t4 = /*#__PURE__*/ $42omo.createElement("div", {
            tabIndex: -1,
            className: t2
        }, /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
            type: "submit",
            icon: $a923a768f1bc2446$var$_temp,
            onMouseDown: onMouseDown,
            label: confirmButtonLabel,
            testId: t3
        }));
        $[2] = confirmButtonLabel;
        $[3] = onMouseDown;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $gMc0m.default)([
            "_2rkofajl _11c8fhey _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs130s _1mpy1b66 _1nlx1bhr _l2uv6o2t _7mfvm8nx _szlbi7uo",
            (0, $dh538.fg)("platform-dst-shape-theme-default") && "_2rko1qi0"
        ]);
        $[6] = t5;
    } else t5 = $[6];
    const t6 = testId && `${testId}--cancel`;
    let t7;
    if ($[7] !== cancelButtonLabel || $[8] !== onCancelClick || $[9] !== onMouseDown || $[10] !== t6) {
        t7 = /*#__PURE__*/ $42omo.createElement("div", {
            tabIndex: -1,
            className: t5
        }, /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
            icon: $a923a768f1bc2446$var$_temp2,
            label: cancelButtonLabel,
            onClick: onCancelClick,
            onMouseDown: onMouseDown,
            testId: t6
        }));
        $[7] = cancelButtonLabel;
        $[8] = onCancelClick;
        $[9] = onMouseDown;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== t4 || $[13] !== t7) {
        t8 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t1
        }, t4, t7);
        $[12] = t4;
        $[13] = t7;
        $[14] = t8;
    } else t8 = $[14];
    return t8;
} : ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _kqswstnw _1o9zidpf _152t1osq _rjxpidpf _1pfh12x7"
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        tabIndex: -1,
        className: (0, $gMc0m.default)([
            "_2rkofajl _11c8fhey _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs130s _1mpy1b66 _1nlx1bhr _l2uv6o2t _7mfvm8nx _szlbi7uo",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1qi0"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
        type: "submit",
        icon: (iconProps)=>/*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                ...iconProps,
                size: "small"
            }),
        onMouseDown: onMouseDown,
        label: confirmButtonLabel,
        testId: testId && `${testId}--confirm`
    })), /*#__PURE__*/ $42omo.createElement("div", {
        tabIndex: -1,
        className: (0, $gMc0m.default)([
            "_2rkofajl _11c8fhey _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs130s _1mpy1b66 _1nlx1bhr _l2uv6o2t _7mfvm8nx _szlbi7uo",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1qi0"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
        icon: (iconProps_0)=>/*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                ...iconProps_0,
                size: "small"
            }),
        label: cancelButtonLabel,
        onClick: onCancelClick,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}--cancel`
    })));
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $a923a768f1bc2446$export$2e2bcd8739ae039 = $a923a768f1bc2446$var$Buttons;
function $a923a768f1bc2446$var$_temp(iconProps) {
    return /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        ...iconProps,
        size: "small"
    });
}
function $a923a768f1bc2446$var$_temp2(iconProps_0) {
    return /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
        ...iconProps_0,
        size: "small"
    });
}





/**
 * Recursively extracts plain text content from a ReactNode.
 *
 * This is useful when a ReactNode needs to be represented as a string,
 * e.g. for use in an `aria-label` attribute.
 */ const $5a32eaa7fa216dae$var$getTextFromReactNode = (node)=>{
    if (node == null || typeof node === 'boolean') return '';
    if (typeof node === 'string') return node;
    if (typeof node === 'number') return String(node);
    if (Array.isArray(node)) return node.map($5a32eaa7fa216dae$var$getTextFromReactNode).join('');
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node)) return $5a32eaa7fa216dae$var$getTextFromReactNode(node.props.children);
    return '';
};
var $5a32eaa7fa216dae$export$2e2bcd8739ae039 = $5a32eaa7fa216dae$var$getTextFromReactNode;











const $1de0b0e2e8eb3144$var$usePrevious = (value)=>{
    const ref = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $1de0b0e2e8eb3144$var$useButtonFocusHook = (0, $4pOgL.isReactCompilerActivePlatform)() ? (isEditing, isEditingState)=>{
    const $ = (0, $frIzR.c)(10);
    const editButtonRef = (0, $42omo.useRef)(null);
    const editViewRef = (0, $42omo.useRef)();
    const preventFocusOnEditButtonRef = (0, $42omo.useRef)(false);
    const isControlled = typeof isEditing === "undefined";
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $1de0b0e2e8eb3144$var$usePrevious(shouldBeEditing);
    let t0;
    let t1;
    if ($[0] !== isEditingState) {
        t0 = ()=>{
            if (isEditingState && editViewRef.current) editViewRef.current.focus();
        };
        t1 = [
            editViewRef,
            isEditingState
        ];
        $[0] = isEditingState;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $42omo.useEffect)(t0, t1);
    let t2;
    let t3;
    if ($[3] !== prevIsEditing || $[4] !== shouldBeEditing) {
        t2 = ()=>{
            if (prevIsEditing && !shouldBeEditing) {
                if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
                else if (editButtonRef && editButtonRef.current) editButtonRef.current.focus();
            }
        };
        t3 = [
            prevIsEditing,
            shouldBeEditing
        ];
        $[3] = prevIsEditing;
        $[4] = shouldBeEditing;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>preventFocusOnEditButtonRef.current = true;
        $[7] = t4;
    } else t4 = $[7];
    const doNotFocusOnEditButton = t4;
    let t5;
    if ($[8] !== shouldBeEditing) {
        t5 = {
            editButtonRef: editButtonRef,
            editViewRef: editViewRef,
            shouldBeEditing: shouldBeEditing,
            doNotFocusOnEditButton: doNotFocusOnEditButton
        };
        $[8] = shouldBeEditing;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : (isEditing, isEditingState)=>{
    const editButtonRef = (0, $42omo.useRef)(null);
    const editViewRef = (0, $42omo.useRef)();
    const preventFocusOnEditButtonRef = (0, $42omo.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $1de0b0e2e8eb3144$var$usePrevious(shouldBeEditing);
    (0, $42omo.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $42omo.useEffect)(()=>{
        /**
     * This logic puts the focus on the edit button after confirming using
     * the confirm button or using the keyboard to confirm, but not when
     * it is confirmed by wrapper blur
     */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $1de0b0e2e8eb3144$export$2e2bcd8739ae039 = $1de0b0e2e8eb3144$var$useButtonFocusHook;




















const $35d9f9715033f1f7$var$readViewContainerStyles = null;
const $35d9f9715033f1f7$var$editButtonStyles = {
    root: "_12ji1r31 _1qu2glyw _12y3idpf _189eidpf _1dqoglyw _1h6d1j28 _1e0c1ule _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _r06hglyw _bfhk1j28 _vwz4kb7n _1xp41v1w _14lydkaa _1j8znqa1 _mizu1r31 _ra3xglyw _128midpf"
};
const $35d9f9715033f1f7$var$readViewWrapperStyles = null;
const $35d9f9715033f1f7$var$readViewWrapperStylesT26Shape = null;
const $35d9f9715033f1f7$var$readViewFitContainerWidthStyles = null;
const $35d9f9715033f1f7$var$DRAG_THRESHOLD = 5;
const $35d9f9715033f1f7$var$ReadView = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId } = t0;
    const startX = (0, $42omo.useRef)(0);
    const startY = (0, $42omo.useRef)(0);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (event)=>Math.abs(startX.current - event.clientX) >= $35d9f9715033f1f7$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $35d9f9715033f1f7$var$DRAG_THRESHOLD;
        $[0] = t1;
    } else t1 = $[0];
    const mouseHasMovedAfterMouseDown = t1;
    let t2;
    if ($[1] !== onEditRequested || $[2] !== postReadViewClick) {
        t2 = (event_0)=>{
            const element = event_0.target;
            if (element.tagName.toLowerCase() !== "a" && !mouseHasMovedAfterMouseDown(event_0)) {
                event_0.preventDefault();
                onEditRequested();
                postReadViewClick();
            }
        };
        $[1] = onEditRequested;
        $[2] = postReadViewClick;
        $[3] = t2;
    } else t2 = $[3];
    const onReadViewClick = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $gMc0m.default)([
            "_vwz4kb7n"
        ]);
        $[4] = t3;
    } else t3 = $[4];
    const t4 = testId && `${testId}--edit-button`;
    let t5;
    if ($[5] !== editButtonLabel || $[6] !== editButtonRef || $[7] !== onEditRequested || $[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
            xcss: $35d9f9715033f1f7$var$editButtonStyles.root,
            onClick: onEditRequested,
            ref: editButtonRef,
            testId: t4,
            "aria-label": editButtonLabel
        });
        $[5] = editButtonLabel;
        $[6] = editButtonRef;
        $[7] = onEditRequested;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (e)=>{
            startX.current = e.clientX;
            startY.current = e.clientY;
        };
        $[10] = t6;
    } else t6 = $[10];
    const t7 = readViewFitContainerWidth && "_1bsb1osq";
    let t8;
    if ($[11] !== t7) {
        t8 = (0, $gMc0m.default)([
            "_2rkofajl _v564thzt _1h6d1j28 _1dqonqa1 _189e1dm9 _1e0c1o8l _vchhusvi _1bsb1wug _p12f1osq _irr31dpa",
            t7,
            (0, $dh538.fg)("platform-dst-shape-theme-default") && "_2rko1qi0"
        ]);
        $[11] = t7;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== readView) {
        t9 = readView();
        $[13] = readView;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== onReadViewClick || $[16] !== readViewFitContainerWidth || $[17] !== t8 || $[18] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            role: "presentation",
            onClick: onReadViewClick,
            onMouseDown: t6,
            "data-read-view-fit-container-width": readViewFitContainerWidth,
            className: t8
        }, t9);
        $[15] = onReadViewClick;
        $[16] = readViewFitContainerWidth;
        $[17] = t8;
        $[18] = t9;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== t10 || $[21] !== t5) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t3
        }, t5, t10);
        $[20] = t10;
        $[21] = t5;
        $[22] = t11;
    } else t11 = $[22];
    return t11;
} : ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $42omo.useRef)(0);
    const startY = (0, $42omo.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $35d9f9715033f1f7$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $35d9f9715033f1f7$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event_0)=>{
        const element = event_0.target; /**
                                                      * If a link is clicked in the read view, default action should be taken
                                                      */ 
        if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event_0)) {
            event_0.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_vwz4kb7n"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: $35d9f9715033f1f7$var$editButtonStyles.root,
        onClick: onEditRequested,
        ref: editButtonRef,
        testId: testId && `${testId}--edit-button`,
        "aria-label": editButtonLabel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" /**
         * It is not normally acceptable to add click handlers to non-interactive elements
         * as this is an accessibility anti-pattern. However, because this instance is
         * account for clicking on links that may be embedded within inline-edit and not
         * creating an inaccessible custom element, we can add role="presentation" so that
         * there is no negative impacts to assistive technologies.
         * (Why links are embeeded in inline-edit is for another day...)
         */ , {
        role: "presentation",
        onClick: onReadViewClick,
        onMouseDown: (e)=>{
            startX.current = e.clientX;
            startY.current = e.clientY;
        },
        "data-read-view-fit-container-width": readViewFitContainerWidth,
        className: (0, $gMc0m.default)([
            "_2rkofajl _v564thzt _1h6d1j28 _1dqonqa1 _189e1dm9 _1e0c1o8l _vchhusvi _1bsb1wug _p12f1osq _irr31dpa",
            readViewFitContainerWidth && "_1bsb1osq",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1qi0"
        ])
    }, readView()));
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $35d9f9715033f1f7$export$2e2bcd8739ae039 = $35d9f9715033f1f7$var$ReadView;


const $639e5e6b0deeee6e$var$fieldStyles = null;
const $639e5e6b0deeee6e$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $639e5e6b0deeee6e$var$InnerInlineEdit = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(56);
    const { startWithEditViewOpen: t0, keepEditViewOpenOnBlur: t1, hideActionButtons: t2, isRequired: t3, readViewFitContainerWidth: t4, editButtonLabel: t5, editLabel: t6, confirmButtonLabel: t7, cancelButtonLabel: t8, defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const startWithEditViewOpen = t0 === undefined ? false : t0;
    const keepEditViewOpenOnBlur = t1 === undefined ? false : t1;
    const hideActionButtons = t2 === undefined ? false : t2;
    const isRequired = t3 === undefined ? false : t3;
    const readViewFitContainerWidth = t4 === undefined ? false : t4;
    const editButtonLabel = t5 === undefined ? "Edit" : t5;
    const editLabel = t6 === undefined ? "edit" : t6;
    const confirmButtonLabel = t7 === undefined ? "Confirm" : t7;
    const cancelButtonLabel = t8 === undefined ? "Cancel" : t8;
    const wasFocusReceivedSinceLastBlurRef = (0, $42omo.useRef)(false);
    const isControlled = typeof isEditing === "undefined";
    const [isEditingState, setEditingState] = (0, $42omo.useState)(startWithEditViewOpen);
    const timerRef = (0, $42omo.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $1de0b0e2e8eb3144$export$2e2bcd8739ae039)(isEditing, isEditingState);
    let t9;
    if ($[0] !== isControlled || $[1] !== providedOnCancel) {
        t9 = ()=>{
            if (isControlled) setEditingState(false);
            providedOnCancel?.();
        };
        $[0] = isControlled;
        $[1] = providedOnCancel;
        $[2] = t9;
    } else t9 = $[2];
    const onCancel = t9;
    let t10;
    if ($[3] !== editViewRef || $[4] !== isControlled || $[5] !== providedOnEdit || $[6] !== shouldBeEditing) {
        t10 = ()=>{
            if (isControlled) setEditingState(true);
            providedOnEdit?.();
            if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
        };
        $[3] = editViewRef;
        $[4] = isControlled;
        $[5] = providedOnEdit;
        $[6] = shouldBeEditing;
        $[7] = t10;
    } else t10 = $[7];
    const onEditRequested = t10;
    let t11;
    if ($[8] !== isControlled || $[9] !== providedOnConfirm) {
        t11 = (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        };
        $[8] = isControlled;
        $[9] = providedOnConfirm;
        $[10] = t11;
    } else t11 = $[10];
    let t12;
    if ($[11] !== analyticsContext || $[12] !== t11) {
        t12 = {
            fn: t11,
            action: "confirmed",
            analyticsData: analyticsContext,
            ...$639e5e6b0deeee6e$var$analyticsAttributes
        };
        $[11] = analyticsContext;
        $[12] = t11;
        $[13] = t12;
    } else t12 = $[13];
    const onConfirm = (0, $gxtzC.usePlatformLeafEventHandler)(t12);
    let t13;
    if ($[14] !== onCancel) {
        t13 = (event)=>{
            event.preventDefault();
            onCancel();
        };
        $[14] = onCancel;
        $[15] = t13;
    } else t13 = $[15];
    const onCancelClick = t13;
    let t14;
    if ($[16] !== doNotFocusOnEditButton) {
        t14 = (isFieldInvalid, onSubmit, formRef)=>{
            if (typeof formRef === "function") return;
            if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
                doNotFocusOnEditButton();
                if (formRef.current.checkValidity()) onSubmit();
            }
        };
        $[16] = doNotFocusOnEditButton;
        $[17] = t14;
    } else t14 = $[17];
    const tryAutoSubmitWhenBlur = t14;
    let t15;
    if ($[18] !== keepEditViewOpenOnBlur || $[19] !== tryAutoSubmitWhenBlur) {
        t15 = (isFieldInvalid_0, onSubmit_0, formRef_0)=>{
            if (!keepEditViewOpenOnBlur) {
                wasFocusReceivedSinceLastBlurRef.current = false;
                timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid_0, onSubmit_0, formRef_0), 0);
            }
        };
        $[18] = keepEditViewOpenOnBlur;
        $[19] = tryAutoSubmitWhenBlur;
        $[20] = t15;
    } else t15 = $[20];
    const onEditViewWrapperBlur = t15;
    let t16;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = ()=>{
            wasFocusReceivedSinceLastBlurRef.current = true;
        };
        $[21] = t16;
    } else t16 = $[21];
    const onEditViewWrapperFocus = t16;
    let t17;
    if ($[22] !== editButtonLabel || $[23] !== editLabel || $[24] !== label) {
        t17 = ()=>{
            if (label) {
                const labelText = typeof label === "string" ? label : (0, $5a32eaa7fa216dae$export$2e2bcd8739ae039)(label);
                return `${editButtonLabel}, ${labelText}, ${editLabel}`;
            }
            return `${editButtonLabel}, ${editLabel}`;
        };
        $[22] = editButtonLabel;
        $[23] = editLabel;
        $[24] = label;
        $[25] = t17;
    } else t17 = $[25];
    const concatenatedEditButtonLabel = t17;
    let t18;
    if ($[26] !== concatenatedEditButtonLabel || $[27] !== doNotFocusOnEditButton || $[28] !== editButtonRef || $[29] !== onEditRequested || $[30] !== readView || $[31] !== readViewFitContainerWidth || $[32] !== testId) {
        t18 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $35d9f9715033f1f7$export$2e2bcd8739ae039), {
                editButtonLabel: concatenatedEditButtonLabel(),
                onEditRequested: onEditRequested,
                postReadViewClick: doNotFocusOnEditButton,
                editButtonRef: editButtonRef,
                readViewFitContainerWidth: readViewFitContainerWidth,
                readView: readView,
                testId: testId
            });
        $[26] = concatenatedEditButtonLabel;
        $[27] = doNotFocusOnEditButton;
        $[28] = editButtonRef;
        $[29] = onEditRequested;
        $[30] = readView;
        $[31] = readViewFitContainerWidth;
        $[32] = testId;
        $[33] = t18;
    } else t18 = $[33];
    const renderReadView = t18;
    let t19;
    if ($[34] !== onConfirm) {
        t19 = (data)=>onConfirm(data.inlineEdit);
        $[34] = onConfirm;
        $[35] = t19;
    } else t19 = $[35];
    let t20;
    if ($[36] !== cancelButtonLabel || $[37] !== confirmButtonLabel || $[38] !== defaultValue || $[39] !== doNotFocusOnEditButton || $[40] !== editView || $[41] !== editViewRef || $[42] !== hideActionButtons || $[43] !== isRequired || $[44] !== label || $[45] !== onCancel || $[46] !== onCancelClick || $[47] !== onEditViewWrapperBlur || $[48] !== renderReadView || $[49] !== shouldBeEditing || $[50] !== testId || $[51] !== validate) {
        t20 = (t21)=>{
            const { formProps: t22, reset: reset } = t21;
            const { onKeyDown: onKeyDown, onSubmit: onSubmit_1, ref: formRef_1 } = t22;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("form", {
                role: "presentation",
                onKeyDown: (e)=>{
                    onKeyDown(e);
                    if (e.key === "Esc" || e.key === "Escape") {
                        reset();
                        onCancel();
                    }
                },
                onSubmit: onSubmit_1,
                ref: formRef_1,
                className: (0, $dh538.fg)("platform_design_system_inline_edit_dont_focus") ? "dont-default-focus" : undefined
            }, shouldBeEditing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
                name: "inlineEdit",
                label: label,
                defaultValue: defaultValue,
                validate: validate,
                isRequired: isRequired,
                key: "edit-view"
            }, (t23)=>{
                const { fieldProps: fieldProps, error: error } = t23;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    onBlur: (e_0)=>{
                        if (!e_0.currentTarget.contains(e_0.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit_1, formRef_1);
                    },
                    onFocus: onEditViewWrapperFocus,
                    className: (0, $gMc0m.default)([
                        "_p12f1osq _kqswh2mm"
                    ])
                }, editView({
                    ...fieldProps,
                    errorMessage: error
                }, editViewRef), !hideActionButtons ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a923a768f1bc2446$export$2e2bcd8739ae039), {
                    testId: testId,
                    cancelButtonLabel: cancelButtonLabel,
                    confirmButtonLabel: confirmButtonLabel,
                    onMouseDown: ()=>{
                        doNotFocusOnEditButton();
                    },
                    onCancelClick: (e_1)=>{
                        reset();
                        onCancelClick(e_1);
                    }
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
                    hidden: true,
                    type: "submit"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), null, "Submit")));
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
                name: "inlineEdit",
                label: label,
                defaultValue: "",
                isRequired: isRequired,
                key: "read-view"
            }, renderReadView));
        };
        $[36] = cancelButtonLabel;
        $[37] = confirmButtonLabel;
        $[38] = defaultValue;
        $[39] = doNotFocusOnEditButton;
        $[40] = editView;
        $[41] = editViewRef;
        $[42] = hideActionButtons;
        $[43] = isRequired;
        $[44] = label;
        $[45] = onCancel;
        $[46] = onCancelClick;
        $[47] = onEditViewWrapperBlur;
        $[48] = renderReadView;
        $[49] = shouldBeEditing;
        $[50] = testId;
        $[51] = validate;
        $[52] = t20;
    } else t20 = $[52];
    let t21;
    if ($[53] !== t19 || $[54] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
            onSubmit: t19
        }, t20);
        $[53] = t19;
        $[54] = t20;
        $[55] = t21;
    } else t21 = $[55];
    return t21;
} : (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $42omo.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $42omo.useState)(startWithEditViewOpen);
    const timerRef = (0, $42omo.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $1de0b0e2e8eb3144$export$2e2bcd8739ae039)(isEditing, isEditingState);
    const onCancel = (0, $42omo.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel?.();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $42omo.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit?.();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$639e5e6b0deeee6e$var$analyticsAttributes
    });
    const onCancelClick = (0, $42omo.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $42omo.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        // Ignore if the provided ref is a function. This is used to make the
        // typechecking accurate. Inline edit only uses one type of ref, so this
        // will never trigger.
        if (typeof formRef === 'function') return;
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]); /**
                                 * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
                                 *  confirms the value, if the focus is not transferred to the action buttons.
                                 *
                                 *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
                                 *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
                                 *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
                                 *  `autoSubmitWhenBlur`.
                                 *
                                 *  There are two paths here the function can be triggered:
                                 *
                                 *  - focus on input first, and then use keyboard to `submit`
                                 *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
                                 */ 
    const onEditViewWrapperBlur = (0, $42omo.useCallback)((isFieldInvalid_0, onSubmit_0, formRef_0)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid_0, onSubmit_0, formRef_0), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]); /**
                                                        * Gets called when focus is transferred to the editView, or action buttons.
                                                        *
                                                        * There are three paths here the function can be called:
                                                        *
                                                        * - when a user click the `editView`
                                                        * - when a user use keyboard to tab into `editView`
                                                        * - when a user use keyboard to tab into `submit` when they were on input field.
                                                        */ 
    const onEditViewWrapperFocus = (0, $42omo.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) {
            const labelText = typeof label === 'string' ? label : (0, $5a32eaa7fa216dae$export$2e2bcd8739ae039)(label);
            return `${editButtonLabel}, ${labelText}, ${editLabel}`;
        }
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $35d9f9715033f1f7$export$2e2bcd8739ae039), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit)
    }, ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit_1, ref: formRef_1 }, reset: reset })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("form" /**
                 * It is not normally acceptable to add key handlers to non-interactive elements
                 * as this is an accessibility anti-pattern. However, because this instance is
                 * to add support for keyboard functionality instead of creating an inaccessible
                 * custom element, we can add role="presentation" so that there is no negative
                 * impacts to assistive technologies.
                 */ , {
            role: "presentation",
            onKeyDown: (e)=>{
                onKeyDown(e);
                if (e.key === 'Esc' || e.key === 'Escape') {
                    reset();
                    onCancel();
                }
            },
            onSubmit: onSubmit_1,
            ref: formRef_1,
            // This is because due to some default focus being applied to the form element, the inline edit component
            // was being focused automatically and causing scroll issues in issue view
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $dh538.fg)('platform_design_system_inline_edit_dont_focus') ? 'dont-default-focus' : undefined
        }, shouldBeEditing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: defaultValue,
            validate: validate,
            isRequired: isRequired,
            key: "edit-view"
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                onBlur: (e_0)=>{
                    if (!e_0.currentTarget.contains(e_0.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit_1, formRef_1);
                },
                onFocus: onEditViewWrapperFocus,
                className: (0, $gMc0m.default)([
                    "_p12f1osq _kqswh2mm"
                ])
            }, editView({
                ...fieldProps,
                errorMessage: error
            }, editViewRef), !hideActionButtons ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a923a768f1bc2446$export$2e2bcd8739ae039), {
                testId: testId,
                cancelButtonLabel: cancelButtonLabel,
                confirmButtonLabel: confirmButtonLabel,
                onMouseDown: ()=>{
                    /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                },
                onCancelClick: (e_1)=>{
                    reset();
                    onCancelClick(e_1);
                }
            }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
                hidden: true,
                type: "submit"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), null, "Submit")))) : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: "",
            isRequired: isRequired,
            key: "read-view"
        }, renderReadView)));
};
const $639e5e6b0deeee6e$var$InlineEdit = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($639e5e6b0deeee6e$var$InnerInlineEdit, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($639e5e6b0deeee6e$var$InnerInlineEdit, props);
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $639e5e6b0deeee6e$export$2e2bcd8739ae039 = $639e5e6b0deeee6e$var$InlineEdit;
module.exports["default"] = $639e5e6b0deeee6e$export$2e2bcd8739ae039;

});

parcelRegister("82gXq", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $c0qxy = parcelRequire("c0qxy");


var $cvXh8 = parcelRequire("cvXh8");


var $hmuev = parcelRequire("hmuev");


var $9hlns = parcelRequire("9hlns");


var $6F6hl = parcelRequire("6F6hl");











var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

const $90e7ba1d552f540d$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
const $90e7ba1d552f540d$var$IconContainer = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { children: children, size: size, isHidden: isHidden, position: position } = t0;
    const t1 = isHidden && $90e7ba1d552f540d$var$styles.hidden;
    const t2 = size === "regular" && $90e7ba1d552f540d$var$styles.iconContainerRegular;
    const t3 = size === "large" && $90e7ba1d552f540d$var$styles.iconContainerLarge;
    const t4 = position === "left" && $90e7ba1d552f540d$var$styles.left;
    const t5 = position === "right" && $90e7ba1d552f540d$var$styles.right;
    let t6;
    if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5) {
        t6 = (0, $1Whri.cx)($90e7ba1d552f540d$var$styles.iconContainer, t1, t2, t3, t4, t5);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== children || $[7] !== t6) {
        t7 = /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            as: "span",
            xcss: t6
        }, children);
        $[6] = children;
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    return t7;
} : ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: (0, $1Whri.cx)($90e7ba1d552f540d$var$styles.iconContainer, isHidden && $90e7ba1d552f540d$var$styles.hidden, size === 'regular' && $90e7ba1d552f540d$var$styles.iconContainerRegular, size === 'large' && $90e7ba1d552f540d$var$styles.iconContainerLarge, position === 'left' && $90e7ba1d552f540d$var$styles.left, position === 'right' && $90e7ba1d552f540d$var$styles.right)
    }, children);
};
var $90e7ba1d552f540d$export$2e2bcd8739ae039 = $90e7ba1d552f540d$var$IconContainer;


const $cdaef5761c0348c7$var$LOADING_LABEL = ', Loading';
const $cdaef5761c0348c7$var$baseStyles = null;
const $cdaef5761c0348c7$var$sizeStyles = {
    regular: "_2rko1rr0 _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf",
    large: "_2rko1rr0 _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz"
}; /**
    * Slider knob translate transforms per size, applied when checked.
    */ 
const $cdaef5761c0348c7$var$checkedSliderStyles = {
    regular: "_7dwz1fbe",
    large: "_7dwzw12q"
}; /**
    * Applied when the toggle is checked
    */ 
const $cdaef5761c0348c7$var$checkedStyles = null; /**
                             * Applied when the toggle is checked and not disabled.
                             */ 
const $cdaef5761c0348c7$var$checkedHoveredStyles = null; /**
                                    * Applied when the toggle is unchecked and not disabled.
                                    */ 
const $cdaef5761c0348c7$var$uncheckedHoveredStyles = null; /**
                                      * Applied when the toggle is disabled.
                                      */ 
const $cdaef5761c0348c7$var$disabledStyles = null;
const $cdaef5761c0348c7$var$inputStyles = null;
const $cdaef5761c0348c7$var$noop = (0, $ee7An.default);
const $cdaef5761c0348c7$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $cdaef5761c0348c7$var$Toggle = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $frIzR.c)(65);
    const { defaultChecked: t0, isDisabled: t1, onBlur: t2, onChange: t3, onFocus: t4, size: t5, name: t6, value: t7, isChecked: isChecked, isLoading: isLoading, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const defaultChecked = t0 === undefined ? false : t0;
    const isDisabled = t1 === undefined ? false : t1;
    const providedOnBlur = t2 === undefined ? $cdaef5761c0348c7$var$noop : t2;
    const providedChange = t3 === undefined ? $cdaef5761c0348c7$var$noop : t3;
    const providedFocus = t4 === undefined ? $cdaef5761c0348c7$var$noop : t4;
    const size = t5 === undefined ? "regular" : t5;
    const name = t6 === undefined ? "" : t6;
    const value = t7 === undefined ? "" : t7;
    const isControlled = typeof isChecked === "undefined";
    const [checked, setChecked] = (0, $42omo.useState)(defaultChecked);
    const loadingLabelId = (0, $c0qxy.useId)();
    let t8;
    if ($[0] !== analyticsContext || $[1] !== providedOnBlur) {
        t8 = {
            fn: providedOnBlur,
            action: "blur",
            analyticsData: analyticsContext,
            ...$cdaef5761c0348c7$var$analyticsAttributes
        };
        $[0] = analyticsContext;
        $[1] = providedOnBlur;
        $[2] = t8;
    } else t8 = $[2];
    const handleBlur = (0, $gxtzC.usePlatformLeafEventHandler)(t8);
    let t9;
    if ($[3] !== analyticsContext || $[4] !== providedFocus) {
        t9 = {
            fn: providedFocus,
            action: "focus",
            analyticsData: analyticsContext,
            ...$cdaef5761c0348c7$var$analyticsAttributes
        };
        $[3] = analyticsContext;
        $[4] = providedFocus;
        $[5] = t9;
    } else t9 = $[5];
    const handleFocus = (0, $gxtzC.usePlatformLeafEventHandler)(t9);
    let t10;
    if ($[6] !== isControlled || $[7] !== providedChange) {
        t10 = (event, analyticsEvent)=>{
            if (isControlled) setChecked($cdaef5761c0348c7$var$_temp);
            return providedChange(event, analyticsEvent);
        };
        $[6] = isControlled;
        $[7] = providedChange;
        $[8] = t10;
    } else t10 = $[8];
    let t11;
    if ($[9] !== analyticsContext || $[10] !== t10) {
        t11 = {
            fn: t10,
            action: "change",
            analyticsData: analyticsContext,
            ...$cdaef5761c0348c7$var$analyticsAttributes
        };
        $[9] = analyticsContext;
        $[10] = t10;
        $[11] = t11;
    } else t11 = $[11];
    const handleChange = (0, $gxtzC.usePlatformLeafEventHandler)(t11);
    const shouldChecked = isControlled ? checked : isChecked;
    const labelId = (0, $c0qxy.useId)();
    const t12 = $cdaef5761c0348c7$var$sizeStyles[size];
    const t13 = shouldChecked && "_bfhkkcmj";
    const t14 = shouldChecked && $cdaef5761c0348c7$var$checkedSliderStyles[size];
    const t15 = !isDisabled && shouldChecked && "_irr3y7x8";
    const t16 = !isDisabled && !shouldChecked && "_irr31ibz";
    const t17 = isDisabled && "_bfhk187o _syaz2sac _80om13gf";
    let t18;
    if ($[12] !== t12 || $[13] !== t13 || $[14] !== t14 || $[15] !== t15 || $[16] !== t16 || $[17] !== t17) {
        t18 = (0, $gMc0m.default)([
            "_1h6d1j28 _1dqonqa1 _189e1dm9 _1e0c1o8l _vchh1ntv _kqswh2mm _1y1m1ntv _bfhk1aqn _syaz5w2r _80omtlke _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1oeci9qs _k8m01e03 _6fl4indk _rfx31qll _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _1cg6i9qs _qs2z1e03 _mlfeindk _1ys41v1w _ju3ddkaa _16rslghj _i5ec1w7i",
            t12,
            t13,
            t14,
            t15,
            t16,
            t17
        ]);
        $[12] = t12;
        $[13] = t13;
        $[14] = t14;
        $[15] = t15;
        $[16] = t16;
        $[17] = t17;
        $[18] = t18;
    } else t18 = $[18];
    let t19;
    if ($[19] !== isLoading || $[20] !== label || $[21] !== labelId) {
        t19 = label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            id: labelId,
            hidden: true
        }, isLoading ? `${label}${$cdaef5761c0348c7$var$LOADING_LABEL}` : label) : null;
        $[19] = isLoading;
        $[20] = label;
        $[21] = labelId;
        $[22] = t19;
    } else t19 = $[22];
    const t20 = testId && `${testId}--input`;
    const t21 = isLoading && label ? `${labelId} ${loadingLabelId}` : label ? labelId : undefined;
    let t22;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _tzy4idpf _nt751snc _49pcagmp _1hvw10yn"
        ]);
        $[23] = t22;
    } else t22 = $[23];
    let t23;
    if ($[24] !== descriptionId || $[25] !== handleBlur || $[26] !== handleChange || $[27] !== handleFocus || $[28] !== id || $[29] !== isDisabled || $[30] !== name || $[31] !== ref || $[32] !== shouldChecked || $[33] !== t20 || $[34] !== t21 || $[35] !== value) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
            ref: ref,
            checked: shouldChecked,
            disabled: isDisabled,
            id: id,
            name: name,
            onBlur: handleBlur,
            onChange: handleChange,
            onFocus: handleFocus,
            type: "checkbox",
            value: value,
            "data-testid": t20,
            "aria-labelledby": t21,
            "aria-describedby": descriptionId,
            className: t22
        });
        $[24] = descriptionId;
        $[25] = handleBlur;
        $[26] = handleChange;
        $[27] = handleFocus;
        $[28] = id;
        $[29] = isDisabled;
        $[30] = name;
        $[31] = ref;
        $[32] = shouldChecked;
        $[33] = t20;
        $[34] = t21;
        $[35] = value;
        $[36] = t23;
    } else t23 = $[36];
    const t24 = !shouldChecked;
    let t25;
    if ($[37] !== isLoading || $[38] !== shouldChecked || $[39] !== testId) {
        t25 = isLoading && shouldChecked ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "xsmall",
            appearance: "invert"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
            label: "",
            color: "currentColor",
            testId: testId && `${testId}--toggle-check-icon`,
            size: "small"
        });
        $[37] = isLoading;
        $[38] = shouldChecked;
        $[39] = testId;
        $[40] = t25;
    } else t25 = $[40];
    let t26;
    if ($[41] !== size || $[42] !== t24 || $[43] !== t25) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90e7ba1d552f540d$export$2e2bcd8739ae039), {
            size: size,
            isHidden: t24,
            position: "left"
        }, t25);
        $[41] = size;
        $[42] = t24;
        $[43] = t25;
        $[44] = t26;
    } else t26 = $[44];
    let t27;
    if ($[45] !== isLoading || $[46] !== shouldChecked || $[47] !== testId) {
        t27 = isLoading && !shouldChecked ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "xsmall",
            appearance: "invert"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            label: "",
            color: "currentColor",
            testId: testId && `${testId}--toggle-cross-icon`,
            size: "small"
        });
        $[45] = isLoading;
        $[46] = shouldChecked;
        $[47] = testId;
        $[48] = t27;
    } else t27 = $[48];
    let t28;
    if ($[49] !== shouldChecked || $[50] !== size || $[51] !== t27) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90e7ba1d552f540d$export$2e2bcd8739ae039), {
            size: size,
            isHidden: shouldChecked,
            position: "right"
        }, t27);
        $[49] = shouldChecked;
        $[50] = size;
        $[51] = t27;
        $[52] = t28;
    } else t28 = $[52];
    let t29;
    if ($[53] !== isLoading || $[54] !== label || $[55] !== loadingLabelId) {
        t29 = isLoading && !label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
            id: loadingLabelId
        }, $cdaef5761c0348c7$var$LOADING_LABEL);
        $[53] = isLoading;
        $[54] = label;
        $[55] = loadingLabelId;
        $[56] = t29;
    } else t29 = $[56];
    let t30;
    if ($[57] !== t18 || $[58] !== t19 || $[59] !== t23 || $[60] !== t26 || $[61] !== t28 || $[62] !== t29 || $[63] !== testId) {
        t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("label", {
            "data-testid": testId,
            className: t18
        }, t19, t23, t26, t28, t29);
        $[57] = t18;
        $[58] = t19;
        $[59] = t23;
        $[60] = t26;
        $[61] = t28;
        $[62] = t29;
        $[63] = testId;
        $[64] = t30;
    } else t30 = $[64];
    return t30;
} : (props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $cdaef5761c0348c7$var$noop, onChange: providedChange = $cdaef5761c0348c7$var$noop, onFocus: providedFocus = $cdaef5761c0348c7$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, isLoading: isLoading, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $42omo.useState)(defaultChecked);
    const loadingLabelId = (0, $c0qxy.useId)();
    const handleBlur = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$cdaef5761c0348c7$var$analyticsAttributes
    });
    const handleFocus = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$cdaef5761c0348c7$var$analyticsAttributes
    });
    const handleChange = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked_0)=>!checked_0);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$cdaef5761c0348c7$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const labelId = (0, $c0qxy.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("label", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1h6d1j28 _1dqonqa1 _189e1dm9 _1e0c1o8l _vchh1ntv _kqswh2mm _1y1m1ntv _bfhk1aqn _syaz5w2r _80omtlke _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1oeci9qs _k8m01e03 _6fl4indk _rfx31qll _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _1cg6i9qs _qs2z1e03 _mlfeindk _1ys41v1w _ju3ddkaa _16rslghj _i5ec1w7i",
            $cdaef5761c0348c7$var$sizeStyles[size],
            shouldChecked && "_bfhkkcmj",
            shouldChecked && $cdaef5761c0348c7$var$checkedSliderStyles[size],
            !isDisabled && shouldChecked && "_irr3y7x8",
            !isDisabled && !shouldChecked && "_irr31ibz",
            isDisabled && "_bfhk187o _syaz2sac _80om13gf"
        ])
    }, label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        id: labelId,
        hidden: true
    }, isLoading ? `${label}${$cdaef5761c0348c7$var$LOADING_LABEL}` : label) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        ref: ref,
        checked: shouldChecked,
        disabled: isDisabled,
        id: id,
        name: name,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        type: "checkbox",
        value: value,
        "data-testid": testId && `${testId}--input`,
        "aria-labelledby": isLoading && label ? `${labelId} ${loadingLabelId}` : label ? labelId : undefined,
        "aria-describedby": descriptionId,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _tzy4idpf _nt751snc _49pcagmp _1hvw10yn"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90e7ba1d552f540d$export$2e2bcd8739ae039), {
        size: size,
        isHidden: !shouldChecked,
        position: "left"
    }, isLoading && shouldChecked ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "xsmall",
        appearance: "invert"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        label: "",
        color: "currentColor",
        testId: testId && `${testId}--toggle-check-icon`,
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90e7ba1d552f540d$export$2e2bcd8739ae039), {
        size: size,
        isHidden: shouldChecked,
        position: "right"
    }, isLoading && !shouldChecked ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "xsmall",
        appearance: "invert"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
        label: "",
        color: "currentColor",
        testId: testId && `${testId}--toggle-cross-icon`,
        size: "small"
    })), isLoading && !label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
        id: loadingLabelId
    }, $cdaef5761c0348c7$var$LOADING_LABEL));
}));
$cdaef5761c0348c7$var$Toggle.displayName = 'Toggle';
var $cdaef5761c0348c7$export$2e2bcd8739ae039 = $cdaef5761c0348c7$var$Toggle;
function $cdaef5761c0348c7$var$_temp(checked_0) {
    return !checked_0;
}
module.exports["default"] = $cdaef5761c0348c7$export$2e2bcd8739ae039;

});

parcelRegister("7aL0g", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $bh5s2 = parcelRequire("bh5s2");


var $gmCNH = parcelRequire("gmCNH");


var $bSHvo = parcelRequire("bSHvo");


var $l7uKY = parcelRequire("l7uKY");


var $dfX8r = parcelRequire("dfX8r");


var $dFVg2 = parcelRequire("dFVg2");


var $aaMcY = parcelRequire("aaMcY");

const $7bb9f0b114d3ce5c$var$styles = {
    baseStyles: "_zulpv77o _2rko1rr0 _11c8wadc _1dqonqa1 _189ee4h9 _1rjcze3t _1mou1b66 _195g1b66 _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3iv47k _kqswh2mm _4cvr1h6o _s7n4nkob _bfhksm61 _syazi7uo _80om73ad _y4tii2wt _bozgze3t",
    noMarginStyles: "_1mouze3t _195gze3t",
    otherBaseStyles: "_2rko12b0 _y4ti1b66",
    agentBaseStyles: "_2rko12b0 _y4ti1b66",
    removableStyles: "_y4ti1l7b _1ul98pqr",
    userRemovableStyles: "_y4ti1l7b _1ul98pqr",
    avatarStyles: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko1rr0 _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _1o9zidpf _ahbq1n1a",
    otherAvatarStyles: "_2rko12b0",
    agentAvatarStyles: "_2rkoidpf",
    textStyles: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _1bto1l2s _o5721q9c _1ul9idpf _syazi7uo",
    afterStyles: "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _lcxv1wug _ahbqv77o _kqswh2mm",
    verifiedIconStyles: "_1e0c116y _4cvr1h6o _1o9zidpf _syaz6txe _ahbqt94y",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _7nm0v77o _59381r31 _yha2glyw _1nmznqa1 _1ufy15vq _turg15vq _jr6g1snc _1ymragmp _1y1s10yn _1hw7116y _6wji1h6o _1k6fidpf _43dsjdj5 _jwdiagmp _1cayjdj5 _102s1snc _yi8hagmp _h79h10yn _9m7f1r31 _w7swglyw _15a9nqa1 _jxlhagmp",
    interactiveHoverStyles: "_fs7a1r31 _1uxk8stv _12u8nqa1 _irr31dpa _oxk4jdj5 _1di6fcek"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles */ // Border color style - gray only for AvatarTag.
// Uses the new color.border.accent.gray.subtle token directly so no OKLCH/color-mix
// runtime transforms are needed.
const $7bb9f0b114d3ce5c$var$borderColorStyles = {
    root: "_119bmsup"
}; // Border filter styles - base state
const $7bb9f0b114d3ce5c$var$borderFilterStyles = {
    root: "_1h6dip4g"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles */ 
/**
 * __AvatarTag__
 *
 * AvatarTag is a specialized tag for representing people, teams/other entities, or agents with an avatar and name.
 * The visual appearance (round, square, or hexagonal) is determined by the `type` prop.
 */ const $7bb9f0b114d3ce5c$var$AvatarTagComponent = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? function AvatarTag(t0, ref) {
    const $ = (0, $frIzR.c)(86);
    let AvatarComponent;
    let href;
    let isVerified;
    let linkComponent;
    let maxWidth;
    let onAfterRemoveAction;
    let onBeforeRemoveAction;
    let onClick;
    let other;
    let removeButtonLabel;
    let t1;
    let t2;
    let testId;
    let text;
    let type;
    if ($[0] !== t0) {
        ({ text: text, type: type, avatar: AvatarComponent, href: href, linkComponent: linkComponent, isRemovable: t1, removeButtonLabel: removeButtonLabel, onBeforeRemoveAction: onBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction, testId: testId, isVerified: isVerified, maxWidth: maxWidth, hasMargin: t2, onClick: onClick, ...other } = t0);
        $[0] = t0;
        $[1] = AvatarComponent;
        $[2] = href;
        $[3] = isVerified;
        $[4] = linkComponent;
        $[5] = maxWidth;
        $[6] = onAfterRemoveAction;
        $[7] = onBeforeRemoveAction;
        $[8] = onClick;
        $[9] = other;
        $[10] = removeButtonLabel;
        $[11] = t1;
        $[12] = t2;
        $[13] = testId;
        $[14] = text;
        $[15] = type;
    } else {
        AvatarComponent = $[1];
        href = $[2];
        isVerified = $[3];
        linkComponent = $[4];
        maxWidth = $[5];
        onAfterRemoveAction = $[6];
        onBeforeRemoveAction = $[7];
        onClick = $[8];
        other = $[9];
        removeButtonLabel = $[10];
        t1 = $[11];
        t2 = $[12];
        testId = $[13];
        text = $[14];
        type = $[15];
    }
    const isRemovable = t1 === undefined ? true : t1;
    const hasMargin = t2 === undefined ? true : t2;
    const { status: status, handleRemoveRequest: handleRemoveRequest, onKeyPress: onKeyPress, removingTag: removingTag, showingTag: showingTag } = (0, $aaMcY.useTagRemoval)(onBeforeRemoveAction);
    let t3;
    if ($[16] !== onAfterRemoveAction || $[17] !== text) {
        t3 = ()=>{
            onAfterRemoveAction?.(text);
        };
        $[16] = onAfterRemoveAction;
        $[17] = text;
        $[18] = t3;
    } else t3 = $[18];
    const onShrinkOutExitComplete = t3;
    const { isLink: isLink, LinkComponent: LinkComponent } = (0, $dfX8r.useLink)(href, linkComponent);
    const { isLinkHovered: isLinkHovered, isOverButton: isOverButton, isButtonFocused: isButtonFocused, isLinkFocused: isLinkFocused, buttonHandlers: buttonHandlers, linkHandlers: linkHandlers } = (0, $l7uKY.useButtonInteraction)();
    const isOtherType = type === "other";
    const isAgentType = type === "agent";
    const isUserType = type === "user";
    const showVerified = isOtherType && isVerified;
    const avatarAppearance = isUserType ? "circle" : isAgentType ? "hexagon" : "square";
    const removeButtonShape = isUserType ? "circle" : "default";
    let t4;
    if ($[19] !== buttonHandlers || $[20] !== handleRemoveRequest || $[21] !== isRemovable || $[22] !== onKeyPress || $[23] !== removeButtonLabel || $[24] !== removeButtonShape || $[25] !== removingTag || $[26] !== showingTag || $[27] !== testId || $[28] !== text) {
        t4 = {
            isRemovable: isRemovable,
            tagText: text,
            removeButtonLabel: removeButtonLabel,
            testId: testId,
            handleRemoveRequest: handleRemoveRequest,
            removingTag: removingTag,
            showingTag: showingTag,
            onKeyPress: onKeyPress,
            shape: removeButtonShape,
            buttonHandlers: buttonHandlers
        };
        $[19] = buttonHandlers;
        $[20] = handleRemoveRequest;
        $[21] = isRemovable;
        $[22] = onKeyPress;
        $[23] = removeButtonLabel;
        $[24] = removeButtonShape;
        $[25] = removingTag;
        $[26] = showingTag;
        $[27] = testId;
        $[28] = text;
        $[29] = t4;
    } else t4 = $[29];
    const removeButton = (0, $dFVg2.useRemoveButton)(t4);
    let t5;
    if ($[30] !== avatarAppearance) {
        t5 = {
            size: "xsmall",
            appearance: avatarAppearance,
            borderColor: "transparent"
        };
        $[30] = avatarAppearance;
        $[31] = t5;
    } else t5 = $[31];
    const controlledProps = t5;
    const AvatarComponentTyped = AvatarComponent;
    let t6;
    if ($[32] !== AvatarComponentTyped || $[33] !== controlledProps) {
        t6 = /*#__PURE__*/ $42omo.createElement(AvatarComponentTyped, controlledProps);
        $[32] = AvatarComponentTyped;
        $[33] = controlledProps;
        $[34] = t6;
    } else t6 = $[34];
    const rendered = t6;
    let t7;
    if ($[35] !== controlledProps || $[36] !== rendered) {
        t7 = /*#__PURE__*/ (0, $42omo.isValidElement)(rendered) ? /*#__PURE__*/ (0, $42omo.cloneElement)(rendered, controlledProps) : rendered;
        $[35] = controlledProps;
        $[36] = rendered;
        $[37] = t7;
    } else t7 = $[37];
    const avatarElement = t7;
    let t8;
    if ($[38] !== maxWidth) {
        t8 = maxWidth !== undefined ? {
            maxWidth: maxWidth
        } : undefined;
        $[38] = maxWidth;
        $[39] = t8;
    } else t8 = $[39];
    const t9 = !hasMargin && $7bb9f0b114d3ce5c$var$styles.noMarginStyles;
    const t10 = isOtherType && $7bb9f0b114d3ce5c$var$styles.otherBaseStyles;
    const t11 = isAgentType && $7bb9f0b114d3ce5c$var$styles.agentBaseStyles;
    const t12 = isLink && $7bb9f0b114d3ce5c$var$styles.interactiveBaseStyles;
    const t13 = isLink && $7bb9f0b114d3ce5c$var$styles.focusRingStyles;
    const t14 = isLink && isLinkHovered && !isOverButton && $7bb9f0b114d3ce5c$var$styles.interactiveHoverStyles;
    const t15 = isRemovable && !isUserType && $7bb9f0b114d3ce5c$var$styles.removableStyles;
    const t16 = isRemovable && isUserType && $7bb9f0b114d3ce5c$var$styles.userRemovableStyles;
    const t17 = isLinkFocused && !isButtonFocused && $7bb9f0b114d3ce5c$var$styles.childFocusRingStyles;
    let t18;
    if ($[40] !== t10 || $[41] !== t11 || $[42] !== t12 || $[43] !== t13 || $[44] !== t14 || $[45] !== t15 || $[46] !== t16 || $[47] !== t17 || $[48] !== t9) {
        t18 = (0, $gMc0m.default)([
            $7bb9f0b114d3ce5c$var$styles.baseStyles,
            t9,
            t10,
            t11,
            $7bb9f0b114d3ce5c$var$borderColorStyles.root,
            $7bb9f0b114d3ce5c$var$borderFilterStyles.root,
            t12,
            t13,
            t14,
            t15,
            t16,
            t17
        ]);
        $[40] = t10;
        $[41] = t11;
        $[42] = t12;
        $[43] = t13;
        $[44] = t14;
        $[45] = t15;
        $[46] = t16;
        $[47] = t17;
        $[48] = t9;
        $[49] = t18;
    } else t18 = $[49];
    const t19 = isOtherType && $7bb9f0b114d3ce5c$var$styles.otherAvatarStyles;
    const t20 = isAgentType && $7bb9f0b114d3ce5c$var$styles.agentAvatarStyles;
    let t21;
    if ($[50] !== t19 || $[51] !== t20) {
        t21 = (0, $gMc0m.default)([
            $7bb9f0b114d3ce5c$var$styles.avatarStyles,
            t19,
            t20
        ]);
        $[50] = t19;
        $[51] = t20;
        $[52] = t21;
    } else t21 = $[52];
    let t22;
    if ($[53] !== avatarElement || $[54] !== t21) {
        t22 = /*#__PURE__*/ $42omo.createElement("span", {
            className: t21
        }, avatarElement);
        $[53] = avatarElement;
        $[54] = t21;
        $[55] = t22;
    } else t22 = $[55];
    let t23;
    if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
        t23 = (0, $gMc0m.default)([
            $7bb9f0b114d3ce5c$var$styles.textStyles
        ]);
        $[56] = t23;
    } else t23 = $[56];
    let t24;
    if ($[57] !== text) {
        t24 = /*#__PURE__*/ $42omo.createElement("span", {
            "data-tag-text": true,
            className: t23
        }, text);
        $[57] = text;
        $[58] = t24;
    } else t24 = $[58];
    let t25;
    if ($[59] !== LinkComponent || $[60] !== href || $[61] !== isLink || $[62] !== linkHandlers || $[63] !== onClick || $[64] !== t22 || $[65] !== t24 || $[66] !== testId) {
        t25 = /*#__PURE__*/ $42omo.createElement((0, $gmCNH.LinkWrapper), {
            isLink: isLink,
            href: href,
            LinkComponent: LinkComponent,
            testId: testId,
            linkHandlers: linkHandlers,
            onClick: onClick
        }, t22, t24);
        $[59] = LinkComponent;
        $[60] = href;
        $[61] = isLink;
        $[62] = linkHandlers;
        $[63] = onClick;
        $[64] = t22;
        $[65] = t24;
        $[66] = testId;
        $[67] = t25;
    } else t25 = $[67];
    let t26;
    if ($[68] !== showVerified) {
        t26 = showVerified && /*#__PURE__*/ $42omo.createElement("span", {
            className: (0, $gMc0m.default)([
                $7bb9f0b114d3ce5c$var$styles.verifiedIconStyles
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), {
            label: "Verified",
            size: "small"
        }));
        $[68] = showVerified;
        $[69] = t26;
    } else t26 = $[69];
    let t27;
    if ($[70] !== removeButton) {
        t27 = removeButton && /*#__PURE__*/ $42omo.createElement("span", {
            className: (0, $gMc0m.default)([
                $7bb9f0b114d3ce5c$var$styles.afterStyles
            ])
        }, removeButton);
        $[70] = removeButton;
        $[71] = t27;
    } else t27 = $[71];
    let t28;
    if ($[72] !== other || $[73] !== ref || $[74] !== t18 || $[75] !== t25 || $[76] !== t26 || $[77] !== t27 || $[78] !== t8 || $[79] !== testId) {
        t28 = /*#__PURE__*/ $42omo.createElement("span", {
            ...other,
            ref: ref,
            "data-testid": testId,
            style: t8,
            className: t18
        }, t25, t26, t27);
        $[72] = other;
        $[73] = ref;
        $[74] = t18;
        $[75] = t25;
        $[76] = t26;
        $[77] = t27;
        $[78] = t8;
        $[79] = testId;
        $[80] = t28;
    } else t28 = $[80];
    const tagContent = t28;
    const t29 = isRemovable ? onShrinkOutExitComplete : undefined;
    let t30;
    if ($[81] !== isRemovable || $[82] !== status || $[83] !== t29 || $[84] !== tagContent) {
        t30 = /*#__PURE__*/ $42omo.createElement((0, $bSHvo.RemovableWrapper), {
            isRemovable: isRemovable,
            status: status,
            onShrinkOutExitComplete: t29
        }, tagContent);
        $[81] = isRemovable;
        $[82] = status;
        $[83] = t29;
        $[84] = tagContent;
        $[85] = t30;
    } else t30 = $[85];
    return t30;
} : function AvatarTag({ text: text, type: type, avatar: AvatarComponent, href: href, linkComponent: linkComponent, isRemovable: isRemovable = true, removeButtonLabel: removeButtonLabel, onBeforeRemoveAction: onBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction, testId: testId, isVerified: isVerified, maxWidth: // Shows verified icon for 'other' type tags
maxWidth, hasMargin: hasMargin = true, onClick: onClick, ...other }, ref) {
    const { status: status, handleRemoveRequest: handleRemoveRequest, onKeyPress: onKeyPress, removingTag: removingTag, showingTag: showingTag } = (0, $aaMcY.useTagRemoval)(onBeforeRemoveAction);
    const onShrinkOutExitComplete = (0, $42omo.useCallback)(()=>{
        onAfterRemoveAction?.(text);
    }, [
        onAfterRemoveAction,
        text
    ]);
    const { isLink: isLink, LinkComponent: LinkComponent } = (0, $dfX8r.useLink)(href, linkComponent);
    const { isLinkHovered: isLinkHovered, isOverButton: isOverButton, isButtonFocused: isButtonFocused, isLinkFocused: isLinkFocused, buttonHandlers: buttonHandlers, linkHandlers: linkHandlers } = (0, $l7uKY.useButtonInteraction)(); // Determine styles based on type
    const isOtherType = type === 'other';
    const isAgentType = type === 'agent';
    const isUserType = type === 'user'; // isVerified is only available for 'other' type
    const showVerified = isOtherType && isVerified; // Determine avatar appearance based on type
    const avatarAppearance = isUserType ? 'circle' : isAgentType ? 'hexagon' : 'square'; // Determine remove button shape based on type
    const removeButtonShape = isUserType ? 'circle' : 'default';
    const removeButton = (0, $dFVg2.useRemoveButton)({
        isRemovable: isRemovable,
        tagText: text,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        shape: removeButtonShape,
        buttonHandlers: buttonHandlers
    }); // Render the avatar with controlled props, then clone so our props are applied
    const controlledProps = {
        size: 'xsmall',
        appearance: avatarAppearance,
        borderColor: 'transparent'
    };
    const AvatarComponentTyped = AvatarComponent;
    const rendered = /*#__PURE__*/ $42omo.createElement(AvatarComponentTyped, controlledProps);
    const avatarElement = // eslint-disable-next-line @repo/internal/react/no-clone-element
    /*#__PURE__*/ (0, $42omo.isValidElement)(rendered) ? /*#__PURE__*/ (0, $42omo.cloneElement)(rendered, controlledProps) : rendered;
    const tagContent = /*#__PURE__*/ $42omo.createElement("span", {
        ...other,
        ref: ref,
        "data-testid": testId,
        style: maxWidth !== undefined ? {
            maxWidth: maxWidth
        } : undefined,
        className: (0, $gMc0m.default)([
            $7bb9f0b114d3ce5c$var$styles.baseStyles,
            !hasMargin && $7bb9f0b114d3ce5c$var$styles.noMarginStyles,
            isOtherType && $7bb9f0b114d3ce5c$var$styles.otherBaseStyles,
            isAgentType && $7bb9f0b114d3ce5c$var$styles.agentBaseStyles,
            $7bb9f0b114d3ce5c$var$borderColorStyles.root,
            $7bb9f0b114d3ce5c$var$borderFilterStyles.root,
            isLink && $7bb9f0b114d3ce5c$var$styles.interactiveBaseStyles,
            isLink && $7bb9f0b114d3ce5c$var$styles.focusRingStyles,
            isLink && isLinkHovered && !isOverButton && $7bb9f0b114d3ce5c$var$styles.interactiveHoverStyles,
            isRemovable && !isUserType && $7bb9f0b114d3ce5c$var$styles.removableStyles,
            isRemovable && isUserType && $7bb9f0b114d3ce5c$var$styles.userRemovableStyles,
            isLinkFocused && !isButtonFocused && $7bb9f0b114d3ce5c$var$styles.childFocusRingStyles
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $gmCNH.LinkWrapper), {
        isLink: isLink,
        href: href,
        LinkComponent: LinkComponent,
        testId: testId,
        linkHandlers: linkHandlers,
        onClick: onClick
    }, /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            $7bb9f0b114d3ce5c$var$styles.avatarStyles,
            isOtherType && $7bb9f0b114d3ce5c$var$styles.otherAvatarStyles,
            isAgentType && $7bb9f0b114d3ce5c$var$styles.agentAvatarStyles
        ])
    }, avatarElement), /*#__PURE__*/ $42omo.createElement("span", {
        "data-tag-text": true,
        className: (0, $gMc0m.default)([
            $7bb9f0b114d3ce5c$var$styles.textStyles
        ])
    }, text)), showVerified && /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            $7bb9f0b114d3ce5c$var$styles.verifiedIconStyles
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), {
        label: "Verified",
        size: "small"
    })), removeButton && /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            $7bb9f0b114d3ce5c$var$styles.afterStyles
        ])
    }, removeButton));
    return /*#__PURE__*/ $42omo.createElement((0, $bSHvo.RemovableWrapper), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined
    }, tagContent);
}); /**
     * __Avatar tag__
     */ 
const $7bb9f0b114d3ce5c$var$AvatarTag = /*#__PURE__*/ (0, $42omo.memo)($7bb9f0b114d3ce5c$var$AvatarTagComponent);
var $7bb9f0b114d3ce5c$export$2e2bcd8739ae039 = $7bb9f0b114d3ce5c$var$AvatarTag;
module.exports["default"] = $7bb9f0b114d3ce5c$export$2e2bcd8739ae039;

});

parcelRegister("iHPbg", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eEA8O = parcelRequire("eEA8O");


var $1Whri = parcelRequire("1Whri");


var $2Nwuj = parcelRequire("2Nwuj");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");

const $25d55444a3e209b4$var$styles = {
    common: "_11c8fhey",
    anchor: "_k48pi7a9",
    pressable: "_syaz13af _k48p1wq8 _bfhk1j28 _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz",
    pressableT26Shape: "_2rkolb4i"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $25d55444a3e209b4$var$SectionMessageAction = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? function SectionMessageAction(t0, ref) {
    const $ = (0, $frIzR.c)(29);
    const { children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent, target: target } = t0;
    if (!linkComponent) {
        if (href) {
            let t1;
            if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = (0, $gMc0m.default)([
                    $25d55444a3e209b4$var$styles.common,
                    $25d55444a3e209b4$var$styles.anchor
                ]);
                $[0] = t1;
            } else t1 = $[0];
            const t2 = ref;
            let t3;
            if ($[1] !== children || $[2] !== href || $[3] !== onClick || $[4] !== t2 || $[5] !== target || $[6] !== testId) {
                t3 = /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
                    testId: testId,
                    onClick: onClick,
                    href: href,
                    target: target,
                    ref: t2
                }, children);
                $[1] = children;
                $[2] = href;
                $[3] = onClick;
                $[4] = t2;
                $[5] = target;
                $[6] = testId;
                $[7] = t3;
            } else t3 = $[7];
            let t4;
            if ($[8] !== t1 || $[9] !== t3) {
                t4 = /*#__PURE__*/ $42omo.createElement("span", {
                    className: t1
                }, t3);
                $[8] = t1;
                $[9] = t3;
                $[10] = t4;
            } else t4 = $[10];
            return t4;
        }
        if (onClick) {
            let t1;
            if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = (0, $1Whri.cx)($25d55444a3e209b4$var$styles.common, $25d55444a3e209b4$var$styles.pressable, (0, $dh538.fg)("platform-dst-shape-theme-default") && $25d55444a3e209b4$var$styles.pressableT26Shape);
                $[11] = t1;
            } else t1 = $[11];
            const t2 = ref;
            let t3;
            if ($[12] !== children || $[13] !== onClick || $[14] !== t1 || $[15] !== t2 || $[16] !== testId) {
                t3 = /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
                    testId: testId,
                    onClick: onClick,
                    xcss: t1,
                    ref: t2
                }, children);
                $[12] = children;
                $[13] = onClick;
                $[14] = t1;
                $[15] = t2;
                $[16] = testId;
                $[17] = t3;
            } else t3 = $[17];
            return t3;
        }
        let t1;
        if ($[18] !== children || $[19] !== ref || $[20] !== testId) {
            t1 = /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
                as: "span",
                testId: testId,
                xcss: $25d55444a3e209b4$var$styles.common,
                ref: ref
            }, children);
            $[18] = children;
            $[19] = ref;
            $[20] = testId;
            $[21] = t1;
        } else t1 = $[21];
        return t1;
    }
    let t1;
    if ($[22] !== children || $[23] !== href || $[24] !== linkComponent || $[25] !== onClick || $[26] !== ref || $[27] !== testId) {
        t1 = onClick || href ? /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
            testId: testId,
            appearance: "link",
            spacing: "none",
            onClick: onClick,
            href: href,
            component: href ? linkComponent : undefined,
            ref: ref
        }, children) : /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, children);
        $[22] = children;
        $[23] = href;
        $[24] = linkComponent;
        $[25] = onClick;
        $[26] = ref;
        $[27] = testId;
        $[28] = t1;
    } else t1 = $[28];
    return t1;
} : function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent, target: target }, ref) {
    if (!linkComponent) {
        if (href) return /*#__PURE__*/ $42omo.createElement("span", {
            className: (0, $gMc0m.default)([
                $25d55444a3e209b4$var$styles.common,
                $25d55444a3e209b4$var$styles.anchor
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            testId: testId,
            onClick: onClick,
            href: href,
            target: target,
            ref: ref
        }, children));
        if (onClick) return /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $1Whri.cx)($25d55444a3e209b4$var$styles.common, $25d55444a3e209b4$var$styles.pressable, (0, $dh538.fg)('platform-dst-shape-theme-default') && $25d55444a3e209b4$var$styles.pressableT26Shape),
            ref: ref
        }, children);
        return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            as: "span",
            testId: testId,
            xcss: $25d55444a3e209b4$var$styles.common,
            ref: ref
        }, children);
    } // TODO: Remove this once the deprecated `linkComponent` prop is removed.
    return onClick || href ? /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        ref: ref
    }, children) : /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, children);
}));
$25d55444a3e209b4$var$SectionMessageAction.displayName = 'SectionMessageAction';
var $25d55444a3e209b4$export$2e2bcd8739ae039 = $25d55444a3e209b4$var$SectionMessageAction;
module.exports["default"] = $25d55444a3e209b4$export$2e2bcd8739ae039;

});

parcelRegister("i93lZ", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $4c0c6881799571d9$export$3351a8d90bcc13aa = {
    standard: 'gray',
    grey: 'gray',
    blue: 'blue',
    green: 'green',
    red: 'red',
    yellow: 'yellow',
    purple: 'purple',
    lime: 'lime',
    magenta: 'magenta',
    orange: 'orange',
    teal: 'teal',
    // Light variants map to same as their non-light counterparts
    greyLight: 'gray',
    blueLight: 'blue',
    greenLight: 'green',
    redLight: 'red',
    yellowLight: 'yellow',
    purpleLight: 'purple',
    limeLight: 'lime',
    magentaLight: 'magenta',
    orangeLight: 'orange',
    tealLight: 'teal'
};
module.exports["colorMapping"] = $4c0c6881799571d9$export$3351a8d90bcc13aa;

});

parcelRegister("bpQ0v", function(module, exports) {
$parcel$export(module.exports, "colorMapping", () => (parcelRequire("i93lZ")).colorMapping);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1bHXt = parcelRequire("1bHXt");


var $ghftu = parcelRequire("ghftu");


var $fVUfS = parcelRequire("fVUfS");


var $9hlns = parcelRequire("9hlns");


var $i93lZ = parcelRequire("i93lZ");


var $58wk0 = parcelRequire("58wk0");


var $gmCNH = parcelRequire("gmCNH");


var $bSHvo = parcelRequire("bSHvo");


var $kT1PP = parcelRequire("kT1PP");


var $l7uKY = parcelRequire("l7uKY");


var $dfX8r = parcelRequire("dfX8r");


var $dFVg2 = parcelRequire("dFVg2");


var $aaMcY = parcelRequire("aaMcY");

const $35e59b02847d5a98$var$styles = {
    baseStyles: "_zulp1b66 _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1rjcv77o _18zr1mie _1mou1b66 _195g1b66 _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3i1k92 _kqswh2mm _4cvr1h6o _80om73ad _bfhksm61",
    noMarginStyles: "_1mouze3t _195gze3t",
    removableStyles: "_zulp1b66",
    beforeStyles: "_4bfu1snc _1hmsagmp _ajmmvv82 _1e0c116y _4cvr1h6o _1o9zidpf _syaz125o",
    beforeStylesSelected: "_syazxl6c",
    textStyles: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n _1ul9idpf _syazi7uo",
    textStylesSelected: "_syaz6x5g",
    afterStyles: "_1e0c1txw _4cvr1h6o _1o9zidpf _lcxv1wug _kqswh2mm",
    trailingMetric: "_2rkolb4i _11c8wadc _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _4cvr1h6o _1o9zidpf _1kz6184x _bfhk1w9g _syazi7uo",
    trailingMetricEndPadding: "_y4ti303w",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _1all1b66 _qsdj1r31 _17ncglyw _15hpnqa1 _1rg815vq _1yoo15vq _j8j91snc _1afaagmp _gdbt10yn _h5vp116y _1qxz1h6o _8zx0idpf _1km4jdj5 _wc1fagmp _9408jdj5 _usew1snc _ebtnagmp _uvk910yn _10nj1r31 _1xq0glyw _18x1nqa1 _2mpsagmp",
    interactiveHoverStyles: "_17501r31 _qrsc8stv _1wodnqa1 _irr31dpa _rlyhjdj5 _1di6fcek"
};
// For accent borders, we use the new color.border.accent.*.subtle tokens (Color300
// light / Color800 dark) which provide proper decorative-border colours
//
// Icons keep color.icon.accent.* in the default state (vibrant on the plain page
// background) and swap to color.text.accent.* in hovered/pressed states (where the
// Tag picks up a coloured background and needs guaranteed 3:1 icon contrast).
const $35e59b02847d5a98$var$colorStyles = {
    gray: "_119bmsup _1ib21diz _egnk1sqi _17x31sqi _ih6z7qp0",
    blue: "_119b18hp _1ib26txe _egnk16jw _17x316jw _ih6z1dy8",
    green: "_119b5d2u _1ib217hp _egnkh55r _17x3h55r _ih6z1wnw",
    red: "_119bn9dc _1ib2nbxb _egnk9lu1 _17x39lu1 _ih6z1rtt",
    yellow: "_119b1s7j _1ib21oqg _egnkfb2s _17x3fb2s _ih6z1773",
    purple: "_119bluwt _1ib2uq3u _egnkqmo9 _17x3qmo9 _ih6z1nm4",
    lime: "_119b1m7d _1ib28645 _egnk1tco _17x31tco _ih6zz2ec",
    magenta: "_119b132u _1ib2v8hk _egnk1s8m _17x31s8m _ih6zv9ra",
    orange: "_119b1ip5 _1ib21j6y _egnkp1lv _17x3p1lv _ih6z165s",
    teal: "_119b131p _1ib28uof _egnk17qg _17x317qg _ih6z1a17"
}; // Border + icon filter styles - base state.
// Borders use the new color.border.accent.*.subtle tokens directly.
// Icons use the color.icon.accent.* tokens directly in the default state.
const $35e59b02847d5a98$var$borderIconFilterStyles = {
    root: "_1h6dip4g _wi6h9ea2"
}; // Border + icon filter styles - interactive states (hover/pressed).
// Icons swap to the color.text.accent.* tokens for guaranteed 3:1 contrast
// against the coloured interactive backgrounds. Borders stay constant.
const $35e59b02847d5a98$var$borderIconInteractiveFilterStyles = {
    root: "_4cvxip4g _zqoiipvw _q4ztip4g _ba35u0j8"
};
const $35e59b02847d5a98$var$dropdownStyles = {
    interactive: "_irr31dpa _1di6fcek",
    selected: "_1h6dq98m _syaz6x5g _bfhk15s3 _irr3ufnl _1di6nozp",
    content: "_zulp1b66 _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf",
    loadingContent: "_tzy4idpf",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw"
}; /**
    * __TagNew__
    *
    * TagNew is the visual uplift implementation of Tag
    */ 
const $35e59b02847d5a98$var$TagNewComponent = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? function TagNew(t0, ref) {
    const $ = (0, $frIzR.c)(81);
    let elemBefore;
    let href;
    let linkComponent;
    let maxWidth;
    let onAfterRemoveAction;
    let onBeforeRemoveAction;
    let onClick;
    let other;
    let removeButtonLabel;
    let swatchBefore;
    let t1;
    let t2;
    let t3;
    let testId;
    let text;
    let trailingMetric;
    if ($[0] !== t0) {
        ({ color: t1, text: text, elemBefore: elemBefore, href: href, linkComponent: linkComponent, isRemovable: t2, removeButtonLabel: removeButtonLabel, onBeforeRemoveAction: onBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction, testId: testId, maxWidth: maxWidth, hasMargin: t3, onClick: onClick, swatchBefore: swatchBefore, trailingMetric: trailingMetric, ...other } = t0);
        $[0] = t0;
        $[1] = elemBefore;
        $[2] = href;
        $[3] = linkComponent;
        $[4] = maxWidth;
        $[5] = onAfterRemoveAction;
        $[6] = onBeforeRemoveAction;
        $[7] = onClick;
        $[8] = other;
        $[9] = removeButtonLabel;
        $[10] = swatchBefore;
        $[11] = t1;
        $[12] = t2;
        $[13] = t3;
        $[14] = testId;
        $[15] = text;
        $[16] = trailingMetric;
    } else {
        elemBefore = $[1];
        href = $[2];
        linkComponent = $[3];
        maxWidth = $[4];
        onAfterRemoveAction = $[5];
        onBeforeRemoveAction = $[6];
        onClick = $[7];
        other = $[8];
        removeButtonLabel = $[9];
        swatchBefore = $[10];
        t1 = $[11];
        t2 = $[12];
        t3 = $[13];
        testId = $[14];
        text = $[15];
        trailingMetric = $[16];
    }
    const color = t1 === undefined ? "gray" : t1;
    const isRemovable = t2 === undefined ? true : t2;
    const hasMargin = t3 === undefined ? true : t3;
    let t4;
    if ($[17] !== text) {
        t4 = (0, $58wk0.getTagText)(text);
        $[17] = text;
        $[18] = t4;
    } else t4 = $[18];
    const normalizedText = t4;
    const { status: status, handleRemoveRequest: handleRemoveRequest, onKeyPress: onKeyPress, removingTag: removingTag, showingTag: showingTag } = (0, $aaMcY.useTagRemoval)(onBeforeRemoveAction);
    let t5;
    if ($[19] !== normalizedText || $[20] !== onAfterRemoveAction) {
        t5 = ()=>{
            onAfterRemoveAction?.(normalizedText);
        };
        $[19] = normalizedText;
        $[20] = onAfterRemoveAction;
        $[21] = t5;
    } else t5 = $[21];
    const onShrinkOutExitComplete = t5;
    const { isLink: isLink, LinkComponent: LinkComponent } = (0, $dfX8r.useLink)(href, linkComponent);
    const { isLinkHovered: isLinkHovered, isOverButton: isOverButton, isButtonFocused: isButtonFocused, isLinkFocused: isLinkFocused, buttonHandlers: buttonHandlers, linkHandlers: linkHandlers } = (0, $l7uKY.useButtonInteraction)();
    let t6;
    if ($[22] !== buttonHandlers || $[23] !== handleRemoveRequest || $[24] !== isRemovable || $[25] !== normalizedText || $[26] !== onKeyPress || $[27] !== removeButtonLabel || $[28] !== removingTag || $[29] !== showingTag || $[30] !== testId) {
        t6 = {
            isRemovable: isRemovable,
            tagText: normalizedText,
            removeButtonLabel: removeButtonLabel,
            testId: testId,
            handleRemoveRequest: handleRemoveRequest,
            removingTag: removingTag,
            showingTag: showingTag,
            onKeyPress: onKeyPress,
            buttonHandlers: buttonHandlers
        };
        $[22] = buttonHandlers;
        $[23] = handleRemoveRequest;
        $[24] = isRemovable;
        $[25] = normalizedText;
        $[26] = onKeyPress;
        $[27] = removeButtonLabel;
        $[28] = removingTag;
        $[29] = showingTag;
        $[30] = testId;
        $[31] = t6;
    } else t6 = $[31];
    const removeButton = (0, $dFVg2.useRemoveButton)(t6);
    let t7;
    if ($[32] !== maxWidth) {
        t7 = maxWidth !== undefined ? {
            maxWidth: maxWidth
        } : undefined;
        $[32] = maxWidth;
        $[33] = t7;
    } else t7 = $[33];
    const t8 = !hasMargin && $35e59b02847d5a98$var$styles.noMarginStyles;
    const t9 = $35e59b02847d5a98$var$colorStyles[color];
    const t10 = isLink && $35e59b02847d5a98$var$styles.interactiveBaseStyles;
    const t11 = isLink && $35e59b02847d5a98$var$styles.focusRingStyles;
    const t12 = isLink && isLinkHovered && !isOverButton && $35e59b02847d5a98$var$borderIconInteractiveFilterStyles.root;
    const t13 = isLink && isLinkHovered && !isOverButton && $35e59b02847d5a98$var$styles.interactiveHoverStyles;
    const t14 = isRemovable && $35e59b02847d5a98$var$styles.removableStyles;
    const t15 = isLinkFocused && !isButtonFocused && $35e59b02847d5a98$var$styles.childFocusRingStyles;
    const t16 = !isRemovable && trailingMetric != null && trailingMetric !== "" && $35e59b02847d5a98$var$styles.trailingMetricEndPadding;
    let t17;
    if ($[34] !== t10 || $[35] !== t11 || $[36] !== t12 || $[37] !== t13 || $[38] !== t14 || $[39] !== t15 || $[40] !== t16 || $[41] !== t8 || $[42] !== t9) {
        t17 = (0, $gMc0m.default)([
            $35e59b02847d5a98$var$styles.baseStyles,
            t8,
            t9,
            $35e59b02847d5a98$var$borderIconFilterStyles.root,
            t10,
            t11,
            t12,
            t13,
            t14,
            t15,
            t16
        ]);
        $[34] = t10;
        $[35] = t11;
        $[36] = t12;
        $[37] = t13;
        $[38] = t14;
        $[39] = t15;
        $[40] = t16;
        $[41] = t8;
        $[42] = t9;
        $[43] = t17;
    } else t17 = $[43];
    const t18 = onClick;
    let t19;
    if ($[44] !== color || $[45] !== swatchBefore) {
        t19 = /*#__PURE__*/ $42omo.createElement((0, $kT1PP.default), {
            colorKey: color,
            swatchBefore: swatchBefore
        });
        $[44] = color;
        $[45] = swatchBefore;
        $[46] = t19;
    } else t19 = $[46];
    let t20;
    if ($[47] !== elemBefore) {
        t20 = elemBefore && /*#__PURE__*/ $42omo.createElement("span", {
            className: (0, $gMc0m.default)([
                $35e59b02847d5a98$var$styles.beforeStyles
            ])
        }, elemBefore);
        $[47] = elemBefore;
        $[48] = t20;
    } else t20 = $[48];
    let t21;
    if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = (0, $gMc0m.default)([
            $35e59b02847d5a98$var$styles.textStyles
        ]);
        $[49] = t21;
    } else t21 = $[49];
    let t22;
    if ($[50] !== normalizedText) {
        t22 = /*#__PURE__*/ $42omo.createElement("span", {
            "data-tag-text": true,
            className: t21
        }, normalizedText);
        $[50] = normalizedText;
        $[51] = t22;
    } else t22 = $[51];
    let t23;
    if ($[52] !== testId || $[53] !== trailingMetric) {
        t23 = trailingMetric != null && trailingMetric !== "" && /*#__PURE__*/ $42omo.createElement("span", {
            "data-testid": testId && `${testId}--metric`,
            className: (0, $gMc0m.default)([
                $35e59b02847d5a98$var$styles.trailingMetric
            ])
        }, trailingMetric);
        $[52] = testId;
        $[53] = trailingMetric;
        $[54] = t23;
    } else t23 = $[54];
    let t24;
    if ($[55] !== LinkComponent || $[56] !== href || $[57] !== isLink || $[58] !== linkHandlers || $[59] !== t18 || $[60] !== t19 || $[61] !== t20 || $[62] !== t22 || $[63] !== t23 || $[64] !== testId) {
        t24 = /*#__PURE__*/ $42omo.createElement((0, $gmCNH.LinkWrapper), {
            isLink: isLink,
            href: href,
            LinkComponent: LinkComponent,
            testId: testId,
            linkHandlers: linkHandlers,
            onClick: t18
        }, t19, t20, t22, t23);
        $[55] = LinkComponent;
        $[56] = href;
        $[57] = isLink;
        $[58] = linkHandlers;
        $[59] = t18;
        $[60] = t19;
        $[61] = t20;
        $[62] = t22;
        $[63] = t23;
        $[64] = testId;
        $[65] = t24;
    } else t24 = $[65];
    let t25;
    if ($[66] !== removeButton) {
        t25 = removeButton && /*#__PURE__*/ $42omo.createElement("span", {
            className: (0, $gMc0m.default)([
                $35e59b02847d5a98$var$styles.afterStyles
            ])
        }, removeButton);
        $[66] = removeButton;
        $[67] = t25;
    } else t25 = $[67];
    let t26;
    if ($[68] !== other || $[69] !== ref || $[70] !== t17 || $[71] !== t24 || $[72] !== t25 || $[73] !== t7 || $[74] !== testId) {
        t26 = /*#__PURE__*/ $42omo.createElement("span", {
            ...other,
            ref: ref,
            "data-testid": testId,
            style: t7,
            className: t17
        }, t24, t25);
        $[68] = other;
        $[69] = ref;
        $[70] = t17;
        $[71] = t24;
        $[72] = t25;
        $[73] = t7;
        $[74] = testId;
        $[75] = t26;
    } else t26 = $[75];
    const tagContent = t26;
    const t27 = isRemovable ? onShrinkOutExitComplete : undefined;
    let t28;
    if ($[76] !== isRemovable || $[77] !== status || $[78] !== t27 || $[79] !== tagContent) {
        t28 = /*#__PURE__*/ $42omo.createElement((0, $bSHvo.RemovableWrapper), {
            isRemovable: isRemovable,
            status: status,
            onShrinkOutExitComplete: t27
        }, tagContent);
        $[76] = isRemovable;
        $[77] = status;
        $[78] = t27;
        $[79] = tagContent;
        $[80] = t28;
    } else t28 = $[80];
    return t28;
} : function TagNew({ color: color = 'gray', text: text, elemBefore: elemBefore, href: href, linkComponent: linkComponent, isRemovable: isRemovable = true, removeButtonLabel: removeButtonLabel, onBeforeRemoveAction: onBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction, testId: testId, maxWidth: maxWidth, hasMargin: hasMargin = true, onClick: onClick, swatchBefore: swatchBefore, trailingMetric: trailingMetric, ...other }, ref) {
    const normalizedText = (0, $58wk0.getTagText)(text);
    const { status: status, handleRemoveRequest: handleRemoveRequest, onKeyPress: onKeyPress, removingTag: removingTag, showingTag: showingTag } = (0, $aaMcY.useTagRemoval)(onBeforeRemoveAction);
    const onShrinkOutExitComplete = (0, $42omo.useCallback)(()=>{
        onAfterRemoveAction?.(normalizedText);
    }, [
        normalizedText,
        onAfterRemoveAction
    ]);
    const { isLink: isLink, LinkComponent: LinkComponent } = (0, $dfX8r.useLink)(href, linkComponent);
    const { isLinkHovered: isLinkHovered, isOverButton: isOverButton, isButtonFocused: isButtonFocused, isLinkFocused: isLinkFocused, buttonHandlers: buttonHandlers, linkHandlers: linkHandlers } = (0, $l7uKY.useButtonInteraction)();
    const removeButton = (0, $dFVg2.useRemoveButton)({
        isRemovable: isRemovable,
        tagText: normalizedText,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        buttonHandlers: buttonHandlers
    });
    const tagContent = /*#__PURE__*/ $42omo.createElement("span", {
        ...other,
        ref: ref,
        "data-testid": testId,
        style: maxWidth !== undefined ? {
            maxWidth: maxWidth
        } : undefined,
        className: (0, $gMc0m.default)([
            $35e59b02847d5a98$var$styles.baseStyles,
            !hasMargin && $35e59b02847d5a98$var$styles.noMarginStyles,
            $35e59b02847d5a98$var$colorStyles[color],
            $35e59b02847d5a98$var$borderIconFilterStyles.root,
            isLink && $35e59b02847d5a98$var$styles.interactiveBaseStyles,
            isLink && $35e59b02847d5a98$var$styles.focusRingStyles,
            isLink && isLinkHovered && !isOverButton && $35e59b02847d5a98$var$borderIconInteractiveFilterStyles.root,
            isLink && isLinkHovered && !isOverButton && $35e59b02847d5a98$var$styles.interactiveHoverStyles,
            isRemovable && $35e59b02847d5a98$var$styles.removableStyles,
            isLinkFocused && !isButtonFocused && $35e59b02847d5a98$var$styles.childFocusRingStyles,
            !isRemovable && trailingMetric != null && trailingMetric !== '' && $35e59b02847d5a98$var$styles.trailingMetricEndPadding
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $gmCNH.LinkWrapper), {
        isLink: isLink,
        href: href,
        LinkComponent: LinkComponent,
        testId: testId,
        linkHandlers: linkHandlers,
        onClick: onClick
    }, /*#__PURE__*/ $42omo.createElement((0, $kT1PP.default), {
        colorKey: color,
        swatchBefore: swatchBefore
    }), elemBefore && /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            $35e59b02847d5a98$var$styles.beforeStyles
        ])
    }, elemBefore), /*#__PURE__*/ $42omo.createElement("span", {
        "data-tag-text": true,
        className: (0, $gMc0m.default)([
            $35e59b02847d5a98$var$styles.textStyles
        ])
    }, normalizedText), trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": testId && `${testId}--metric`,
        className: (0, $gMc0m.default)([
            $35e59b02847d5a98$var$styles.trailingMetric
        ])
    }, trailingMetric)), removeButton && /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            $35e59b02847d5a98$var$styles.afterStyles
        ])
    }, removeButton));
    return /*#__PURE__*/ $42omo.createElement((0, $bSHvo.RemovableWrapper), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined
    }, tagContent);
}); // Put the tag dropdown trigger in this file to reuse the styles
const $35e59b02847d5a98$export$aba6bd1190e79361 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? function TagDropdownTrigger(t0, ref) {
    const $ = (0, $frIzR.c)(66);
    let elemBefore;
    let maxWidth;
    let onClick;
    let other;
    let swatchBefore;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let testId;
    let text;
    let trailingMetric;
    if ($[0] !== t0) {
        const { color: t6, text: t7, elemBefore: t8, testId: t9, maxWidth: t10, hasMargin: t11, onClick: t12, isSelected: t13, isLoading: t14, analyticsContext: _analyticsContext, hasChevron: t15, swatchBefore: t16, trailingMetric: t17, ...t18 } = t0;
        t1 = t6;
        text = t7;
        elemBefore = t8;
        testId = t9;
        maxWidth = t10;
        t2 = t11;
        onClick = t12;
        t3 = t13;
        t4 = t14;
        t5 = t15;
        swatchBefore = t16;
        trailingMetric = t17;
        other = t18;
        $[0] = t0;
        $[1] = elemBefore;
        $[2] = maxWidth;
        $[3] = onClick;
        $[4] = other;
        $[5] = swatchBefore;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = testId;
        $[12] = text;
        $[13] = trailingMetric;
    } else {
        elemBefore = $[1];
        maxWidth = $[2];
        onClick = $[3];
        other = $[4];
        swatchBefore = $[5];
        t1 = $[6];
        t2 = $[7];
        t3 = $[8];
        t4 = $[9];
        t5 = $[10];
        testId = $[11];
        text = $[12];
        trailingMetric = $[13];
    }
    const color = t1 === undefined ? "gray" : t1;
    const hasMargin = t2 === undefined ? true : t2;
    const isSelected = t3 === undefined ? false : t3;
    const isLoading = t4 === undefined ? false : t4;
    const hasChevron = t5 === undefined ? true : t5;
    const resolvedColor = (0, $i93lZ.colorMapping)[color] || "gray";
    const t6 = !hasMargin && $35e59b02847d5a98$var$styles.noMarginStyles;
    const t7 = $35e59b02847d5a98$var$colorStyles[resolvedColor];
    const t8 = isSelected && $35e59b02847d5a98$var$dropdownStyles.selected;
    const t9 = !hasChevron && trailingMetric != null && trailingMetric !== "" && $35e59b02847d5a98$var$styles.trailingMetricEndPadding;
    let t10;
    if ($[14] !== t6 || $[15] !== t7 || $[16] !== t8 || $[17] !== t9) {
        t10 = (0, $1bHXt.cx)($35e59b02847d5a98$var$styles.baseStyles, t6, t7, $35e59b02847d5a98$var$borderIconFilterStyles.root, $35e59b02847d5a98$var$dropdownStyles.interactive, $35e59b02847d5a98$var$styles.focusRingStyles, $35e59b02847d5a98$var$borderIconInteractiveFilterStyles.root, t8, t9);
        $[14] = t6;
        $[15] = t7;
        $[16] = t8;
        $[17] = t9;
        $[18] = t10;
    } else t10 = $[18];
    const t11 = isLoading ? undefined : onClick;
    const t12 = isSelected ? "var(--ds-border-selected, #1868DB)" : undefined;
    const t13 = isLoading ? "progress" : "pointer";
    const t14 = maxWidth !== undefined ? maxWidth : undefined;
    let t15;
    if ($[19] !== t12 || $[20] !== t13 || $[21] !== t14) {
        t15 = {
            borderColor: t12,
            cursor: t13,
            maxWidth: t14
        };
        $[19] = t12;
        $[20] = t13;
        $[21] = t14;
        $[22] = t15;
    } else t15 = $[22];
    let t16;
    if ($[23] !== isLoading) {
        t16 = isLoading && {
            "aria-busy": true,
            "aria-disabled": true,
            isDisabled: true
        };
        $[23] = isLoading;
        $[24] = t16;
    } else t16 = $[24];
    const t17 = isLoading && $35e59b02847d5a98$var$dropdownStyles.loadingContent;
    let t18;
    if ($[25] !== t17) {
        t18 = (0, $gMc0m.default)([
            $35e59b02847d5a98$var$dropdownStyles.content,
            t17
        ]);
        $[25] = t17;
        $[26] = t18;
    } else t18 = $[26];
    let t19;
    if ($[27] !== resolvedColor || $[28] !== swatchBefore) {
        t19 = /*#__PURE__*/ $42omo.createElement((0, $kT1PP.default), {
            colorKey: resolvedColor,
            swatchBefore: swatchBefore
        });
        $[27] = resolvedColor;
        $[28] = swatchBefore;
        $[29] = t19;
    } else t19 = $[29];
    let t20;
    if ($[30] !== elemBefore || $[31] !== isSelected) {
        t20 = elemBefore && /*#__PURE__*/ $42omo.createElement("span", {
            className: (0, $gMc0m.default)([
                $35e59b02847d5a98$var$styles.beforeStyles,
                isSelected && $35e59b02847d5a98$var$styles.beforeStylesSelected
            ])
        }, elemBefore);
        $[30] = elemBefore;
        $[31] = isSelected;
        $[32] = t20;
    } else t20 = $[32];
    const t21 = isSelected && $35e59b02847d5a98$var$styles.textStylesSelected;
    let t22;
    if ($[33] !== t21) {
        t22 = (0, $gMc0m.default)([
            $35e59b02847d5a98$var$styles.textStyles,
            t21
        ]);
        $[33] = t21;
        $[34] = t22;
    } else t22 = $[34];
    let t23;
    if ($[35] !== text) {
        t23 = (0, $58wk0.getTagText)(text);
        $[35] = text;
        $[36] = t23;
    } else t23 = $[36];
    let t24;
    if ($[37] !== t22 || $[38] !== t23) {
        t24 = /*#__PURE__*/ $42omo.createElement("span", {
            "data-tag-text": true,
            className: t22
        }, t23);
        $[37] = t22;
        $[38] = t23;
        $[39] = t24;
    } else t24 = $[39];
    let t25;
    if ($[40] !== testId || $[41] !== trailingMetric) {
        t25 = trailingMetric != null && trailingMetric !== "" && /*#__PURE__*/ $42omo.createElement("span", {
            "data-testid": testId && `${testId}--metric`,
            className: (0, $gMc0m.default)([
                $35e59b02847d5a98$var$styles.trailingMetric
            ])
        }, trailingMetric);
        $[40] = testId;
        $[41] = trailingMetric;
        $[42] = t25;
    } else t25 = $[42];
    let t26;
    if ($[43] !== hasChevron || $[44] !== testId) {
        t26 = hasChevron && /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            size: "small",
            color: "currentColor",
            testId: testId && `${testId}--chevron`
        });
        $[43] = hasChevron;
        $[44] = testId;
        $[45] = t26;
    } else t26 = $[45];
    let t27;
    if ($[46] !== t18 || $[47] !== t19 || $[48] !== t20 || $[49] !== t24 || $[50] !== t25 || $[51] !== t26) {
        t27 = /*#__PURE__*/ $42omo.createElement("span", {
            className: t18
        }, t19, t20, t24, t25, t26);
        $[46] = t18;
        $[47] = t19;
        $[48] = t20;
        $[49] = t24;
        $[50] = t25;
        $[51] = t26;
        $[52] = t27;
    } else t27 = $[52];
    let t28;
    if ($[53] !== isLoading || $[54] !== testId) {
        t28 = isLoading && /*#__PURE__*/ $42omo.createElement("span", {
            className: (0, $gMc0m.default)([
                $35e59b02847d5a98$var$dropdownStyles.loadingOverlay
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
            size: "xsmall",
            label: ", Loading",
            testId: testId ? `${testId}--loading-spinner` : undefined
        }));
        $[53] = isLoading;
        $[54] = testId;
        $[55] = t28;
    } else t28 = $[55];
    let t29;
    if ($[56] !== other || $[57] !== ref || $[58] !== t10 || $[59] !== t11 || $[60] !== t15 || $[61] !== t16 || $[62] !== t27 || $[63] !== t28 || $[64] !== testId) {
        t29 = /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
            ref: ref,
            xcss: t10,
            onClick: t11,
            style: t15,
            ...t16,
            testId: testId,
            ...other
        }, t27, t28);
        $[56] = other;
        $[57] = ref;
        $[58] = t10;
        $[59] = t11;
        $[60] = t15;
        $[61] = t16;
        $[62] = t27;
        $[63] = t28;
        $[64] = testId;
        $[65] = t29;
    } else t29 = $[65];
    return t29;
} : function TagDropdownTrigger({ color: color = 'gray', text: text, elemBefore: elemBefore, testId: testId, maxWidth: maxWidth, hasMargin: hasMargin = true, onClick: onClick, isSelected: isSelected = false, isLoading: isLoading = false, analyticsContext: _analyticsContext, hasChevron: hasChevron = true, swatchBefore: swatchBefore, trailingMetric: trailingMetric, ...other }, ref) {
    const resolvedColor = (0, $i93lZ.colorMapping)[color] || 'gray';
    return /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        ref: ref,
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $1bHXt.cx)($35e59b02847d5a98$var$styles.baseStyles, !hasMargin && $35e59b02847d5a98$var$styles.noMarginStyles, $35e59b02847d5a98$var$colorStyles[resolvedColor], $35e59b02847d5a98$var$borderIconFilterStyles.root, $35e59b02847d5a98$var$dropdownStyles.interactive, $35e59b02847d5a98$var$styles.focusRingStyles, $35e59b02847d5a98$var$borderIconInteractiveFilterStyles.root, isSelected && $35e59b02847d5a98$var$dropdownStyles.selected, // Reduce end padding when trailing metric is the last element (no chevron)
        !hasChevron && trailingMetric != null && trailingMetric !== '' && $35e59b02847d5a98$var$styles.trailingMetricEndPadding),
        onClick: isLoading ? undefined : onClick,
        style: {
            borderColor: isSelected ? "var(--ds-border-selected, #1868DB)" : undefined,
            cursor: isLoading ? 'progress' : 'pointer',
            maxWidth: maxWidth !== undefined ? maxWidth : undefined
        },
        ...isLoading && {
            'aria-busy': true,
            'aria-disabled': true,
            isDisabled: true
        },
        testId: testId,
        ...other
    }, /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            $35e59b02847d5a98$var$dropdownStyles.content,
            isLoading && $35e59b02847d5a98$var$dropdownStyles.loadingContent
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $kT1PP.default), {
        colorKey: resolvedColor,
        swatchBefore: swatchBefore
    }), elemBefore && /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            $35e59b02847d5a98$var$styles.beforeStyles,
            isSelected && $35e59b02847d5a98$var$styles.beforeStylesSelected
        ])
    }, elemBefore), /*#__PURE__*/ $42omo.createElement("span", {
        "data-tag-text": true,
        className: (0, $gMc0m.default)([
            $35e59b02847d5a98$var$styles.textStyles,
            isSelected && $35e59b02847d5a98$var$styles.textStylesSelected
        ])
    }, (0, $58wk0.getTagText)(text)), trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": testId && `${testId}--metric`,
        className: (0, $gMc0m.default)([
            $35e59b02847d5a98$var$styles.trailingMetric
        ])
    }, trailingMetric), hasChevron && /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && `${testId}--chevron`
    })), isLoading && /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            $35e59b02847d5a98$var$dropdownStyles.loadingOverlay
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
        size: 'xsmall',
        label: ", Loading",
        testId: testId ? `${testId}--loading-spinner` : undefined
    })));
}); /**
     * __Tag new__
     */ 
const $35e59b02847d5a98$var$TagNew = /*#__PURE__*/ (0, $42omo.memo)($35e59b02847d5a98$var$TagNewComponent); // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $35e59b02847d5a98$export$2e2bcd8739ae039 = $35e59b02847d5a98$var$TagNew;
module.exports["default"] = $35e59b02847d5a98$export$2e2bcd8739ae039;

});

parcelRegister("8dG3J", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $c594c0560f0f9d56$var$borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
const $c594c0560f0f9d56$var$baseStyles = null;
const $c594c0560f0f9d56$var$interactiveStyles = null;
const $c594c0560f0f9d56$var$focusRingStyles = null;
const $c594c0560f0f9d56$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((0, $4pOgL.isReactCompilerActivePlatform)() ? function BaseTag(t0, ref) {
    const $ = (0, $frIzR.c)(26);
    let after;
    let before;
    let className;
    let contentElement;
    let href;
    let other;
    let style;
    let t1;
    let testId;
    if ($[0] !== t0) {
        ({ before: before, contentElement: contentElement, after: after, testId: testId, style: style, color: t1, href: href, className: className, ...other } = t0);
        $[0] = t0;
        $[1] = after;
        $[2] = before;
        $[3] = className;
        $[4] = contentElement;
        $[5] = href;
        $[6] = other;
        $[7] = style;
        $[8] = t1;
        $[9] = testId;
    } else {
        after = $[1];
        before = $[2];
        className = $[3];
        contentElement = $[4];
        href = $[5];
        other = $[6];
        style = $[7];
        t1 = $[8];
        testId = $[9];
    }
    let color = t1 === undefined ? "standard" : t1;
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    if (color === "gray") color = "grey";
    let t2;
    if ($[10] !== style) {
        t2 = {
            ...style
        };
        $[10] = style;
        $[11] = t2;
    } else t2 = $[11];
    const t3 = t2;
    const t4 = isInteractive && "_1e38dfik _7glxv77o";
    const t5 = isLink && "_irr31dpa _1di6fcek";
    const t6 = $c594c0560f0f9d56$var$borderColors[color];
    let t7;
    if ($[12] !== className || $[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
        t7 = (0, $gMc0m.default)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3i1k92 _kqswh2mm _4cvr1h6o _bfhksm61 _syazi7uo _80om73ad",
            t4,
            t5,
            t6,
            className
        ]);
        $[12] = className;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== after || $[18] !== before || $[19] !== contentElement || $[20] !== other || $[21] !== ref || $[22] !== t3 || $[23] !== t7 || $[24] !== testId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            ...other,
            ref: ref,
            style: t3,
            className: t7,
            "data-testid": testId
        }, before, contentElement, after);
        $[17] = after;
        $[18] = before;
        $[19] = contentElement;
        $[20] = other;
        $[21] = ref;
        $[22] = t3;
        $[23] = t7;
        $[24] = testId;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
} : function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    if (color === 'gray') // internally we use 'grey' for gray color so that we can make migration easier behind the ff (gray will work with and without ff now)
    color = 'grey';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ...other,
        ref: ref,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        className: (0, $gMc0m.default)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3i1k92 _kqswh2mm _4cvr1h6o _bfhksm61 _syazi7uo _80om73ad",
            isInteractive && "_1e38dfik _7glxv77o",
            isLink && "_irr31dpa _1di6fcek",
            $c594c0560f0f9d56$var$borderColors[color],
            className
        ]),
        "data-testid": testId
    }, before, contentElement, after);
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $c594c0560f0f9d56$export$2e2bcd8739ae039 = $c594c0560f0f9d56$var$BaseTag;
module.exports["default"] = $c594c0560f0f9d56$export$2e2bcd8739ae039;

});

parcelRegister("kHF6o", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $9081fbaab560dd68$var$beforeElementStyles = null;
const $9081fbaab560dd68$var$Before = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { elemBefore: elemBefore } = t0;
    let t1;
    if ($[0] !== elemBefore) {
        t1 = elemBefore ? /*#__PURE__*/ $42omo.createElement("span", {
            className: (0, $gMc0m.default)([
                "_1e0c1txw _4t3i1j6v _4cvr1h6o _1bah1h6o _152tze3t"
            ])
        }, elemBefore) : null;
        $[0] = elemBefore;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4t3i1j6v _4cvr1h6o _1bah1h6o _152tze3t"
        ])
    }, elemBefore) : null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $9081fbaab560dd68$export$2e2bcd8739ae039 = $9081fbaab560dd68$var$Before;
module.exports["default"] = $9081fbaab560dd68$export$2e2bcd8739ae039;

});

parcelRegister("4009b", function(module, exports) {
/**
 * Maps Tag color values to Lozenge appearance values.
 * Used for migration_fallback rendering when feature flag is off.
 */ const $ff09199a85d0bb87$var$colorToLozengeAppearanceMap = {
    gray: 'default',
    grey: 'default',
    lime: 'success',
    green: 'success',
    blue: 'inprogress',
    red: 'removed',
    purple: 'new',
    yellow: 'moved',
    orange: 'moved',
    magenta: 'new',
    teal: 'inprogress',
    grayLight: 'default',
    greyLight: 'default',
    limeLight: 'success',
    greenLight: 'success',
    blueLight: 'inprogress',
    redLight: 'removed',
    purpleLight: 'new',
    yellowLight: 'moved',
    orangeLight: 'moved',
    magentaLight: 'new',
    tealLight: 'inprogress'
};
function $ff09199a85d0bb87$export$4d9e331cafeacb9d(color) {
    return $ff09199a85d0bb87$var$colorToLozengeAppearanceMap[color || 'gray'] || 'default';
}
module.exports["getLozengeAppearance"] = $ff09199a85d0bb87$export$4d9e331cafeacb9d;

});

parcelRegister("lJT0z", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $58wk0 = parcelRequire("58wk0");

const $2634609f11ac6695$var$baseStyles = null;
const $2634609f11ac6695$var$linkStyles = null;
const $2634609f11ac6695$var$hasAfterStyles = null;
const $2634609f11ac6695$var$Content = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { isRemovable: t1, text: t2, color: t3, href: href, linkComponent: linkComponent, testId: testId } = t0;
    const isRemovable = t1 === undefined ? true : t1;
    const text = t2 === undefined ? "" : t2;
    const color = t3 === undefined ? "standard" : t3;
    const Link = linkComponent ?? "a";
    let t4;
    if ($[0] !== text) {
        t4 = (0, $58wk0.getTagText)(text);
        $[0] = text;
        $[1] = t4;
    } else t4 = $[1];
    const normalizedText = t4;
    if (href) {
        const t5 = testId ? `${testId}--link` : undefined;
        const t6 = isRemovable && "_p12f1lit";
        let t7;
        if ($[2] !== t6) {
            t7 = (0, $gMc0m.default)([
                "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
                "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazi7uo _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
                t6
            ]);
            $[2] = t6;
            $[3] = t7;
        } else t7 = $[3];
        let t8;
        if ($[4] !== Link || $[5] !== color || $[6] !== href || $[7] !== normalizedText || $[8] !== t5 || $[9] !== t7) {
            t8 = /*#__PURE__*/ $42omo.createElement(Link, {
                href: href,
                "data-color": color,
                "data-testid": t5,
                className: t7
            }, normalizedText);
            $[4] = Link;
            $[5] = color;
            $[6] = href;
            $[7] = normalizedText;
            $[8] = t5;
            $[9] = t7;
            $[10] = t8;
        } else t8 = $[10];
        return t8;
    } else {
        const t5 = isRemovable && "_p12f1lit";
        let t6;
        if ($[11] !== t5) {
            t6 = (0, $gMc0m.default)([
                "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
                t5
            ]);
            $[11] = t5;
            $[12] = t6;
        } else t6 = $[12];
        let t7;
        if ($[13] !== normalizedText || $[14] !== t6) {
            t7 = /*#__PURE__*/ $42omo.createElement("span", {
                className: t6
            }, normalizedText);
            $[13] = normalizedText;
            $[14] = t6;
            $[15] = t7;
        } else t7 = $[15];
        return t7;
    }
} : ({ isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent, testId: testId })=>{
    const Link = linkComponent ?? 'a';
    const normalizedText = (0, $58wk0.getTagText)(text);
    if (href) return /*#__PURE__*/ $42omo.createElement(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? `${testId}--link` : undefined,
        className: (0, $gMc0m.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazi7uo _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
            isRemovable && "_p12f1lit"
        ])
    }, normalizedText);
    else return /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ])
    }, normalizedText);
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $2634609f11ac6695$export$2e2bcd8739ae039 = $2634609f11ac6695$var$Content;
module.exports["default"] = $2634609f11ac6695$export$2e2bcd8739ae039;

});

parcelRegister("dKLHc", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8Cy4Y = parcelRequire("8Cy4Y");


var $1Whri = parcelRequire("1Whri");


var $ghftu = parcelRequire("ghftu");


var $19w2x = parcelRequire("19w2x");


var $dh538 = parcelRequire("dh538");


var $2W0qg = parcelRequire("2W0qg");


var $9hlns = parcelRequire("9hlns");


var $kLDYa = parcelRequire("kLDYa");


var $gJRGK = parcelRequire("gJRGK");


var $i52dL = parcelRequire("i52dL");

const $b79a7ce738636669$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
const $b79a7ce738636669$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1j28 _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    motionContainer: "_k8m01rje _1oeci9qs _6fl41d08",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _o5721q9c",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    metricBadgeWrapper: "_1e0c1txw",
    'semantic.success': "_3wu02gvx _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_3wu01wfx _bfhk10f4 _syazmgs1",
    'semantic.danger': "_3wu01mzp _bfhk18wg _syaz1blx",
    'semantic.information': "_3wu0wn4u _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_3wu01l7x _bfhki8nm _syazi7uo",
    'semantic.discovery': "_3wu019v3 _bfhke670 _syaz1g72",
    'accent.red': "_3wu0n9dc _bfhk1rtt _syazhwvp",
    'accent.orange': "_3wu01ip5 _bfhk165s _syaz7i1p",
    'accent.yellow': "_3wu01s7j _bfhk1773 _syazekll",
    'accent.lime': "_3wu01m7d _bfhkz2ec _syaz1ik3",
    'accent.green': "_3wu05d2u _bfhk1wnw _syaz1y78",
    'accent.teal': "_3wu0131p _bfhk1a17 _syaz12v7",
    'accent.blue': "_3wu018hp _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_3wu0luwt _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_3wu0132u _bfhkv9ra _syaz1qur",
    'accent.gray': "_3wu01l7x _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6d74of",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    maxWidth: "_p12f1osq",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    containerBadgePressed: "_1axmtoke _17i7toke",
    containerBadgeNeutralAppearance: "_1ftrnkaw _1axmnkaw _17i7nkaw"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ const $b79a7ce738636669$var$LozengeBase = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(101);
    const { children: children, testId: testId, appearance: appearance, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance, maxWidth: t1, spacing: t2, isSelected: isSelected, isLoading: t3, onClick: onClick, style: style, analyticsContext: analyticsContext, interactionName: interactionName, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHaspopup, "aria-label": ariaLabel } = t0;
    const maxWidth = t1 === undefined ? 200 : t1;
    const spacing = t2 === undefined ? "default" : t2;
    const isLoading = t3 === undefined ? false : t3;
    const [resizing, setResizing] = (0, $42omo.useState)(false);
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>setResizing(false);
        $[0] = t4;
    } else t4 = $[0];
    const onFinishMotion = t4;
    let t5;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            dimension: "width",
            duration: "var(--ds-duration-medium, 200ms)",
            easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
            onFinishMotion: onFinishMotion
        };
        $[1] = t5;
    } else t5 = $[1];
    const resizingWidth = (0, $19w2x.useResizing)(t5);
    const isInitialRender = (0, $42omo.useRef)(true);
    const isInteractive = typeof onClick === "function";
    let colorStyleKey;
    let interactiveStyleKey;
    let maxWidthIsPc;
    let maxWidthValue;
    let resolvedColor;
    let resolvedTrailingMetricAppearance;
    let t6;
    if ($[2] !== appearance || $[3] !== maxWidth || $[4] !== trailingMetricAppearance) {
        resolvedColor = (0, $i52dL.resolveLozengeColor)(appearance) || "neutral";
        const { category: category, key: key } = (0, $kLDYa.getThemeStyles)(resolvedColor);
        colorStyleKey = `${category}.${key}`;
        interactiveStyleKey = `interactive.${category}.${key}`;
        maxWidthValue = typeof maxWidth === "string" ? maxWidth : `${maxWidth}px`;
        maxWidthIsPc = typeof maxWidth === "string" && maxWidth.endsWith("%");
        resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === "inverse" ? "inverse" : (0, $i52dL.resolveLozengeColor)(trailingMetricAppearance) : resolvedColor;
        bb0: {
            if (resolvedTrailingMetricAppearance === "inverse") {
                t6 = "inverse";
                break bb0;
            }
            if (resolvedTrailingMetricAppearance == null) {
                t6 = "neutral";
                break bb0;
            }
            if (resolvedTrailingMetricAppearance.startsWith("accent-")) {
                t6 = "neutral";
                break bb0;
            }
            switch(resolvedTrailingMetricAppearance){
                case "success":
                    t6 = "successBold";
                    break bb0;
                case "warning":
                    t6 = "warningBold";
                    break bb0;
                case "danger":
                    t6 = "dangerBold";
                    break bb0;
                case "information":
                    t6 = "informationBold";
                    break bb0;
                case "discovery":
                    t6 = "discoveryBold";
                    break bb0;
                case "neutral":
                default:
                    t6 = "neutral";
            }
        }
        $[2] = appearance;
        $[3] = maxWidth;
        $[4] = trailingMetricAppearance;
        $[5] = colorStyleKey;
        $[6] = interactiveStyleKey;
        $[7] = maxWidthIsPc;
        $[8] = maxWidthValue;
        $[9] = resolvedColor;
        $[10] = resolvedTrailingMetricAppearance;
        $[11] = t6;
    } else {
        colorStyleKey = $[5];
        interactiveStyleKey = $[6];
        maxWidthIsPc = $[7];
        maxWidthValue = $[8];
        resolvedColor = $[9];
        resolvedTrailingMetricAppearance = $[10];
        t6 = $[11];
    }
    const metricBadgeAppearance = t6;
    const t7 = style?.backgroundColor;
    const t8 = maxWidthIsPc ? maxWidth : `min(${maxWidthValue}, 100%)`;
    let t9;
    if ($[12] !== t7 || $[13] !== t8) {
        t9 = {
            backgroundColor: t7,
            maxWidth: t8
        };
        $[12] = t7;
        $[13] = t8;
        $[14] = t9;
    } else t9 = $[14];
    const commonStyleOverrides = t9;
    const hasTrailingMetric = trailingMetric != null && trailingMetric !== "";
    const childrenKey = typeof children === "string" ? children : undefined;
    let t10;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = ()=>{
            if (isInitialRender.current) {
                isInitialRender.current = false;
                return;
            }
            setResizing(true);
        };
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== childrenKey) {
        t11 = [
            childrenKey
        ];
        $[16] = childrenKey;
        $[17] = t11;
    } else t11 = $[17];
    (0, $42omo.useLayoutEffect)(t10, t11);
    const enableMotionFG = (0, $dh538.fg)("platform-dst-motion-uplift");
    const t12 = enableMotionFG ? resizingWidth : undefined;
    const t13 = spacing === "spacious" && $b79a7ce738636669$var$styles.contentSpacious;
    const t14 = isLoading && $b79a7ce738636669$var$styles.loadingContent;
    let t15;
    if ($[18] !== t13 || $[19] !== t14) {
        t15 = (0, $gMc0m.default)([
            $b79a7ce738636669$var$styles.content,
            t13,
            t14,
            $b79a7ce738636669$var$styles.maxWidth
        ]);
        $[18] = t13;
        $[19] = t14;
        $[20] = t15;
    } else t15 = $[20];
    let t16;
    if ($[21] !== iconBefore || $[22] !== resolvedColor || $[23] !== spacing || $[24] !== testId) {
        t16 = iconBefore && /*#__PURE__*/ $42omo.createElement((0, $gJRGK.default), {
            size: spacing === "spacious" ? "medium" : "small",
            icon: iconBefore,
            color: resolvedColor,
            testId: testId && `${testId}--icon`
        });
        $[21] = iconBefore;
        $[22] = resolvedColor;
        $[23] = spacing;
        $[24] = testId;
        $[25] = t16;
    } else t16 = $[25];
    const t17 = maxWidthIsPc ? "100%" : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`;
    const t18 = style?.color;
    let t19;
    if ($[26] !== t17 || $[27] !== t18) {
        t19 = {
            maxWidth: t17,
            color: t18
        };
        $[26] = t17;
        $[27] = t18;
        $[28] = t19;
    } else t19 = $[28];
    const t20 = testId && `${testId}--text`;
    const t21 = enableMotionFG && resizing && !maxWidth ? $b79a7ce738636669$var$styles.textClip : $b79a7ce738636669$var$styles.textEllipsis;
    const t22 = spacing === "spacious" && $b79a7ce738636669$var$styles.textSpacious;
    let t23;
    if ($[29] !== t21 || $[30] !== t22) {
        t23 = (0, $gMc0m.default)([
            $b79a7ce738636669$var$styles.text,
            t21,
            t22
        ]);
        $[29] = t21;
        $[30] = t22;
        $[31] = t23;
    } else t23 = $[31];
    let t24;
    if ($[32] !== children || $[33] !== t19 || $[34] !== t20 || $[35] !== t23) {
        t24 = /*#__PURE__*/ $42omo.createElement("span", {
            style: t19,
            "data-testid": t20,
            className: t23
        }, children);
        $[32] = children;
        $[33] = t19;
        $[34] = t20;
        $[35] = t23;
        $[36] = t24;
    } else t24 = $[36];
    let t25;
    if ($[37] !== hasTrailingMetric || $[38] !== metricBadgeAppearance || $[39] !== resolvedColor || $[40] !== testId || $[41] !== trailingMetric) {
        t25 = hasTrailingMetric && !resolvedColor.startsWith("accent-") && /*#__PURE__*/ $42omo.createElement("span", {
            "data-lozenge-metric-wrapper": true,
            "data-testid": testId && `${testId}--metric`,
            className: (0, $gMc0m.default)([
                $b79a7ce738636669$var$styles.metricBadgeWrapper
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, $8Cy4Y.default), {
            appearance: metricBadgeAppearance
        }, trailingMetric));
        $[37] = hasTrailingMetric;
        $[38] = metricBadgeAppearance;
        $[39] = resolvedColor;
        $[40] = testId;
        $[41] = trailingMetric;
        $[42] = t25;
    } else t25 = $[42];
    let t26;
    if ($[43] !== isInteractive || $[44] !== testId) {
        t26 = isInteractive && /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            size: "small",
            color: "currentColor",
            testId: testId && `${testId}--chevron`
        });
        $[43] = isInteractive;
        $[44] = testId;
        $[45] = t26;
    } else t26 = $[45];
    let t27;
    if ($[46] !== t12 || $[47] !== t15 || $[48] !== t16 || $[49] !== t24 || $[50] !== t25 || $[51] !== t26) {
        t27 = /*#__PURE__*/ $42omo.createElement("span", {
            ...t12,
            className: t15
        }, t16, t24, t25, t26);
        $[46] = t12;
        $[47] = t15;
        $[48] = t16;
        $[49] = t24;
        $[50] = t25;
        $[51] = t26;
        $[52] = t27;
    } else t27 = $[52];
    const innerContent = t27;
    if (isInteractive) {
        const t28 = ref;
        let t29;
        if ($[53] !== colorStyleKey || $[54] !== hasTrailingMetric || $[55] !== interactiveStyleKey || $[56] !== isLoading || $[57] !== isSelected || $[58] !== resolvedTrailingMetricAppearance || $[59] !== spacing) {
            t29 = (0, $1Whri.cx)($b79a7ce738636669$var$styles.container, (0, $dh538.fg)("platform-dst-motion-uplift") && $b79a7ce738636669$var$styles.motionContainer, spacing === "spacious" && $b79a7ce738636669$var$styles.containerSpacious, !isSelected && $b79a7ce738636669$var$styles.iconBorderFilter, $b79a7ce738636669$var$styles[colorStyleKey], !isLoading && $b79a7ce738636669$var$styles[interactiveStyleKey], hasTrailingMetric && $b79a7ce738636669$var$styles.containerBadgePressed, hasTrailingMetric && resolvedTrailingMetricAppearance === "neutral" && $b79a7ce738636669$var$styles.containerBadgeNeutralAppearance);
            $[53] = colorStyleKey;
            $[54] = hasTrailingMetric;
            $[55] = interactiveStyleKey;
            $[56] = isLoading;
            $[57] = isSelected;
            $[58] = resolvedTrailingMetricAppearance;
            $[59] = spacing;
            $[60] = t29;
        } else t29 = $[60];
        let t30;
        if ($[61] !== isLoading) {
            t30 = isLoading && {
                "aria-busy": true,
                "aria-disabled": true,
                isDisabled: true
            };
            $[61] = isLoading;
            $[62] = t30;
        } else t30 = $[62];
        const t31 = isLoading ? "Loading" : ariaLabel;
        const t32 = isLoading ? undefined : onClick;
        const t33 = `solid ${"var(--ds-border-width, 1px)"} ${isSelected ? "var(--border-color) !important" : "transparent"}`;
        const t34 = isSelected ? $b79a7ce738636669$var$pressedBackgroundMapping[resolvedColor] : undefined;
        const t35 = isLoading ? "progress" : "pointer";
        let t36;
        if ($[63] !== commonStyleOverrides || $[64] !== t33 || $[65] !== t34 || $[66] !== t35) {
            t36 = {
                ...commonStyleOverrides,
                border: t33,
                backgroundColor: t34,
                cursor: t35
            };
            $[63] = commonStyleOverrides;
            $[64] = t33;
            $[65] = t34;
            $[66] = t35;
            $[67] = t36;
        } else t36 = $[67];
        let t37;
        if ($[68] !== isSelected) {
            t37 = isSelected && {
                "data-selected": "true"
            };
            $[68] = isSelected;
            $[69] = t37;
        } else t37 = $[69];
        let t38;
        if ($[70] !== isLoading || $[71] !== spacing || $[72] !== testId) {
            t38 = isLoading && /*#__PURE__*/ $42omo.createElement("span", {
                className: (0, $gMc0m.default)([
                    $b79a7ce738636669$var$styles.loadingOverlay
                ])
            }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
                size: spacing === "spacious" ? "small" : "xsmall",
                label: ", Loading",
                testId: testId ? `${testId}--loading-spinner` : undefined
            }));
            $[70] = isLoading;
            $[71] = spacing;
            $[72] = testId;
            $[73] = t38;
        } else t38 = $[73];
        let t39;
        if ($[74] !== analyticsContext || $[75] !== ariaControls || $[76] !== ariaExpanded || $[77] !== ariaHaspopup || $[78] !== innerContent || $[79] !== interactionName || $[80] !== t28 || $[81] !== t29 || $[82] !== t30 || $[83] !== t31 || $[84] !== t32 || $[85] !== t36 || $[86] !== t37 || $[87] !== t38 || $[88] !== testId) {
            t39 = /*#__PURE__*/ $42omo.createElement((0, $2W0qg.default), {
                ref: t28,
                xcss: t29,
                ...t30,
                "aria-label": t31,
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHaspopup,
                onClick: t32,
                style: t36,
                testId: testId,
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                componentName: "LozengeDropdownTrigger",
                ...t37
            }, innerContent, t38);
            $[74] = analyticsContext;
            $[75] = ariaControls;
            $[76] = ariaExpanded;
            $[77] = ariaHaspopup;
            $[78] = innerContent;
            $[79] = interactionName;
            $[80] = t28;
            $[81] = t29;
            $[82] = t30;
            $[83] = t31;
            $[84] = t32;
            $[85] = t36;
            $[86] = t37;
            $[87] = t38;
            $[88] = testId;
            $[89] = t39;
        } else t39 = $[89];
        return t39;
    }
    const t28 = spacing === "spacious" && $b79a7ce738636669$var$styles.containerSpacious;
    const t29 = spacing !== "spacious" && hasTrailingMetric && $b79a7ce738636669$var$styles.containerBadgePadding;
    const t30 = $b79a7ce738636669$var$styles[colorStyleKey];
    const t31 = hasTrailingMetric && resolvedTrailingMetricAppearance === "neutral" && $b79a7ce738636669$var$styles.containerBadgeNeutralAppearance;
    let t32;
    if ($[90] !== t28 || $[91] !== t29 || $[92] !== t30 || $[93] !== t31) {
        t32 = (0, $gMc0m.default)([
            $b79a7ce738636669$var$styles.container,
            t28,
            t29,
            t30,
            $b79a7ce738636669$var$styles.iconBorderFilter,
            t31
        ]);
        $[90] = t28;
        $[91] = t29;
        $[92] = t30;
        $[93] = t31;
        $[94] = t32;
    } else t32 = $[94];
    let t33;
    if ($[95] !== commonStyleOverrides || $[96] !== innerContent || $[97] !== ref || $[98] !== t32 || $[99] !== testId) {
        t33 = /*#__PURE__*/ $42omo.createElement("span", {
            ref: ref,
            style: commonStyleOverrides,
            "data-testid": testId,
            className: t32
        }, innerContent);
        $[95] = commonStyleOverrides;
        $[96] = innerContent;
        $[97] = ref;
        $[98] = t32;
        $[99] = testId;
        $[100] = t33;
    } else t33 = $[100];
    return t33;
} : ({ children: children, testId: testId, appearance: appearance, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance, maxWidth: maxWidth = 200, spacing: spacing = 'default', isSelected: isSelected, isLoading: // for dropdown trigger
isLoading = false, onClick: // for dropdown trigger
onClick, style: // for dropdown trigger
style, analyticsContext: analyticsContext, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-label': ariaLabel }, ref)=>{
    const [resizing, setResizing] = (0, $42omo.useState)(false);
    const onFinishMotion = ()=>setResizing(false);
    const resizingWidth = (0, $19w2x.useResizing)({
        dimension: 'width',
        duration: "var(--ds-duration-medium, 200ms)",
        easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
        onFinishMotion: onFinishMotion
    });
    const isInitialRender = (0, $42omo.useRef)(true);
    const isInteractive = typeof onClick === 'function'; // Determine the effective color, with fallback logic for legacy appearances
    const resolvedColor = (0, $i52dL.resolveLozengeColor)(appearance) || 'neutral';
    const { category: category, key: key } = (0, $kLDYa.getThemeStyles)(resolvedColor);
    const colorStyleKey = `${category}.${key}`;
    const interactiveStyleKey = `interactive.${category}.${key}`;
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && maxWidth.endsWith('%');
    const resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, $i52dL.resolveLozengeColor)(trailingMetricAppearance) : resolvedColor; // Map the resolved trailing metric appearance to a Badge appearance.
    // Semantic colors map to their new bold variants (e.g. successBold),
    // which provide sufficient color emphasis on top of the subtler
    // lozenge background. Accent colors and unknown values fall back to
    // the neutral appearance.
    const metricBadgeAppearance = (()=>{
        if (resolvedTrailingMetricAppearance === 'inverse') return 'inverse';
        if (resolvedTrailingMetricAppearance == null) return 'neutral';
        if (resolvedTrailingMetricAppearance.startsWith('accent-')) return 'neutral';
        switch(resolvedTrailingMetricAppearance){
            case 'success':
                return 'successBold';
            case 'warning':
                return 'warningBold';
            case 'danger':
                return 'dangerBold';
            case 'information':
                return 'informationBold';
            case 'discovery':
                return 'discoveryBold';
            case 'neutral':
            default:
                return 'neutral';
        }
    })();
    const commonStyleOverrides = {
        backgroundColor: style?.backgroundColor,
        // Constrain the container to the smaller of the explicit maxWidth and 100% of
        // the parent. Using min(...) means the lozenge never overflows its parent,
        // while still honouring the explicit maxWidth prop when the parent is wider.
        maxWidth: maxWidthIsPc ? maxWidth : `min(${maxWidthValue}, 100%)`
    };
    const hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    const childrenKey = typeof children === 'string' ? children : undefined;
    (0, $42omo.useLayoutEffect)(()=>{
        // Ignore initial render
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        setResizing(true);
    }, [
        childrenKey
    ]);
    const enableMotionFG = (0, $dh538.fg)('platform-dst-motion-uplift');
    const innerContent = /*#__PURE__*/ $42omo.createElement("span", {
        ...enableMotionFG ? resizingWidth : undefined,
        className: (0, $gMc0m.default)([
            $b79a7ce738636669$var$styles.content,
            spacing === 'spacious' && $b79a7ce738636669$var$styles.contentSpacious,
            isLoading && $b79a7ce738636669$var$styles.loadingContent,
            // Constrain the content wrapper to its container so text truncation
            // works correctly within the flex layout, regardless of whether maxWidth
            // is a percentage, fixed value, or the parent container is narrower than
            // the explicit maxWidth.
            $b79a7ce738636669$var$styles.maxWidth
        ])
    }, iconBefore && /*#__PURE__*/ $42omo.createElement((0, $gJRGK.default), {
        size: spacing === 'spacious' ? 'medium' : 'small',
        icon: iconBefore,
        color: resolvedColor,
        testId: testId && `${testId}--icon`
    }), /*#__PURE__*/ $42omo.createElement("span", {
        style: {
            // The text fills 100% of the inner content wrapper. The container's
            // own max-width (set on the container via commonStyleOverrides) handles
            // the actual size constraint, so the text just needs to fill the available
            // space and truncate when it overflows.
            maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`,
            color: style?.color
        },
        "data-testid": testId && `${testId}--text`,
        className: (0, $gMc0m.default)([
            $b79a7ce738636669$var$styles.text,
            enableMotionFG && resizing && !maxWidth ? $b79a7ce738636669$var$styles.textClip : $b79a7ce738636669$var$styles.textEllipsis,
            spacing === 'spacious' && $b79a7ce738636669$var$styles.textSpacious
        ])
    }, children), hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ $42omo.createElement("span", {
        "data-lozenge-metric-wrapper": true,
        "data-testid": testId && `${testId}--metric`,
        className: (0, $gMc0m.default)([
            $b79a7ce738636669$var$styles.metricBadgeWrapper
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $8Cy4Y.default), {
        appearance: metricBadgeAppearance
    }, trailingMetric)), isInteractive && /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && `${testId}--chevron`
    }));
    if (isInteractive) return /*#__PURE__*/ $42omo.createElement((0, $2W0qg.default), {
        ref: ref,
        xcss: (0, $1Whri.cx)($b79a7ce738636669$var$styles.container, (0, $dh538.fg)('platform-dst-motion-uplift') && $b79a7ce738636669$var$styles.motionContainer, spacing === 'spacious' && $b79a7ce738636669$var$styles.containerSpacious, !isSelected && $b79a7ce738636669$var$styles.iconBorderFilter, $b79a7ce738636669$var$styles[colorStyleKey], !isLoading && $b79a7ce738636669$var$styles[interactiveStyleKey], hasTrailingMetric && $b79a7ce738636669$var$styles.containerBadgePressed, hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $b79a7ce738636669$var$styles.containerBadgeNeutralAppearance),
        ...isLoading && {
            'aria-busy': true,
            'aria-disabled': true,
            isDisabled: true
        },
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...commonStyleOverrides,
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: `solid ${"var(--ds-border-width, 1px)"} ${isSelected ? 'var(--border-color) !important' : 'transparent'}`,
            backgroundColor: isSelected ? $b79a7ce738636669$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        },
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger",
        ...isSelected && {
            'data-selected': 'true'
        }
    }, innerContent, isLoading && /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            $b79a7ce738636669$var$styles.loadingOverlay
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
        size: spacing === 'spacious' ? 'small' : 'xsmall',
        label: ", Loading",
        testId: testId ? `${testId}--loading-spinner` : undefined
    })));
    return /*#__PURE__*/ $42omo.createElement("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $b79a7ce738636669$var$styles.container,
            spacing === 'spacious' && $b79a7ce738636669$var$styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && $b79a7ce738636669$var$styles.containerBadgePadding,
            $b79a7ce738636669$var$styles[colorStyleKey],
            $b79a7ce738636669$var$styles.iconBorderFilter,
            hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $b79a7ce738636669$var$styles.containerBadgeNeutralAppearance
        ])
    }, innerContent);
}));
var $b79a7ce738636669$export$2e2bcd8739ae039 = $b79a7ce738636669$var$LozengeBase;
module.exports["default"] = $b79a7ce738636669$export$2e2bcd8739ae039;

});

parcelRegister("8Cy4Y", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $iXCQx = parcelRequire("iXCQx");


var $cOrQJ = parcelRequire("cOrQJ");


var $jW7WB = parcelRequire("jW7WB");

// Nested selectors with data attributes are required for theme switching
const $62caa3bc42101006$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo",
    informationBold: "_syaz1qd9 _bfhk9pm7",
    successBold: "_syaz1p1e _bfhk16ib",
    dangerBold: "_syaz1blx _bfhkud63",
    warningBold: "_syazmgs1 _bfhk1kmu",
    warningBoldDark: "_syazmgs1 _bfhkgj02",
    discoveryBold: "_syaz1g72 _bfhk5ly7"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ const $62caa3bc42101006$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    return typeof children === 'number' && max ? (0, $jW7WB.formatValue)(children, max) : children;
}; /**
    * __BadgeNew__
    *
    * New visual refresh implementation of Badge component for the labelling system.
    * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
    *
    * Uses new appearance naming convention:
    * - success (green)
    * - danger (red)
    * - neutral (gray)
    * - information (blue)
    * - inverse (inverted colors)
    * - warning (orange/yellow)
    * - discovery (purple)
    * - informationBold (bold blue, color.background.information.subtle)
    * - successBold (bold green, color.background.success.subtle)
    * - dangerBold (bold red, color.background.danger.subtle)
    * - warningBold (bold warning, color.background.warning.bold)
    * - discoveryBold (bold purple, color.background.discovery.subtle)
    */ 
const $62caa3bc42101006$var$BadgeNew = /*#__PURE__*/ (0, $42omo.memo)((0, $4pOgL.isReactCompilerActivePlatform)() ? function BadgeNew(t0) {
    const $ = (0, $frIzR.c)(15);
    const { appearance: t1, children: t2, max: t3, style: style, testId: testId } = t0;
    const appearance = t1 === undefined ? "neutral" : t1;
    const children = t2 === undefined ? 0 : t2;
    const max = t3 === undefined ? 99 : t3;
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const resolvedAppearance = appearance === "warningBold" && colorMode === "dark" ? "warningBoldDark" : appearance;
    const t4 = style?.backgroundColor;
    const t5 = style?.color;
    let t6;
    if ($[0] !== t4 || $[1] !== t5) {
        t6 = {
            background: t4,
            color: t5
        };
        $[0] = t4;
        $[1] = t5;
        $[2] = t6;
    } else t6 = $[2];
    const t7 = $62caa3bc42101006$var$stylesNew[resolvedAppearance];
    let t8;
    if ($[3] !== t7) {
        t8 = (0, $gMc0m.default)([
            $62caa3bc42101006$var$stylesNew.root,
            t7
        ]);
        $[3] = t7;
        $[4] = t8;
    } else t8 = $[4];
    let t9;
    if ($[5] !== children || $[6] !== max) {
        t9 = $62caa3bc42101006$var$badgeValueWithNegativeNumberSupported(children, max);
        $[5] = children;
        $[6] = max;
        $[7] = t9;
    } else t9 = $[7];
    let t10;
    if ($[8] !== t9) {
        t10 = /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
            size: "small",
            align: "center",
            color: "inherit"
        }, t9);
        $[8] = t9;
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== t10 || $[11] !== t6 || $[12] !== t8 || $[13] !== testId) {
        t11 = /*#__PURE__*/ $42omo.createElement("span", {
            "data-testid": testId,
            style: t6,
            className: t8
        }, t10);
        $[10] = t10;
        $[11] = t6;
        $[12] = t8;
        $[13] = testId;
        $[14] = t11;
    } else t11 = $[14];
    return t11;
} : function BadgeNew({ appearance: appearance = 'neutral', children: children = 0, max: max = 99, style: style, testId: testId }) {
    const { colorMode: colorMode } = (0, $cOrQJ.default)(); // In dark theme, warningBold needs to swap to a lighter background
    // (color.background.warning.subtle / Orange800) for better contrast against
    // the typical dark surface colors.
    const resolvedAppearance = appearance === 'warningBold' && colorMode === 'dark' ? 'warningBoldDark' : appearance;
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": testId,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $gMc0m.default)([
            $62caa3bc42101006$var$stylesNew.root,
            $62caa3bc42101006$var$stylesNew[resolvedAppearance]
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $62caa3bc42101006$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $62caa3bc42101006$export$2e2bcd8739ae039 = $62caa3bc42101006$var$BadgeNew;
module.exports["default"] = $62caa3bc42101006$export$2e2bcd8739ae039;

});

parcelRegister("gmCNH", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $c0f887a73e3562c3$export$ce4b6a469c26f53f = (0, $4pOgL.isReactCompilerActivePlatform)() ? function LinkWrapper(t0) {
    const $ = (0, $frIzR.c)(13);
    const { isLink: isLink, href: href, LinkComponent: LinkComponent, testId: testId, children: children, onClick: onClick, linkHandlers: linkHandlers } = t0;
    if (isLink && href) {
        const t1 = testId ? `${testId}--link` : undefined;
        const t2 = linkHandlers?.onMouseEnter;
        const t3 = linkHandlers?.onMouseLeave;
        const t4 = linkHandlers?.onMouseDown;
        const t5 = linkHandlers?.onFocus;
        const t6 = linkHandlers?.onBlur;
        let t7;
        if ($[0] !== LinkComponent || $[1] !== children || $[2] !== href || $[3] !== onClick || $[4] !== t1 || $[5] !== t2 || $[6] !== t3 || $[7] !== t4 || $[8] !== t5 || $[9] !== t6) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LinkComponent, {
                href: href,
                testId: t1,
                onClick: onClick,
                onMouseEnter: t2,
                onMouseLeave: t3,
                onMouseDown: t4,
                onFocus: t5,
                onBlur: t6
            }, children);
            $[0] = LinkComponent;
            $[1] = children;
            $[2] = href;
            $[3] = onClick;
            $[4] = t1;
            $[5] = t2;
            $[6] = t3;
            $[7] = t4;
            $[8] = t5;
            $[9] = t6;
            $[10] = t7;
        } else t7 = $[10];
        return t7;
    }
    let t1;
    if ($[11] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
        $[11] = children;
        $[12] = t1;
    } else t1 = $[12];
    return t1;
} : function LinkWrapper({ isLink: isLink, href: href, LinkComponent: LinkComponent, testId: testId, children: children, onClick: onClick, linkHandlers: linkHandlers }) {
    if (isLink && href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LinkComponent, {
        href: href,
        testId: testId ? `${testId}--link` : undefined,
        onClick: onClick,
        onMouseEnter: linkHandlers?.onMouseEnter,
        onMouseLeave: linkHandlers?.onMouseLeave,
        onMouseDown: linkHandlers?.onMouseDown,
        onFocus: linkHandlers?.onFocus,
        onBlur: linkHandlers?.onBlur
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
};
module.exports["LinkWrapper"] = $c0f887a73e3562c3$export$ce4b6a469c26f53f;

});

parcelRegister("bSHvo", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $g9Srd = parcelRequire("g9Srd");

var $8DMug = parcelRequire("8DMug");


var $6AEnm = parcelRequire("6AEnm");

const $6def21747ee8efde$var$removableShrinkOutChildKey = 'atlaskit-tag-removable-shrink-out';
const $6def21747ee8efde$var$motionWrapperStyles = null; // Props for the removable wrapper
const $6def21747ee8efde$export$898a500849bb5cf4 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function RemovableWrapper(t0) {
    const $ = (0, $frIzR.c)(6);
    const { isRemovable: isRemovable, status: status, onShrinkOutExitComplete: onShrinkOutExitComplete, children: children } = t0;
    if (isRemovable) {
        let t1;
        if ($[0] !== children || $[1] !== onShrinkOutExitComplete || $[2] !== status) {
            t1 = !(status === (0, $6AEnm.TagStatus).Removed) && /*#__PURE__*/ $42omo.createElement((0, $8DMug.default), {
                key: $6def21747ee8efde$var$removableShrinkOutChildKey,
                onFinish: onShrinkOutExitComplete ? (phase)=>{
                    if (phase === "exiting") onShrinkOutExitComplete();
                } : undefined
            }, (motion)=>/*#__PURE__*/ $42omo.createElement("span", {
                    ref: motion.ref,
                    className: (0, $gMc0m.default)([
                        "_1e0c116y"
                    ])
                }, children));
            $[0] = children;
            $[1] = onShrinkOutExitComplete;
            $[2] = status;
            $[3] = t1;
        } else t1 = $[3];
        let t2;
        if ($[4] !== t1) {
            t2 = /*#__PURE__*/ $42omo.createElement((0, $g9Srd.default), null, t1);
            $[4] = t1;
            $[5] = t2;
        } else t2 = $[5];
        return t2;
    }
    return children;
} : function RemovableWrapper({ isRemovable: isRemovable, status: status, onShrinkOutExitComplete: onShrinkOutExitComplete, children: children }) {
    if (isRemovable) return /*#__PURE__*/ $42omo.createElement((0, $g9Srd.default), null, !(status === (0, $6AEnm.TagStatus).Removed) && /*#__PURE__*/ $42omo.createElement((0, $8DMug.default), {
        key: $6def21747ee8efde$var$removableShrinkOutChildKey,
        onFinish: onShrinkOutExitComplete ? (phase)=>{
            if (phase === 'exiting') onShrinkOutExitComplete();
        } : undefined
    }, (motion)=>/*#__PURE__*/ $42omo.createElement("span", {
            ref: motion.ref,
            className: (0, $gMc0m.default)([
                "_1e0c116y"
            ])
        }, children)));
    return children;
};
module.exports["RemovableWrapper"] = $6def21747ee8efde$export$898a500849bb5cf4;

});

parcelRegister("l7uKY", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $32a8b98357c26faf$export$84acd183858d8235 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useButtonInteraction() {
    const $ = (0, $frIzR.c)(7);
    const [isLinkHovered, setIsLinkHovered] = (0, $42omo.useState)(false);
    const [isOverButton, setIsOverButton] = (0, $42omo.useState)(false);
    const [isButtonFocused, setIsButtonFocused] = (0, $42omo.useState)(false);
    const [isLinkFocused, setIsLinkFocused] = (0, $42omo.useState)(false);
    const hadMouseDownRef = (0, $42omo.useRef)(false);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            onMouseEnter: ()=>setIsOverButton(true),
            onMouseLeave: ()=>setIsOverButton(false),
            onMouseDown: (e)=>{
                e?.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsButtonFocused(false)
        };
        $[0] = t0;
    } else t0 = $[0];
    const buttonHandlers = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            onMouseEnter: ()=>setIsLinkHovered(true),
            onMouseLeave: ()=>setIsLinkHovered(false),
            onMouseDown: ()=>{
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsLinkFocused(false)
        };
        $[1] = t1;
    } else t1 = $[1];
    const linkHandlers = t1;
    let t2;
    if ($[2] !== isButtonFocused || $[3] !== isLinkFocused || $[4] !== isLinkHovered || $[5] !== isOverButton) {
        t2 = {
            isLinkHovered: isLinkHovered,
            isOverButton: isOverButton,
            isButtonFocused: isButtonFocused,
            isLinkFocused: isLinkFocused,
            buttonHandlers: buttonHandlers,
            linkHandlers: linkHandlers
        };
        $[2] = isButtonFocused;
        $[3] = isLinkFocused;
        $[4] = isLinkHovered;
        $[5] = isOverButton;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : function useButtonInteraction() {
    const [isLinkHovered, setIsLinkHovered] = (0, $42omo.useState)(false);
    const [isOverButton, setIsOverButton] = (0, $42omo.useState)(false);
    const [isButtonFocused, setIsButtonFocused] = (0, $42omo.useState)(false);
    const [isLinkFocused, setIsLinkFocused] = (0, $42omo.useState)(false);
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    const hadMouseDownRef = (0, $42omo.useRef)(false);
    // Button handlers
    const buttonHandlers = (0, $42omo.useMemo)(()=>({
            onMouseEnter: ()=>setIsOverButton(true),
            onMouseLeave: ()=>setIsOverButton(false),
            onMouseDown: (e)=>{
                // Prevent the browser from moving focus to the remove button on mousedown.
                // Without this, parent composite widgets (e.g. Select) lose input focus when
                // the user clicks remove, triggering unwanted blur side-effects.
                e?.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsButtonFocused(false)
        }), []);
    // Link handlers - includes hover tracking
    const linkHandlers = (0, $42omo.useMemo)(()=>({
            onMouseEnter: ()=>setIsLinkHovered(true),
            onMouseLeave: ()=>setIsLinkHovered(false),
            onMouseDown: ()=>{
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsLinkFocused(false)
        }), []);
    return {
        isLinkHovered: isLinkHovered,
        isOverButton: isOverButton,
        isButtonFocused: isButtonFocused,
        isLinkFocused: isLinkFocused,
        buttonHandlers: buttonHandlers,
        linkHandlers: linkHandlers
    };
};
module.exports["useButtonInteraction"] = $32a8b98357c26faf$export$84acd183858d8235;

});

parcelRegister("dfX8r", function(module, exports) {

var $2Nwuj = parcelRequire("2Nwuj");

function $b0745751f99760f8$export$dcf14c9974fe2767(href, linkComponent) {
    const isLink = Boolean(href);
    const LinkComponent = linkComponent ?? (0, $2Nwuj.default);
    return {
        isLink: isLink,
        LinkComponent: LinkComponent
    };
}
module.exports["useLink"] = $b0745751f99760f8$export$dcf14c9974fe2767;

});

parcelRegister("dFVg2", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jCd35 = parcelRequire("jCd35");

const $d9da8b09021b4016$export$97d8be09cd53869b = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useRemoveButton(t0) {
    const $ = (0, $frIzR.c)(17);
    const { isRemovable: isRemovable, tagText: tagText, removeButtonLabel: removeButtonLabel, testId: testId, handleRemoveRequest: handleRemoveRequest, removingTag: removingTag, showingTag: showingTag, onKeyPress: onKeyPress, shape: t1, buttonHandlers: buttonHandlers } = t0;
    const shape = t1 === undefined ? "default" : t1;
    let t2;
    if ($[0] !== buttonHandlers || $[1] !== removingTag) {
        t2 = ()=>{
            removingTag();
            buttonHandlers?.onFocus();
        };
        $[0] = buttonHandlers;
        $[1] = removingTag;
        $[2] = t2;
    } else t2 = $[2];
    const handleFocus = t2;
    let t3;
    if ($[3] !== buttonHandlers || $[4] !== showingTag) {
        t3 = ()=>{
            showingTag();
            buttonHandlers?.onBlur();
        };
        $[3] = buttonHandlers;
        $[4] = showingTag;
        $[5] = t3;
    } else t3 = $[5];
    const handleBlur = t3;
    let t4;
    bb0: {
        if (!isRemovable) {
            t4 = undefined;
            break bb0;
        }
        const t5 = `${removeButtonLabel || "Remove"} ${tagText}`;
        const t6 = buttonHandlers?.onMouseEnter;
        const t7 = buttonHandlers?.onMouseLeave;
        const t8 = buttonHandlers?.onMouseDown;
        const t9 = testId ? `close-button-${testId}` : undefined;
        let t10;
        if ($[6] !== handleBlur || $[7] !== handleFocus || $[8] !== handleRemoveRequest || $[9] !== onKeyPress || $[10] !== shape || $[11] !== t5 || $[12] !== t6 || $[13] !== t7 || $[14] !== t8 || $[15] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jCd35.default), {
                "aria-label": t5,
                onClick: handleRemoveRequest,
                onFocus: handleFocus,
                onBlur: handleBlur,
                onKeyPress: onKeyPress,
                onMouseEnter: t6,
                onMouseLeave: t7,
                onMouseDown: t8,
                testId: t9,
                shape: shape
            });
            $[6] = handleBlur;
            $[7] = handleFocus;
            $[8] = handleRemoveRequest;
            $[9] = onKeyPress;
            $[10] = shape;
            $[11] = t5;
            $[12] = t6;
            $[13] = t7;
            $[14] = t8;
            $[15] = t9;
            $[16] = t10;
        } else t10 = $[16];
        t4 = t10;
    }
    return t4;
} : function useRemoveButton({ isRemovable: isRemovable, tagText: tagText, removeButtonLabel: removeButtonLabel, testId: testId, handleRemoveRequest: handleRemoveRequest, removingTag: removingTag, showingTag: showingTag, onKeyPress: onKeyPress, shape: shape = 'default', buttonHandlers: buttonHandlers }) {
    const handleFocus = (0, $42omo.useCallback)(()=>{
        removingTag();
        buttonHandlers?.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    const handleBlur = (0, $42omo.useCallback)(()=>{
        showingTag();
        buttonHandlers?.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, $42omo.useMemo)(()=>{
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jCd35.default), {
            "aria-label": `${removeButtonLabel || 'Remove'} ${tagText}`,
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers?.onMouseEnter,
            onMouseLeave: buttonHandlers?.onMouseLeave,
            onMouseDown: buttonHandlers?.onMouseDown,
            testId: testId ? `close-button-${testId}` : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
};
module.exports["useRemoveButton"] = $d9da8b09021b4016$export$97d8be09cd53869b;

});

parcelRegister("aaMcY", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7AFqy = parcelRequire("7AFqy");


var $6AEnm = parcelRequire("6AEnm");

const $f3e92dc0b5e15e76$export$f26019543e9f862f = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useTagRemoval(onBeforeRemoveAction) {
    const $ = (0, $frIzR.c)(10);
    const [status, setStatus] = (0, $42omo.useState)((0, $6AEnm.TagStatus).Showing);
    let t0;
    if ($[0] !== onBeforeRemoveAction) {
        t0 = ()=>{
            const beforeAction = onBeforeRemoveAction ?? (0, $7AFqy.defaultBeforeRemoveAction);
            if (beforeAction()) setStatus((0, $6AEnm.TagStatus).Removed);
        };
        $[0] = onBeforeRemoveAction;
        $[1] = t0;
    } else t0 = $[1];
    const handleRemoveRequest = t0;
    let t1;
    if ($[2] !== handleRemoveRequest) {
        t1 = (e)=>{
            const spacebarOrEnter = e.key === " " || e.key === "Enter";
            if (spacebarOrEnter) {
                e.stopPropagation();
                handleRemoveRequest();
            }
        };
        $[2] = handleRemoveRequest;
        $[3] = t1;
    } else t1 = $[3];
    const onKeyPress = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setStatus((0, $6AEnm.TagStatus).Removing);
        $[4] = t2;
    } else t2 = $[4];
    const removingTag = t2;
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setStatus((0, $6AEnm.TagStatus).Showing);
        $[5] = t3;
    } else t3 = $[5];
    const showingTag = t3;
    let t4;
    if ($[6] !== handleRemoveRequest || $[7] !== onKeyPress || $[8] !== status) {
        t4 = {
            status: status,
            handleRemoveRequest: handleRemoveRequest,
            onKeyPress: onKeyPress,
            removingTag: removingTag,
            showingTag: showingTag
        };
        $[6] = handleRemoveRequest;
        $[7] = onKeyPress;
        $[8] = status;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : function useTagRemoval(onBeforeRemoveAction) {
    const [status, setStatus] = (0, $42omo.useState)((0, $6AEnm.TagStatus).Showing);
    const handleRemoveRequest = (0, $42omo.useCallback)(()=>{
        const beforeAction = onBeforeRemoveAction ?? (0, $7AFqy.defaultBeforeRemoveAction);
        if (beforeAction()) // Defer onAfterRemoveAction until ShrinkOut's onFinish so ExitingPersistence can run
        // the exit animation (e.g. in multi-select and user pickers).
        setStatus((0, $6AEnm.TagStatus).Removed);
    }, [
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $42omo.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $42omo.useCallback)(()=>setStatus((0, $6AEnm.TagStatus).Removing), []);
    const showingTag = (0, $42omo.useCallback)(()=>setStatus((0, $6AEnm.TagStatus).Showing), []);
    return {
        status: status,
        handleRemoveRequest: handleRemoveRequest,
        onKeyPress: onKeyPress,
        removingTag: removingTag,
        showingTag: showingTag
    };
};
module.exports["useTagRemoval"] = $f3e92dc0b5e15e76$export$f26019543e9f862f;

});

parcelRegister("58wk0", function(module, exports) {
// Intentionally scoped to the UI-uplifted TagNew implementation.
const $0f49b70bb0cd25cd$export$7d100de1166870f6 = (text)=>Array.isArray(text) ? text.join('') : text;
module.exports["getTagText"] = $0f49b70bb0cd25cd$export$7d100de1166870f6;

});

parcelRegister("kT1PP", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $c0878b35a63b435e$var$tagSwatchBeforeStyles = {
    swatch: "_2rkolb4i _1bsboqnp _4t3ioqnp _1o9zidpf"
};
const $c0878b35a63b435e$var$tagSwatchBeforeColorStyles = {
    gray: "_bfhk18j9",
    blue: "_bfhk115i",
    green: "_bfhk1rsu",
    red: "_bfhkkrt9",
    yellow: "_bfhk8y3s",
    purple: "_bfhk18ah",
    lime: "_bfhkbq5w",
    magenta: "_bfhk1mi6",
    orange: "_bfhk1kkj",
    teal: "_bfhktdv8"
};
const $c0878b35a63b435e$var$SwatchBefore = (0, $4pOgL.isReactCompilerActivePlatform)() ? function SwatchBefore(t0) {
    const $ = (0, $frIzR.c)(10);
    const { colorKey: colorKey, swatchBefore: swatchBefore } = t0;
    if (swatchBefore === undefined || swatchBefore === false) return null;
    if (swatchBefore === true) {
        const t1 = $c0878b35a63b435e$var$tagSwatchBeforeColorStyles[colorKey];
        let t2;
        if ($[0] !== t1) {
            t2 = (0, $gMc0m.default)([
                $c0878b35a63b435e$var$tagSwatchBeforeStyles.swatch,
                t1
            ]);
            $[0] = t1;
            $[1] = t2;
        } else t2 = $[1];
        let t3;
        if ($[2] !== t2) {
            t3 = /*#__PURE__*/ $42omo.createElement("span", {
                className: t2
            });
            $[2] = t2;
            $[3] = t3;
        } else t3 = $[3];
        return t3;
    }
    let t1;
    if ($[4] !== swatchBefore) {
        t1 = {
            backgroundColor: swatchBefore
        };
        $[4] = swatchBefore;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gMc0m.default)([
            $c0878b35a63b435e$var$tagSwatchBeforeStyles.swatch
        ]);
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ $42omo.createElement("span", {
            style: t1,
            className: t2
        });
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : function SwatchBefore({ colorKey: colorKey, swatchBefore: swatchBefore }) {
    if (swatchBefore === undefined || swatchBefore === false) return null;
    if (swatchBefore === true) return /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            $c0878b35a63b435e$var$tagSwatchBeforeStyles.swatch,
            $c0878b35a63b435e$var$tagSwatchBeforeColorStyles[colorKey]
        ])
    });
    return /*#__PURE__*/ $42omo.createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: {
            backgroundColor: swatchBefore
        },
        className: (0, $gMc0m.default)([
            $c0878b35a63b435e$var$tagSwatchBeforeStyles.swatch
        ])
    });
};
var $c0878b35a63b435e$export$2e2bcd8739ae039 = $c0878b35a63b435e$var$SwatchBefore;
module.exports["default"] = $c0878b35a63b435e$export$2e2bcd8739ae039;

});

parcelRegister("kLDYa", function(module, exports) {
const $39964b4d0d070831$export$a3fc04b8551e006a = (resolvedColor)=>{
    const isAccent = resolvedColor.startsWith('accent-');
    const category = isAccent ? 'accent' : 'semantic';
    const key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};
module.exports["getThemeStyles"] = $39964b4d0d070831$export$a3fc04b8551e006a;

});

parcelRegister("gJRGK", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

// Map lozenge colors to appropriate icon colors.
//
// We intentionally use `color.text.*.bolder` tokens for icons across all
// colored lozenges (semantic + accent). Text tokens use higher-stop palette
// values (Color700+) which pass 3:1 contrast against subtler backgrounds in
// every interactive state — including pressed where icon Color600 fails for
// most hues. Using text tokens uniformly:
//   - avoids global changes to the `color.icon.*` token ramps
//   - keeps icon and text visually aligned in the lozenge
//   - guarantees ≥3:1 contrast across default/hover/pressed states
//
// Neutral lozenges use `color.text.subtle` to match the neutral text styling
// and remain consistent with their alpha-based backgrounds.
const $398b25942ffd103f$var$getIconColor = (color)=>{
    switch(color){
        // Semantic
        case 'success':
            return "var(--ds-text-success, #4C6B1F)";
        case 'warning':
            return "var(--ds-text-warning, #9E4C00)";
        case 'danger':
            return "var(--ds-text-danger, #AE2E24)";
        case 'information':
            return "var(--ds-text-information, #1558BC)";
        case 'discovery':
            return "var(--ds-text-discovery, #803FA5)";
        case 'neutral':
            return "var(--ds-text-subtle, #505258)";
        // Accent
        case 'accent-red':
            return "var(--ds-text-accent-red, #AE2E24)";
        case 'accent-orange':
            return "var(--ds-text-accent-orange, #9E4C00)";
        case 'accent-yellow':
            return "var(--ds-text-accent-yellow, #7F5F01)";
        case 'accent-lime':
            return "var(--ds-text-accent-lime, #4C6B1F)";
        case 'accent-green':
            return "var(--ds-text-accent-green, #216E4E)";
        case 'accent-teal':
            return "var(--ds-text-accent-teal, #206A83)";
        case 'accent-blue':
            return "var(--ds-text-accent-blue, #1558BC)";
        case 'accent-purple':
            return "var(--ds-text-accent-purple, #803FA5)";
        case 'accent-magenta':
            return "var(--ds-text-accent-magenta, #943D73)";
        case 'accent-gray':
            return "var(--ds-text-subtle, #505258)";
        default:
            return "var(--ds-text-subtle, #505258)";
    }
};
const $398b25942ffd103f$var$styles = {
    motion: "_k8m01ylx _1oeci9qs _6fl41d08"
}; /**
    * Icon renderer for lozenge components
    * Handles proper sizing and color theming for icons
    */ 
const $398b25942ffd103f$var$IconRenderer = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { icon: Icon, color: color, testId: testId, size: size } = t0;
    let t1;
    if ($[0] !== color) {
        t1 = $398b25942ffd103f$var$getIconColor(color);
        $[0] = color;
        $[1] = t1;
    } else t1 = $[1];
    const iconColor = t1;
    let t2;
    if ($[2] !== Icon || $[3] !== iconColor || $[4] !== size || $[5] !== testId) {
        t2 = (0, $dh538.fg)("platform-dst-motion-uplift") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $398b25942ffd103f$var$styles.motion,
            style: {
                color: iconColor
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: "",
            size: size,
            testId: testId
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            color: iconColor,
            label: "",
            size: size,
            testId: testId
        });
        $[2] = Icon;
        $[3] = iconColor;
        $[4] = size;
        $[5] = testId;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ icon: Icon, color: color, testId: testId, size: size })=>{
    const iconColor = $398b25942ffd103f$var$getIconColor(color);
    return (0, $dh538.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $398b25942ffd103f$var$styles.motion,
        style: {
            color: iconColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: "",
        size: size,
        testId: testId
    })) : // Cast required because the lozenge intentionally uses some
    // `color.text.*.bolder` tokens for icons that don't pass 3:1 contrast
    // at their default `color.icon.*` stop. The Icon component types only
    // accept `IconColor`, but text tokens are valid CSS color values and
    // render correctly at runtime.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$398b25942ffd103f$export$2e2bcd8739ae039 = $398b25942ffd103f$var$IconRenderer;
module.exports["default"] = $398b25942ffd103f$export$2e2bcd8739ae039;

});

parcelRegister("i52dL", function(module, exports) {

// Map legacy appearance to new color values
const $99bcbfdffa078f04$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
const $99bcbfdffa078f04$export$acf5d2b7dc999bda = (appearance = 'neutral')=>{
    if (appearance.startsWith('accent-')) return appearance;
    return $99bcbfdffa078f04$var$legacyAppearanceMap[appearance] ?? appearance;
};
module.exports["resolveLozengeColor"] = $99bcbfdffa078f04$export$acf5d2b7dc999bda;

});

parcelRegister("jW7WB", function(module, exports) {
function $6a9376684c160785$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $6a9376684c160785$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $6a9376684c160785$var$getSafeValue(value);
    const safeMax = $6a9376684c160785$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}
module.exports["formatValue"] = $6a9376684c160785$export$7c4d25c0c3217d8c;

});

parcelRegister("6AEnm", function(module, exports) {
// Tag status enum
var $1f014880aeb1cfbd$export$74452314b63acabc = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});
module.exports["TagStatus"] = $1f014880aeb1cfbd$export$74452314b63acabc;

});

parcelRegister("jCd35", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $hmuev = parcelRequire("hmuev");


var $dh538 = parcelRequire("dh538");


var $fVUfS = parcelRequire("fVUfS");

const $ee677bd76e709ca8$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i1j6v _1bsb1j6v _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah3idpf _irr31dpa _1di6fcek",
    circle: "_2rko1rr0 _1ah3idpf",
    focusRing: "_1ah3v77o",
    newIcon: "_rjxpv77o"
};
const $ee677bd76e709ca8$var$RemoveButton = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { "aria-label": ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, testId: testId, shape: t1 } = t0;
    const shape = t1 === undefined ? "default" : t1;
    const t2 = shape === "circle" && $ee677bd76e709ca8$var$removeButtonStyles.circle;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $1Whri.cx)($ee677bd76e709ca8$var$removeButtonStyles.root, t2, $ee677bd76e709ca8$var$removeButtonStyles.newIcon, (0, $dh538.fg)("platform-dst-lozenge-tag-badge-visual-uplifts") && $ee677bd76e709ca8$var$removeButtonStyles.focusRing);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            color: "currentColor",
            label: "",
            size: "small"
        });
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== ariaLabel || $[4] !== onBlur || $[5] !== onClick || $[6] !== onFocus || $[7] !== onKeyPress || $[8] !== onMouseDown || $[9] !== onMouseEnter || $[10] !== onMouseLeave || $[11] !== onMouseOut || $[12] !== onMouseOver || $[13] !== onMouseUp || $[14] !== t3 || $[15] !== testId) {
        t5 = /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
            xcss: t3,
            "aria-label": ariaLabel,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            onKeyPress: onKeyPress,
            onMouseOver: onMouseOver,
            onMouseOut: onMouseOut,
            onMouseDown: onMouseDown,
            onMouseUp: onMouseUp,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            testId: testId
        }, t4);
        $[3] = ariaLabel;
        $[4] = onBlur;
        $[5] = onClick;
        $[6] = onFocus;
        $[7] = onKeyPress;
        $[8] = onMouseDown;
        $[9] = onMouseEnter;
        $[10] = onMouseLeave;
        $[11] = onMouseOut;
        $[12] = onMouseOver;
        $[13] = onMouseUp;
        $[14] = t3;
        $[15] = testId;
        $[16] = t5;
    } else t5 = $[16];
    return t5;
} : ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, testId: testId, shape: shape = 'default' })=>{
    return /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)($ee677bd76e709ca8$var$removeButtonStyles.root, shape === 'circle' && $ee677bd76e709ca8$var$removeButtonStyles.circle, $ee677bd76e709ca8$var$removeButtonStyles.newIcon, (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && $ee677bd76e709ca8$var$removeButtonStyles.focusRing),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
        color: "currentColor",
        label: "",
        size: "small"
    }));
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $ee677bd76e709ca8$export$2e2bcd8739ae039 = $ee677bd76e709ca8$var$RemoveButton;
module.exports["default"] = $ee677bd76e709ca8$export$2e2bcd8739ae039;

});

parcelRegister("7AFqy", function(module, exports) {
const $c905f924e6233d8a$export$279e7025ed114474 = ()=>true;
module.exports["defaultBeforeRemoveAction"] = $c905f924e6233d8a$export$279e7025ed114474;

});


$parcel$global.rlb("Wowvf")
//# sourceMappingURL=vendors~editor_atlaskit_sm.647788d6.js.map
